// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../Assets/Img/FANTASY MAGIST.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../Assets/Img/brandLabel.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../Assets/Img/Brand Page Banner.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL(".././Img/FANTASY MAGIST.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL(".././Img/Bannermain.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../Img/ContactusBanner.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL(".././Img/homebanner2.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../Img/Gilroy-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../Img/Hero Section Influencer.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

.Title {
    font-size: 32px;
    font-weight: 500;
    color: #6B8E76;
    padding: 0 0 30px 0;
    margin-right: 59%;
}

.MainContainerPadding {
    padding: 0 50px;
}

.custom-footer .footer-links {
    margin-left: -10%;
}

.custom-footer .footer-legal {
    margin-left: 50%;
    margin-top: -210px;
}

header a.nav-link {
    font-size: 20px;
    color: #6B8E76;
    font-weight: 400;
    padding: 12px 20px !important;
}

header .LoginBtn {
    background-color: #6B8E76;
    border-radius: 10px;
    color: #fff !important;
    padding: 0px 20px !important;
    line-height: 24px;
    font-size: 20px !important;
    height: 48px;
    width: 120px;
    text-align: center;
}

.custom-footer {
    background-color: #6f8d77;
    color: #ffffff;
    font-family: "Public Sans", sans-serif;
    padding: 40px 0;
}

.custom-footer .footer-about,
.custom-footer .footer-links,
.custom-footer .footer-legal {
    font-family: Poppins, "sans-serif";
}

.custom-footer .footer-links {
    margin-left: -10%;
}

.custom-footer .footer-legal {
    margin-left: 50%;
    margin-top: -210px;
}

h5.links.mb-3 {
    font-size: 17px;
}

.custom-footer .footer-about p.description,
.custom-footer .footer-links p.description,
.custom-footer .footer-legal p.description {
    width: 100%;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    color: rgba(255, 255, 255, 1);
    margin-top: 3%;
}

.custom-footer .footer-about .contact-info,
.custom-footer .footer-links .contact-info,
.custom-footer .footer-legal .contact-info {
    display: flex;
    flex-direction: column;
    margin-top: 3%;
}

.custom-footer .footer-about .contact-info .contact-box-call,
.custom-footer .footer-links .contact-info .contact-box-call,
.custom-footer .footer-legal .contact-info .contact-box-call {
    background-color: rgba(255, 255, 255, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.3);
    border-radius: 8px;
    padding: 15px;
    max-width: fit-content;
    color: rgba(255, 255, 255, 1) !important;
    font-size: 14px;
    line-height: 1.6;
    display: flex;
    align-items: center;
    font-family: "Public Sans", sans-serif;
    height: 36px;
    background-color: rgba(121, 155, 132, 1);
}

.custom-footer .footer-about .contact-info .contact-box-call:hover,
.custom-footer .footer-links .contact-info .contact-box-call:hover,
.custom-footer .footer-legal .contact-info .contact-box-call:hover {
    color: #fff;
    background-color: rgba(255, 255, 255, 0.2);
}

.custom-footer .footer-about .contact-info .contact-box-mail,
.custom-footer .footer-links .contact-info .contact-box-mail,
.custom-footer .footer-legal .contact-info .contact-box-mail {
    background-color: rgba(255, 255, 255, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.3);
    border-radius: 8px;
    padding: 15px;
    max-width: max-content;
    color: rgba(255, 255, 255, 1) !important;
    font-size: 14px;
    line-height: 1.6;
    display: flex;
    align-items: center;
    font-family: "Public Sans", sans-serif;
    height: 36px;
    background-color: rgba(121, 155, 132, 1);
    text-decoration: none;
}

.custom-footer .footer-about .contact-info .contact-box-mail:hover,
.custom-footer .footer-links .contact-info .contact-box-mail:hover,
.custom-footer .footer-legal .contact-info .contact-box-mail:hover {
    color: #fff;
    background-color: rgba(255, 255, 255, 0.2);
}

.custom-footer .footer-links ul li a,
.custom-footer .footer-legal ul li a {
    font-size: 14px;
    line-height: 1.8;
    position: relative;
    display: inline-block;
    padding-left: 10px;
    text-decoration: none;
    overflow: hidden;
    white-space: nowrap;
    color: #ffffff;
    transition: all 0.3s ease;
    width: -webkit-fill-available;
    margin-left: -10px;
}

.custom-footer .footer-bottom {
    padding-top: 20px;
}

.custom-footer .footer-bottom p {
    font-size: 12px;
    margin: 0;
}

.SMN_effect-31 a {
    position: relative;
    overflow: hidden;
    display: block;
    text-align: center;
    flex-grow: 1;
    animation-duration: 1s;
    animation-fill-mode: both;
    padding: 0;
    width: fit-content;
}

ul.menu.align-center.expanded.text-center.SMN_effect-31 {
    list-style: none;
}

.SMN_effect-31 a span {
    display: block;
    transition: transform 500ms cubic-bezier(0.68, -0.55, 0.265, 1.55);
}

.SMN_effect-31 a:after {
    content: "";
    height: 2px;
    color: #ffffff;
    font-size: 14px;
    height: 2px;
    position: absolute;
    top: 0;
    left: 100%;
    right: 0;
    bottom: 0;
    text-align: center;
    transition: left 500ms cubic-bezier(0.68, -0.55, 0.265, 1.55);
    width: fit-content;
}

.SMN_effect-31 a:hover {
    color: #ffffff;
}

.SMN_effect-31 a:hover span {
    color: #ffffff !important;
    transform: translateX(100%);
    animation: hover-list 15s ease-in-out forwards;
}

@keyframes hover-list {
    0% {
        opacity: 0;
    }

    50% {
        opacity: 0.9;
    }

    100% {
        opacity: 0;
    }
}

.SMN_effect-31 a:hover:after {
    content: "• " attr(data-hover);
    left: 20%;
    top: 0;
    transition: all 0.3s ease-in-out;
}

.SMN_effect-31 a:active {
    animation-name: rubberBand;
}


.Why {}

.Why .WhyImg {
    border-radius: 10px;
}

.Why .WhyImg img {
    width: 100%;
    border-radius: 14px;
}












@media (max-width: 1200px) {
    .col-xl-4 {
        flex: 0 0 auto;
        width: 40%;
    }

    .custom-footer .footer-about p.description,
    .custom-footer .footer-links p.description,
    .custom-footer .footer-legal p.description {
        font-size: 14px;
        color: rgb(255, 255, 255);
    }
}

@media (max-width: 480px) {

    .custom-footer .footer-about p.description,
    .custom-footer .footer-links p.description,
    .custom-footer .footer-legal p.description {
        font-size: 15px;
        text-align: center;
    }

    .footer-logo {
        margin: auto;
    }

    .col-xl-4.col-xs-12.col-md-3.col-sm-6.footer-links {
        text-align: center;
        margin-bottom: 2%;
    }

    .col-xl-4.col-xs-12.col-md-3.col-sm-6.mb-4.footer-legal {
        text-align: center;
        margin-top: 5%;
    }
}

@media (max-width: 576px) {
    .col-xl-4.col-xs-12.col-md-3.col-sm-6.mb-4.footer-about {
        width: 100%;
    }

    .custom-footer .footer-about p.description,
    .custom-footer .footer-links p.description,
    .custom-footer .footer-legal p.description {
        font-size: 17px;
        text-align: justify;
        color: rgb(255, 255, 255);
    }

    .col-sm-6 {
        flex: 0 0 auto;
        width: 100%;
    }

    .row {
        text-align: center;
    }

    .custom-footer .footer-about .contact-info,
    .custom-footer .footer-links .contact-info,
    .custom-footer .footer-legal .contact-info {
        justify-content: center;
        margin-top: 10%;
    }
}

@media (max-width: 768px) {

    .custom-footer .footer-about .contact-info,
    .custom-footer .footer-links .contact-info,
    .custom-footer .footer-legal .contact-info {
        justify-content: center;
    }

    .col-xl-4.col-xs-12.col-md-12.col-sm-12.all-links {
        display: flex;
        justify-content: space-around;
    }

    .contact-info {
        display: flex;
        justify-content: center;
    }

    .custom-footer .footer-about p.description,
    .custom-footer .footer-links p.description,
    .custom-footer .footer-legal p.description {
        font-size: 18px;
        line-height: 26px;
        color: rgb(255, 255, 255);
    }
}

@media (max-width: 992px) {
    .contact-info {
        justify-content: center;
    }

    .custom-footer .footer-about p.description,
    .custom-footer .footer-links p.description,
    .custom-footer .footer-legal p.description {
        font-size: 19px;
        line-height: 23px;
        color: rgb(255, 255, 255);
    }

    .col-xl-4.col-xs-12.col-md-6.col-sm-12.all-links {
        width: 100%;
        display: flex;
        justify-content: center;
        margin: auto;
    }

    .row {
        display: flex;
        justify-content: space-between;
    }
}

@media (max-width: 1024px) {

    .custom-footer .footer-about .contact-info,
    .custom-footer .footer-links .contact-info,
    .custom-footer .footer-legal .contact-info {
        flex-wrap: wrap;
        gap: 15px;
    }

    .col-xl-4.col-xs-12.col-md-6.col-sm-12.all-links {
        width: 100%;
        margin: auto;
    }
}

.align-items-start {
    align-items: flex-start !important;
    width: 100%;
}

.justify-content-between {
    justify-content: space-between !important;
}

.row {
    --bs-gutter-x: 1.5rem;
    --bs-gutter-y: 0;
    display: flex;
    flex-wrap: wrap;
}

@media (max-width: 1440px) {

    .custom-footer .footer-about p.description,
    .custom-footer .footer-links p.description,
    .custom-footer .footer-legal p.description {
        font-size: 17px;
        line-height: 26px;
        text-align: left;
        color: rgb(255, 255, 255);
    }

    .custom-footer .footer-about .contact-info,
    .custom-footer .footer-links .contact-info,
    .custom-footer .footer-legal .contact-info {
        flex-wrap: wrap;
        margin-top: 2%;
        gap: 15px;
    }
}



/* privacy policy */
nav.navbar.navbar-expand-lg.navbar-light {
    background: #6f8d77 !important;
    color: #fff !important;
    box-shadow: none !important;
}


.main-policy {
    color: rgba(103, 103, 103, 1);
    ;
}

.row-nav-profile .nav-link {
    height: fit-content;
    color: #fff !important;
    padding: 5px !important;
    border-radius: 4px;
}

.row-nav-profile .nav-link:hover {
    color: #6f8d77 !important;
    background-color: #fff !important;
    border-radius: 4px;
}

.policy-container {
    background-color: white;
    padding: 40px 20px;
    font-family: "Poppins", sans-serif;
}

.policy-container .privacy-policy-content {
    padding: 30px;
}

.policy-container .privacy-policy-content .head-title {
    width: 100%;
}

p.info-title {
    font-weight: 500;
}

span.child-titles {
    font-family: "Poppins", sans-serif;
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    color: rgb(107, 142, 118);
}

span.Cookies-child-titles {
    font-family: "Poppins", sans-serif;
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    color: rgb(107, 142, 118);
}

span.Your-rights-child-titles {
    font-family: "Poppins", sans-serif;
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    color: rgb(107, 142, 118);
}

.policy-container .privacy-policy-content .policy-heading {
    text-align: justify !important;
    font-family: "Poppins", sans-serif;
    font-size: 24px;
    font-weight: 500;
    line-height: 36px;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    color: rgba(107, 142, 118, 1);
    margin-bottom: 0.5%;
}

.policy-container .privacy-policy-content .policy-content {
    margin-bottom: 2%;
}

.policy-container .privacy-policy-content .policy-content p {
    text-align: justify !important;
    font-family: "Poppins", sans-serif;
    font-size: 20px;
    font-weight: 400;
    line-height: 28px;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    color: rgba(103, 103, 103, 1);
}

.policy-container .privacy-policy-content .policy-content p .iso-title {
    color: rgba(107, 142, 118, 1);
    font-weight: 600;
    font-size: 20px;
}

.policy-container .about-heading {
    text-align: justify !important;
    font-family: "Poppins", sans-serif;
    font-size: 22px;
    font-weight: 500;
    line-height: 33px;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    color: rgba(107, 142, 118, 1);
}

.policy-container .about-content {
    text-align: justify !important;
    font-family: "Poppins", sans-serif;
    font-size: 16px;
    font-weight: 400;
    line-height: 28px;
    letter-spacing: -0.0015em;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    color: rgba(103, 103, 103, 1);
    margin-top: 1%;
}

.policy-container .about-content .about-iso,
.policy-container .about-content .address,
.policy-container .about-content .website-link {
    font-family: "Poppins", sans-serif;
    font-size: 16px;
    font-weight: 600;
    line-height: 28px;
    letter-spacing: -0.0015em;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
}

.policy-container .about-content .website-link {
    text-decoration-line: underline;
    text-decoration-style: solid;
    color: rgba(0, 122, 255, 1);
    cursor: pointer;
}

.child-Data-Sharing-heading {
    line-height: 30px;
    margin-bottom: 15px;

}

p.cookie-title {
    font-weight: 500;
}

.cookie-head-title {
    margin-bottom: 17px;
    margin-top: 17px;
}

.Cookies-content {
    line-height: 29px;
}

.Data-Retention-titles {
    margin-top: 10px;
    margin-bottom: 10px;
}

.Data-Retentionchild-content {
    margin-bottom: 10px;
}

.Your-rights-heading {
    margin-bottom: 20px;
}

.policy-container .Information-heading,
.policy-container .Data-Collection-heading,
.policy-container .Data-Sharing-heading,
.policy-container .Cookies-heading,
.policy-container .Data-Retentionchild-titles,
.policy-container .Your-rights-titles,
.policy-container .Security-titles,
.policy-container .Updates-titles,
.policy-container .Contact-titles {
    font-family: "Poppins", sans-serif;
    font-size: 22px;
    font-weight: 500;
    line-height: 33px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    color: rgba(107, 142, 118, 1);
    margin-top: 1%;
    margin-bottom: 1%;
}

.policy-container .Information-content,
.policy-container .Data-Collection-content,
.policy-container .Data-Sharing-content,
.policy-container .Updates-content,
.policy-container .Contact-content,
.policy-container .Your-rights-content {
    font-family: "Poppins", sans-serif;
    font-size: 16px;
    font-weight: 400;
    line-height: 30px;
    letter-spacing: -0.0015em;
    text-align: justify;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    color: rgba(103, 103, 103, 1);
    margin-top: 1%;
    margin-bottom: 1%;
}

.policy-container .Information-content .information-point,
.policy-container .Data-Sharing-content .child-Data-Sharing-heading,
.policy-container .Data-Sharing-content .child-Data-Sharing-heading .child-titles,
.policy-container .Cookies-content .Cookies-point,
.policy-container .Your-rights-content .Your-rights-child-titles {
    font-family: "Poppins", sans-serif;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    color: rgba(103, 103, 103, 1);
    margin-top: 1%;
}

.contacts {
    color: rgba(103, 103, 103, 1) !important;
    ;
}

.policy-container .Cookies-content .google-text,
.policy-container .Cookies-content .note,
.policy-container .contacts {
    font-family: "Poppins", sans-serif;
    font-size: 16px;
    font-weight: 600;
    line-height: 28px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    color: rgba(107, 142, 118, 1);
}


/* brand pagee */
@font-face {
    font-family: "FantasyMagist";
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("opentype");
}

.brand-container .brand-hero-section {
    background: rgba(0, 0, 0, 0.5) url(${___CSS_LOADER_URL_REPLACEMENT_1___}) center center;

    background-size: cover;
    height: 400px;
}

.brand-container .brand-hero-section .text-center {
    margin-top: 21%;
}

.brand-container .brand-hero-section .text-center .hero-title {
    font-family: "FantasyMagist", "Arial", sans-serif;
    color: rgba(245, 242, 231, 1);
    font-weight: 400;
}

.brand-container .brand-hero-section .brand-hero-title {
    margin-top: 5%;
    font-size: 24px;
    border-bottom: 2px solid black;
}

.brand-container .slider .slider-overlay-text {
    width: fit-content;
    position: absolute;
    top: 0;
    padding: 28px;
    text-align: left;
    font-size: 26px;
    color: #fff;
}

.brand-container .slider .slider-overlay-text h2 {
    font-size: 3rem;
    margin-top: 3rem;
    transition: all 0.3s ease;
    width: 23rem;
}

.brand-container .why-marketing .brand-section-title {
    width: 100%;
    font-family: "Poppins", sans-serif;
    font-size: 32px;
    font-weight: 600;
    line-height: 48px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    color: rgba(107, 142, 118, 1);
}

.brand-container .why-marketing .card {
    border: none;
}

.brand-container .why-marketing .card .image-container {
    position: relative;
    overflow: hidden;
    border-radius: 6px;
}

/* Ensure the slider container spans full width */
.fresh-slides {
    width: 100%;
    /* Ensure the slider spans the full width of the container */
    position: relative;
}

/* Hide arrows and dots */
.fresh-slides .slick-arrow,
.fresh-slides .slick-dots {
    display: none;
}

/* Container for images */
.image-container {
    position: relative;
    /* Position for overlay text */
    width: 100%;
    /* Make sure the image container spans the full width of the slider */
}

/* Image styling */
.fresh-slides img {
    width: 102%;
    margin-left: -10px;
    /* Ensure the image takes the full width */
    height: 400px;
    /* Set fixed height */
    object-fit: cover;
    /* Ensure images cover the space without distortion */
}

/* Overlay text styling */
.slider-text {
    position: absolute;
    top: 20px;
    /* Position from the top */
    left: 20px;
    /* Position from the left */
    color: white;
    /* White text color */
    font-size: 24px;
    /* Text size */
    font-weight: bold;
    /* Make text bold */
    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
    /* Optional: adds shadow to make text more readable */
}

.key-trend {
    color: rgba(245, 242, 231, 1);
    font-family: "Poppins", sans-serif;
    font-weight: 500;
    font-size: 20px;
}


.why-marketing .card .card-img-top {
    width: 100%;
    object-fit: cover;
    transition: filter 0.3s ease-in-out;
    height: 289px;
    filter: grayscale(100%);
}

.why-marketing .card .overlay-text {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    color: #fff;
    padding: 10px;
    text-align: center;
    transition: all 1s ease;
    opacity: 1;
    overflow: hidden;
}

.why-marketing .card .overlay-text .card-text {
    font-size: 32px;
    font-weight: 600;
    font-family: "Poppins", sans-serif;
}

.why-marketing .card:hover .card-img-top {
    filter: grayscale(0%);
}

.why-marketing .card:hover .overlay-text {
    transform: translateY(100%);
    opacity: 0;
}

.why-marketing .row {
    margin-bottom: 1.5rem;
}

.carousel-item img {
    height: 300px !important;
    object-fit: cover !important;
    border-radius: 8px !important;
}

.hero-title {
    font-size: 2.5rem;
    font-weight: bold;
}

.brand-container hr {
    width: 50px;
    border: 2px solid #fff;
    margin: auto;
}

.heading-Challenges {
    font-family: "Poppins", sans-serif;
    font-size: 32px;
    font-weight: 600;
    line-height: 48px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    color: rgba(107, 142, 118, 1);
    margin-top: -71px;
    margin-left: -70px;
}

.challenges-brand {
    margin-left: 9px;
}

.brand-panel-4 .challenges-brand .title-Challenges {
    font-family: "Poppins", sans-serif;
    font-size: 20px;
    font-weight: 500;
    line-height: 30px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    color: rgba(107, 142, 118, 1);
}

.brand-panel-4 .challenges-brand .description-Challenges {
    font-family: "Poppins", sans-serif;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    color: rgba(103, 103, 103, 1);
}

.about-image {
    font-size: 20px;
    width: 516px;
    font-weight: 400;
    background-color: white;
    padding: 4px;
    border-radius: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: rgb(255, 255, 255) 0px 0px 0px 2px inset,
        rgba(107, 142, 118, 0.8784313725) 15px -15px 0px -3px;
        margin-left: 80px;
}

.brand-panel-4 .about-image img {
    border-radius: 8px;
    width: 100%;
}

.main-content .all-cards .card-one .card {

    padding-top: 70px;
    /* Prevent overlap of text with icon */

    text-align: center;

}

.main-content .all-cards .card-one .card .card-image {

    position: absolute;

    top: -40px;
    /* Move the icon above the card */

    left: 50%;

    transform: translateX(-50%);

    width: 130px;

    height: 124px;

    margin: 0 auto;

}

.main-content .all-cards .card-one .card .card-image img {

    width: 100px;

    height: 100px;

    object-fit: none;
    /* Ensure image fits well */

    background: #6b8e76;

    border-radius: 5rem;

    border: 9px solid #f5f2e7;

}

.main-content .all-cards .card-one .card .card-content {

    margin-left: 0;
    /* Reset margin so text stays centered */

    text-align: center;

}

.main-content .all-cards .card-one .card .card-content .brand-text-container .brand-card-heading {

    font-family: "Poppins", sans-serif;

    font-size: 20px;

    font-weight: 600;

    line-height: 27px;

    /* kanj */

    text-align: center;

    /* kanj */

    text-underline-position: from-font;

    text-decoration-skip-ink: none;

    color: rgba(107, 142, 118, 1);

}

.main-content .all-cards .card-one .card .card-content .brand-text-container .brand-card-description {

    font-family: "Poppins", sans-serif;

    font-size: 15px;

    font-weight: 400;

    line-height: 22px;

    /* kanj */

    text-align: center;

    /* kanj */

    text-underline-position: from-font;

    text-decoration-skip-ink: none;

    color: rgba(103, 103, 103, 1);

}

.about-image1 {

    font-size: 20px;

    width: 516px;

    font-weight: 400;

    background-color: white;

    padding: 4px;

    border-radius: 10px;

    display: flex;

    justify-content: center;

    align-items: center;

    box-shadow: rgb(255, 255, 255) 0px 0px 0px 2px inset,

        rgba(107, 142, 118, 0.8784313725) -15px -15px 0px -3px;

}


.brand-panel-4 .about-image1 img {

    border-radius: 8px;

    width: 100%;

}

.container-about-section .about-image1-wrapper {

    font-size: 20px;

    font-weight: 400;

    background-color: white;

    padding: 10px;

    border-radius: 10px;

    display: flex;

    justify-content: center;

    align-items: center;

    box-shadow: rgb(255, 255, 255) 0px 0px 0px 2px inset, #6b8e76e0 15px -15px 0px -3px;

}

.container-about-section .about-image1-wrapper img {

    border-radius: 8px;

}

.main-content {
    background-color: rgba(245, 242, 231, 1);
}

.main-content .heading-brand-benifit {
    text-align: start;
    color: rgba(107, 142, 118, 1);
    font-family: "Poppins", sans-serif;
    font-size: 32px;
    font-weight: 500;
    line-height: 48px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    margin-bottom: 2%;
}

.heading-brand-benifit .titles-brand {
    font-size: 24px;
    font-weight: 600;
}

.impactful-stats {
    margin: 40px 0;
    font-family: "Poppins", sans-serif;
}

.impactful-stats .title {
    color: rgba(107, 142, 118, 1);
    font-weight: 600;
    font-size: 24px;
    margin-bottom: 20px;
    text-align: left;
}

.impactful-stats .stats-container {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    justify-content: space-between;
    margin-top: 20px;
}

.impactful-stats .stats-container .stat-card {
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: calc(25% - 20px);
    max-width: calc(25% - 20px);
    text-align: start;
    color: rgb(42, 42, 42);
}

.impactful-stats .stats-container .stat-card .stat-title {
    font-family: "Poppins", sans-serif;
    font-size: 48px;
    font-weight: 600;
    line-height: 27px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    color: rgba(107, 142, 118, 1);
}

.impactful-stats .stats-container .stat-card .divider {
    width: 50%;
    margin: 0 0 10px;
    border: 1px solid rgba(103, 103, 103, 1);
    margin-top: 5%
}

.impactful-stats .stats-container .stat-card .stats-description {
    width: 100%;
}

.impactful-stats .stats-container .stat-card .stats-description .stat-description {
    width: 80%;
    font-family: "Poppins", sans-serif;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    color: rgba(103, 103, 103, 1);
}

@media screen and (max-width: 768px) {
    .impactful-stats .stats-container .stat-card {
        flex: 1 1 100%;
        max-width: 100%;
        margin-bottom: 20px;
    }

    .brand-container .brand-hero-section {
        background: rgba(0, 0, 0, 0.5) url(${___CSS_LOADER_URL_REPLACEMENT_2___}) center center;
        background-size: cover;
        height: 400px;
    }
}

@media screen and (max-width: 426px) {
    .brand-container .brand-hero-section .text-center .hero-title {
        font-family: "FantasyMagist", "Arial", sans-serif;
        color: rgba(245, 242, 231, 1);
        font-weight: 400;
        font-size: 32px;
    }
}


.main-content {
    background-color: rgba(245, 242, 231, 1);
}

.main-content .heading-brand-benifit {
    text-align: start;
    color: rgba(107, 142, 118, 1);
    font-family: "Poppins", sans-serif;
    font-size: 32px;
    font-weight: 500;
    line-height: 48px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    margin-bottom: 2%;
}

.main-content .heading-brand-benifit .titles-brand {
    font-size: 32px;
    font-weight: 500;
    margin-left: -8px;
}

.main-content .all-cards .card-one {
    position: relative;
    width: 100%;
    padding: 26px;
    padding-left: 1rem;
}

/* .main-content .all-cards .card-one .card {
    background-color: #fff;
    width: 100%;
    height: 159px;
    padding: 10px;
} */

/* .main-content .all-cards .card-one .card .card-image {
    position: absolute;
    top: 51%;
    left: -55px;
    transform: translateY(-50%);
    width: 130px;
    height: 124px;
    margin: 0;
    bottom: 50%;
} */
/* 
.main-content .all-cards .card-one .card .card-image img {
    width: 119px;
    object-fit: none;
    background: #6b8e76;
    border-radius: 5rem;
    border: 9px solid #f5f2e7;
    height: 119px;
} */
/* 
.main-content .all-cards .card-one .card .card-content {
    margin-left: 100px;
} */

/* .main-content .all-cards .card-one .
 .card-content .brand-text-container .brand-card-heading {
    font-family: "Poppins", sans-serif;
    font-size: 20px;
    font-weight: 600;
    line-height: 27px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    color: rgba(107, 142, 118, 1);
} */

/* .main-content .all-cards .card-one .card .card-content .brand-text-container .brand-card-description {
    font-family: "Poppins", sans-serif;
    font-size: 16px;
    font-weight: 400;
    line-height: 22px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    color: rgba(103, 103, 103, 1);
} */
.main-content .all-cards .card-one .card {
    padding-top: 70px;
    /* Prevent overlap of text with icon */
    text-align: center;
}

.main-content .all-cards .card-one .card .card-image {
    position: absolute;
    top: -40px;
    /* Move the icon above the card */
    left: 50%;
    transform: translateX(-50%);
    width: 130px;
    height: 124px;
    margin: 0 auto;
}

.main-content .all-cards .card-one .card .card-image img {
    width: 100px;
    height: 100px;
    object-fit: none;
    /* Ensure image fits well */
    background: #6b8e76;
    border-radius: 5rem;
    border: 9px solid #f5f2e7;
}

.main-content .all-cards .card-one .card .card-content {
    margin-left: 0;
    /* Reset margin so text stays centered */
    text-align: center;
}

.main-content .all-cards .card-one .card .card-content .brand-text-container .brand-card-heading {
    font-family: "Poppins", sans-serif;
    font-size: 20px;
    font-weight: 600;
    line-height: 27px;
    /* kanj */
    text-align: center;
    /* kanj */
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    color: rgba(107, 142, 118, 1);
}

.main-content .all-cards .card-one .card .card-content .brand-text-container .brand-card-description {

    font-family: "Poppins", sans-serif;
    font-size: 15px;
    font-weight: 400;
    line-height: 22px;
    /* kanj */
    text-align: center;
    /* kanj */
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    color: rgba(103, 103, 103, 1);
    padding: 5px;

}

/* testimonials */


.testimonial-section {
    text-align: center;
    padding: 50px 20px;
}

.testimonial-section .testimonial-heading {
    text-align: start;
    width: 100%;
    font-family: "Poppins", "Public Sans", sans-serif;
    font-size: 32px;
    font-weight: 500;
    line-height: 48px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    color: rgba(107, 142, 118, 1);
    margin-bottom: 20px;
    margin-bottom: 3%;
}

.testimonial-carousel {
    display: flex;
    justify-content: center;
    overflow: hidden;
    width: 100%;
    margin: 0 auto;
    scroll-behavior: smooth;
    flex-wrap: nowrap;
}

.testimonial-card {
    min-width: 300px;
    margin: 0 10px;
    padding: 20px;
    border-radius: 8px;
    background-color: white;
    border: 1px solid rgba(245, 242, 231, 1);
    transition: transform 0.3s ease;
    text-align: center;
}

.testimonial-card-wrapper {
    padding: 10px;
    /* Adds spacing between the cards */
}

.testimonial-card {
    min-width: 300px;
    padding: 20px;
    border-radius: 8px;
    background-color: white;
    border: 1px solid rgba(245, 242, 231, 1);
    text-align: center;
}


.client-image {
    width: 100%;
    height: 100px;
    margin: 0 auto 10px auto;
    /* border-radius: 50%; */
    overflow: hidden;
}

.client-image img {
    margin: auto;
    width: 100%;
    height: 39px;
    object-fit: contain;
}

.testimonial-text {
    text-align: justify;
    width: 100%;
    height: 144px;
    font-family: "Poppins", "Public Sans", sans-serif;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    text-align: center;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    color: rgba(103, 103, 103, 1);
}

.star-rating {
    width: 100%;
    height: 25px;
    display: flex;
    justify-content: center;
    margin-top: 11%;
}

h3 {
    font-size: 1.3em;
    margin: 10px 0 5px 0;
    color: #333;
}

.client-role {
    display: flex;
    justify-content: center;
    width: 100%;
    height: 24px;
    font-family: "Poppins", "Public Sans", sans-serif;
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    color: rgba(107, 142, 118, 1);
}

@media (max-width: 2720px) {
    .testimonial-section .testimonial-heading {
        text-align: start;
        width: 100%;
        font-family: "Poppins", "Public Sans", sans-serif;
        font-size: 24px;
        font-weight: 600;
        line-height: 48px;
        text-align: justify;
        text-underline-position: from-font;
        text-decoration-skip-ink: none;
        color: rgb(107, 142, 118);
        margin-bottom: 20px;
        margin-bottom: 3%;
        padding-left: 4%;
    }
}

@media (max-width: 2560px) {
    .testimonial-section .testimonial-heading {
        text-align: start;
        width: 100%;
        font-family: "Poppins", "Public Sans", sans-serif;
        font-size: 24px;
        font-weight: 600;
        line-height: 48px;
        text-align: justify;
        text-underline-position: from-font;
        text-decoration-skip-ink: none;
        color: rgb(107, 142, 118);
        margin-bottom: 20px;
        margin-bottom: 3%;
        padding-left: 4%;
    }
}

@media (max-width: 1200px) {
    .testimonial-card {
        width: 100%;
        margin: 0 10px;
        border-radius: 8px;
        background-color: white;
        border: 1px solid rgb(245, 242, 231);
        transition: transform 0.3s ease;
        text-align: center;
    }

    .testimonial-text {
        text-align: justify;
        width: 100%;
        height: 144px;
        font-family: "Poppins", "Public Sans", sans-serif;
        font-size: 15px;
        font-weight: 400;
        line-height: 22px;
        text-align: center;
        text-underline-position: from-font;
        text-decoration-skip-ink: none;
        color: rgb(103, 103, 103);
    }

    .star-rating {
        width: 100%;
        height: 25px;
        display: flex;
        justify-content: center;
        margin-top: 3rem;
    }
}

@media (max-width: 1024px) {
    .testimonial-section .testimonial-heading {
        text-align: start;
        width: 100%;
        height: 22px;
        font-family: "Poppins", "Public Sans", sans-serif;
        font-size: 32px;
        font-weight: 500;
        line-height: 48px;
        text-align: left;
        text-underline-position: from-font;
        text-decoration-skip-ink: none;
        color: rgb(107, 142, 118);
        margin-bottom: 20px;
        margin-left: 1%;
        margin-bottom: 3%;
    }
}

@media (max-width: 768px) {
    .testimonial-carousel {
        flex-wrap: wrap;
        justify-content: center;
    }

    .testimonial-card {
        flex: 1 1 90%;
        margin: 10px 0;
    }
}

@media (max-width: 480px) {
    .testimonial-card {
        flex: 1 1 100%;
    }
}

@media (max-width: 768px) {
    .testimonial-text {
        text-align: justify;
        width: 100%;
        height: 144px;
        font-family: "Poppins", "Public Sans", sans-serif;
        font-size: 14px;
        font-weight: 400;
        line-height: 30px;
        text-align: justify;
        text-underline-position: from-font;
        text-decoration-skip-ink: none;
        color: rgb(103, 103, 103);
    }
}

/* AboutPage */

@font-face {
    font-family: "FantasyMagist";
    src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("opentype");
}

.about-hero-section {
    position: relative;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
    background-size: cover;
    background-position: center;
    height: 300px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: white !important;
    text-align: center;
    font-family: "FantasyMagist", "Arial", sans-serif;
    width: 100%;
}

.about-hero-section::before {
    content: "";
    background-color: rgba(101, 145, 115, 0.88);
    width: 100%;
    height: 100%;
    background-repeat: repeat;
    background-position: center;
    background-size: contain;
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0.5;
    z-index: 1;
}

p.About.card-description.text-white.position-absolute.top-50.start-50.translate-middle-x.text-center.belief-description {
    margin-top: -24% !important;
    font-size: 15px;
}

.about-hero-section .overlay-text {
    position: relative;
    z-index: 2;
    margin-top: 9%;
    padding: 20px;
    border-radius: 5px;
    width: 100%;
    max-width: 900px;
    font-family: "FantasyMagist";
}

.about-hero-section .overlay h1 {
    margin: 0;
    font-size: 48px;
    font-weight: 400;
    font-family: "FantasyMagist", "Arial", sans-serif;
    width: 877px;
    top: 340px;
    color: rgba(245, 242, 231, 1);
}

.about-hero-section .overlay .underline {
    width: 600px;
    height: 2px;
    background-color: rgba(245, 242, 231, 1);
    margin: 10px auto 0;
}

.about-hero-section .underline::after {
    content: "";
    display: none;
}

@media (max-width: 576px) {
    .hero-section::before {
        content: "";
        background-color: rgba(107, 142, 118, 0.88);
        width: 100%;
        height: 100%;
        background-repeat: no-repeat;
        background-position: top;
        background-size: contain;
        position: absolute;
        top: 0px;
        left: 0;
        opacity: 0.5;
        z-index: 1;
    }

    .hero-section .overlay h1 {
        margin: 0;
        font-size: 27px;
        font-weight: 400;
        font-family: "FantasyMagist", "Arial", sans-serif;
        width: 553px;
        top: 340px;
        color: rgb(245, 242, 231);
    }

    .col-xl-4.col-xs-12.col-md-3.col-sm-6.d-flex {
        margin-bottom: 5%;
    }

    p.About.card-description.text-white.position-absolute.top-50.start-50.translate-middle-x.text-center.belief-description {
        margin-top: -30% !important;
        font-size: 13px;
        line-height: 2;
    }
}

@media (max-width: 768px) {
    .hero-section::before {
        content: "";
        background-color: rgba(107, 142, 118, 0.88);
        width: 100%;
        height: 100%;
        background-repeat: no-repeat;
        background-position: top;
        background-size: contain;
        position: absolute;
        top: 0;
        left: 0;
        opacity: 0.5;
        z-index: 1;
    }

    .hero-section .overlay h1 {
        margin: 0 !important;
        font-size: 28px !important;
        font-weight: 400 !important;
        font-family: "FantasyMagist", "Arial", sans-serif;
        width: 90% !important;
        max-width: 890px !important;
        top: 200px !important;
        color: rgb(245, 242, 231) !important;
        z-index: 2 !important;
        text-align: center !important;
    }

    .hero-section .overlay .underline {
        width: 600px !important;
        height: 2px !important;
        background-color: rgb(245, 242, 231);
        margin: 10px 40px 0 !important;
    }
}

@media (max-width: 992px) {
    .hero-section .overlay h1 {
        margin: 0;
        font-size: 34px;
        font-weight: 400;
        font-family: "FantasyMagist", "Arial", sans-serif;
        width: 818px;
        top: 340px;
        color: rgb(245, 242, 231);
    }

    .hero-section .overlay .underline {
        width: 600px;
        height: 2px;
        background-color: rgb(245, 242, 231);
        margin: 10px 113px 0;
    }
}

@media (max-width: 480px) {
    .hero-section .overlay h1 {
        margin: 0 !important;
        font-size: 35px !important;
        font-weight: 400 !important;
        font-family: "FantasyMagist", "Arial", sans-serif;
        width: 101% !important;
        max-width: 439px !important;
        top: 200px !important;
        color: rgb(245, 242, 231) !important;
        z-index: 2 !important;
        text-align: center !important;
    }

    .row.d-flex.justify-content-around {
        margin-left: 7%;
    }

    .hero-section .overlay .underline {
        width: 295px !important;
        height: 2px !important;
        background-color: rgb(245, 242, 231);
        margin: 10px 40px 0 !important;
    }

    /* .container-about-section .about-image-wrapper {
        font-size: 20px;
        font-weight: 400;
        background-color: white;
        padding: 10px;
        border-radius: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        box-shadow: rgb(255, 255, 255) 0px 0px 0px 2px inset, #6b8e76e0 15px -15px 0px -3px;
        margin-top: 5%;
        margin-right: 5%;
    } */
}

@media (max-width: 380px) {
    .hero-section .overlay h1 {
        margin: 0;
        font-size: 30px;
        font-weight: 400;
        font-family: "FantasyMagist", "Arial", sans-serif;
        width: 338px;
        top: 340px;
        color: rgb(245, 242, 231);
    }

    .hero-section .overlay .underline {
        display: none;
    }

    .hero-section .overlay {
        position: relative;
        z-index: 2;
        margin-top: 9%;
        padding: 20px;
        border-radius: 5px;
        width: 82%;
        max-width: 900px;
        font-family: "FantasyMagist";
    }

    .row.d-flex.justify-content-around {
        margin-left: 7%;
    }
}

/* Apply Poppins font globally */
body {
    font-family: "Poppins", sans-serif;
}

.container-about-section p.text-justify {
    color: #676767;
    font-family: "Poppins", sans-serif;
    font-weight: 400;
    font-size: 20px;
    line-height: 34px;
}

.container-about-section .about-image-wrapper {
    font-size: 20px;
    font-weight: 400;
    background-color: white;
    padding: 10px;
    border-radius: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: rgb(255, 255, 255) 0px 0px 0px 2px inset, #6b8e76e0 15px -15px 0px -3px;
}

/* .container-about-section .about-image-wrapper img {
    border-radius: 8px;
} */

.container-about-section .text-justify {
    text-align: justify;
}

/* Variables are replaced directly with their values */

/* Base styles */
body {
    font-family: "Arial", sans-serif;
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

/* Section styling */
.why-choose-section {
    padding: 40px 20px;
    background-color: #fff;
    text-align: center;
}

.why-choose-section h2 {
    width: 100%;
    font-family: "Poppins", sans-serif;
    font-size: 32px;
    font-weight: 500;
    line-height: 48px;
    text-align: left;
    color: rgba(107, 142, 118, 1);
    margin-bottom: 2%;
}

.why-choose-section p {
    width: 100%;
    font-family: "Poppins", sans-serif;
    font-size: 24px;
    font-weight: 400;
    line-height: 34px;
    text-align: justify;
    color: rgba(103, 103, 103, 1);
}

/* Responsive adjustments */
@media (max-width: 768px) {
    .why-choose-section h2 {
        font-size: 24px;
    }

    .why-choose-section p {
        font-size: 14px;
    }
}

@media (max-width: 480px) {
    .why-choose-section h2 {
        font-size: 16px;
    }

    .why-choose-section p {
        font-size: 12px;
    }
}

/* Cards */
.card-body {
    position: relative;
    overflow: hidden;
    cursor: pointer;
    background: rgb(107, 142, 118);
}

.card-body .card-img-top {
    object-fit: cover;
    width: 100%;
    margin-left: 7%;
    transition: transform 0.3s ease-in-out;
}

.card-body .card-title-vmg {
    font-family: "Poppins", sans-serif;
    font-size: 24px;
    font-weight: 600;
    line-height: 36px;
    text-align: left;
}

/* Hover Effect for Card Body */
.card-body:hover .card-img-top {
    opacity: 0;
}

.card-body:hover .belief-description {
    opacity: 1;
    visibility: visible;
    color: transparent;
    transform: translate(-50%, 0%) !important;
}

/* Style the text inside the overlay */
.belief-description {
    position: absolute;
    transform: translate(-100%, 0%) !important;
    color: #fff !important;
    opacity: 0;
    transition: all 0.3s ease-in-out;
    text-align: center;
    width: 100%;
    line-height: 45px;
}

.why-choose-section p.about.card-description.text-white.position-absolute.top-50.start-50.translate-middle-x.text-center.belief-description {
    font-size: 17px;
    margin: -29%;
    margin-left: 1%;
}

/* Media Queries */
@media (max-width: 768px) {
    .card-body {
        flex: 1 1 auto;
        color: var(--bs-card-color);
    }

    h5.card-title-vmg.text-white.position-absolute.top-0.start-50.translate-middle-x.text-center.mt-3 {
        font-size: 14px;
    }

    .why-choose-section p.card-description.text-white.position-absolute.top-50.start-50.translate-middle-x.text-center.belief-description {
        font-size: 13px;
        margin: -25%;
        line-height: 1.5rem;
        margin-left: 1%;
        background: linear-gradient(to bottom, #fff);
    }
}

@media (max-width: 576px) {
    .card-img-top {
        width: 85%;
        margin-left: 7%;
    }

    .row.d-flex.justify-content-around {
        flex-direction: row;
        width: 90%;
        margin: auto;
    }

    .why-choose-section p.card-description.text-white.position-absolute.top-50.start-50.translate-middle-x.text-center.belief-description {
        font-size: 25.5px;
        margin: -30%;
        margin-left: 2%;
    }

    .why-choose-section p.card-description.text-white.position-absolute.top-50.start-50.translate-middle-x.text-center.belief-description {
        font-size: 10px;
        margin: -25%;
        width: 90%;
        margin-left: 1%;
        background: linear-gradient(to bottom, #fff);
    }
}

@media (max-width: 375px) {
    .why-choose-section p.card-description.text-white.position-absolute.top-50.start-50.translate-middle-x.text-center.belief-description {
        font-size: 12px;
        margin: -32%;
        line-height: 2rem;
        margin-left: 1%;
        background: linear-gradient(to bottom, #fff);
    }
}

/* contact-us */
@font-face {
    font-family: "FantasyMagist";
    /* Name the font family */
    src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("opentype");
    /* Corrected path */
}

.contact-container .hero-section {
    background: rgba(0, 0, 0, 0.5) url(${___CSS_LOADER_URL_REPLACEMENT_5___}) center center;
    background-size: cover;
    height: 400px;
}

.contact-container .hero-section .text-center {
    margin-top: 14%;
}

.contact-container .hero-section .text-center .hero-title {
    font-family: "FantasyMagist", "Arial", sans-serif;
    color: rgba(245, 242, 231, 1);
    font-weight: 400;
}

.contact-container .hero-section .contact-hero-title {
    margin-top: 5%;
    font-size: 24px;
    border-bottom: 2px solid black;
}

.contact-container .contact-content .section-title {
    color: #6b8e76;
    font-family: "Poppins", sans-serif;
    font-size: 32px;
    font-weight: 600;
    line-height: 48px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
}

.contact-container .contact-content .description {
    color: rgba(103, 103, 103, 1);
    font-size: 20px;
    font-weight: 400;
    margin-top: -4% !important;
}

label.form-label {
    color: rgba(103, 103, 103, 1);
}

.contact-container .contact-content .get-in-touch {
    color: #6b8e76;
    font-family: "Poppins", sans-serif;
    font-size: 32px;
    font-weight: 600;
    line-height: 48px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    margin-top: 5% !important;
}

.contact-container .contact-content .contact-info {
    font-family: "Poppins", sans-serif;
    font-size: 20px;
    font-weight: 500;
    line-height: 40px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    color: #6b8e76 !important;
    list-style-type: none;
    margin-left: -28px;
    margin-top: 10px;
}

.contact-container .contact-content .contact-info li {
    margin-bottom: 10px;
}

.contact-label {
    color: rgba(103, 103, 103, 1) !important;
}

.contact-container .form-section {
    background-color: rgba(249, 247, 237, 1);
}

.contact-container .form-section .form-title .title {
    font-family: "Poppins", sans-serif;
    font-size: 32px;
    font-weight: 500;
    line-height: 48px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    color: rgba(107, 142, 118, 1);
}

.contact-container .form-section .connect-form .form-label {
    font-weight: 500;
}

.contact-container .form-section .connect-form input {
    border: 1px solid rgba(103, 103, 103, 1);
    margin-bottom: 3%;
    background-color: rgba(249, 247, 237, 1);
}

.contact-container .form-section .connect-form input::placeholder,
.contact-container .form-section .connect-form textarea::placeholder {
    color: #6b8e76;
    opacity: 1;
    font-family: "Poppins", sans-serif;
    font-size: 16px;
    font-weight: 400;
    line-height: 30px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
}

.contact-container .form-section .connect-form textarea {
    border: 1px solid rgba(103, 103, 103, 1);
    background-color: rgba(249, 247, 237, 1);
}

.contact-container .form-section .connect-form .btn-success {
    background-color: #6b8e76;
    border: none;
}

.contact-container .form-section .connect-form .btn-success:hover {
    background-color: #5a7a65;
}

/* HOMEPAGE */

.hero-section-banner {
    position: relative;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
    /* Replace with your actual image */
    background-size: cover;
    background-position: center;
    height: 544px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: rgb(245, 242, 231) !important;
    text-align: center;
    font-family: "FantasyMagist", "Arial", sans-serif;
    width: 100%;
    /* Ensures the section spans the full width */
    mix-blend-mode: multiply;
}

.hero-section-banner::before {
    content: "";
    /* background-image: url("../../assets/bannericon.png"); */
    background-color: rgba(107, 142, 118, 1);
    /* Set to the color you want above the image */
    width: 100%;
    /* Ensure full-width */
    height: 100%;
    /* Matches the full height of .hero-section */
    background-repeat: repeat;
    background-position: center;
    background-size: contain;
    /* Adjust the background size */
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0;
    /* Adjust as needed */
    z-index: 1;
    /* Behind text but above the background */
}

.overlay {
    position: relative;
    z-index: 2;
    /* Text content appears above both images */
    margin-top: 15%;
    padding: 20px;
    border-radius: 5px;
    width: 100%;
    max-width: 900px;
    font-family: "FantasyMagist";
}

.animation-text h1 {
    animation-name: intro;
    /* Reference the animation */
    animation-duration: 0.5s;
    animation-iteration-count: 1;
    animation-timing-function: ease;
    animation-delay: 1s;
    animation-fill-mode: forwards;
}

h1 {
    margin: 0;
    font-size: 45px;
    font-weight: 400;
    font-family: "FantasyMagist", "Arial", sans-serif;
    width: 100%;
    color: rgba(245, 242, 231, 1);
    position: relative;
    /* For animation to work */
}

button.connect-button {
    margin-top: 20px;
    padding: 10px 20px;
    font-size: 16px;
    font-weight: 500;
    background-color: rgba(245, 242, 231, 1);
    color: rgba(107, 142, 118, 1);
    border: none;
    border-radius: 5px;
    cursor: pointer;
    position: relative;
    animation-name: intro;
    animation-duration: 0.5s;
    animation-iteration-count: 1;
    animation-timing-function: ease;
    animation-delay: 1s;
    /* Slightly delay compared to h1 */
    animation-fill-mode: forwards;
    font-style: Poppins;
    width: 30%;
}

@keyframes intro {
    0% {
        top: 150px;
        /* Start below the visible area */
    }

    98% {
        top: -5px;
        /* Slight bounce effect */
    }

    100% {
        top: 0%;
        /* Final position */
    }
}

@media (max-width: 2720px) {
    .hero-section .overlay {
        position: relative;
        z-index: 2;
        margin-top: 10%;
        padding: 20px;
        border-radius: 5px;
        width: 100%;
        max-width: 900px;
        font-family: "FantasyMagist";
    }
}

@media (max-width: 576px) {
    .hero-section::before {
        content: "";
        /* background-image: url("../../assets/bannericon.png"); */
        background-color: rgba(107, 142, 118, 0.88);
        width: 100%;
        height: 100%;
        background-repeat: no-repeat;
        background-position: top;
        background-size: contain;
        position: absolute;
        top: 0px;
        left: 0;
        opacity: 0.5;
        z-index: 1;
    }

    .hero-section .overlay h1 {
        margin: 0;
        font-size: 27px;
        font-weight: 400;
        font-family: "FantasyMagist", "Arial", sans-serif;
        width: 553px;
        top: 340px;
        color: rgb(245, 242, 231);
    }
}

@media (max-width: 768px) {
    .hero-section::before {
        content: "";
        background-color: rgba(107, 142, 118, 0.88);
        width: 100%;
        height: 100%;
        background-repeat: no-repeat;
        background-position: top;
        background-size: contain;
        position: absolute;
        top: 0;
        left: 0;
        opacity: 0.5;
        z-index: 1;
        /* Ensure it's behind the text */
    }

    .hero-section .overlay h1 {
        margin: 0 !important;
        font-size: 28px !important;
        /* Adjust font size for smaller screens */
        font-weight: 400 !important;
        font-family: "FantasyMagist", "Arial", sans-serif;
        width: 90% !important;
        /* Make the width relative to the container */
        max-width: 890px !important;
        /* Max width for larger screens */
        top: 200px !important;
        /* Adjust top position if necessary */
        color: rgb(245, 242, 231) !important;
        z-index: 2 !important;
        text-align: center !important;
    }

    /* Responsive underline styling */
    .hero-section .overlay .underline {
        width: 600px !important;
        height: 2px !important;
        background-color: rgb(245, 242, 231);
        margin: 10px 40px 0 !important;
    }
}

@media (max-width: 1200px) {
    .hero-section {
        width: 100%;
    }
}

@media (max-width: 992px) {
    .hero-section .overlay h1 {
        margin: 0;
        font-size: 34px;
        font-weight: 400;
        font-family: "FantasyMagist", "Arial", sans-serif;
        width: 100%;
        top: 340px;
        color: rgb(245, 242, 231);
    }
}

@media (max-width: 480px) {
    .hero-section .overlay h1 {
        margin: 0 !important;
        font-size: 29px !important;
        font-weight: 400 !important;
        font-family: "FantasyMagist", "Arial", sans-serif;
        width: 100% !important;
        max-width: 439px !important;
        top: 200px !important;
        color: rgb(245, 242, 231) !important;
        z-index: 2 !important;
        text-align: center !important;
    }

    .row.d-flex.justify-content-around {
        margin-left: 7%;
    }

    .hero-section .overlay .underline {
        width: 295px !important;
        height: 2px !important;
        background-color: rgb(245, 242, 231);
        margin: 10px 40px 0 !important;
    }

    .hero-section-banner .overlay button.connect-button {
        margin-top: 20px;
        padding: 10px 20px;
        font-size: 16px;
        font-weight: 500;
        background-color: rgb(245, 242, 231);
        color: rgb(107, 142, 118);
        border: none;
        border-radius: 5px;
        cursor: pointer;
        position: relative;
        animation-name: intro;
        animation-duration: 0.5s;
        animation-iteration-count: 1;
        animation-timing-function: ease;
        animation-delay: 1s;
        animation-fill-mode: forwards;
        font-style: Poppins;
        width: 50%;
    }
}

@media (max-width: 380px) {
    .hero-section .overlay h1 {
        margin: 0;
        font-size: 30px;
        font-weight: 400;
        font-family: "FantasyMagist", "Arial", sans-serif;
        width: 338px;
        top: 340px;
        color: rgb(245, 242, 231);
    }

    .hero-section .overlay button.connect-button {
        margin-top: 20px;
        padding: 10px 20px;
        font-size: 16px;
        font-weight: 500;
        background-color: rgb(245, 242, 231);
        color: rgb(107, 142, 118);
        border: none;
        border-radius: 5px;
        cursor: pointer;
        position: relative;
        animation-name: intro;
        animation-duration: 0.5s;
        animation-iteration-count: 1;
        animation-timing-function: ease;
        animation-delay: 1s;
        animation-fill-mode: forwards;
        font-style: Poppins;
        width: 50%;
    }
}

@media (max-width: 380px) {
    .hero-section .overlay h1 {}
}

/* Variables for colors and typography */
:root {
    --primary-color: #6b8e76;
    /* Greenish color */
    --text-color: #555;
    /* Gray color */
    --background-color: #fff;
    /* White background */
}

/* Base styles */
body {
    font-family: "Arial", sans-serif;
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

/* Section styling */
.why-choose-section {
    padding: 40px 20px;
    background-color: var(--background-color);
    text-align: center;
}

.why-choose-section .why-we-title {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
}

.why-choose-section .why-we-title h2 {
    width: 82%;
    top: 734px;
    left: 80px;
    gap: 0px;
    opacity: 0px;
    font-family: 'Poppins', sans-serif;
    font-size: 32px;
    font-weight: 500 !important;
    line-height: 48px;
    text-align: left;
    color: rgba(107, 142, 118, 1) !important;
    text-decoration-skip-ink: none;
    margin-bottom: 2%;
}

.why-choose-section .why-we {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
}

.why-choose-section .why-we p {
    width: 82%;
    top: 795px;
    left: 80px;
    gap: 0px;
    font-family: 'Poppins', sans-serif;
    font-size: 24px;
    font-weight: 400;
    line-height: 34px;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    text-align: justify !important;
    color: rgba(103, 103, 103, 1);
}

/* Responsive adjustments */
@media (max-width: 2720px) {
    .d-flex.justify-content-start {
        flex-direction: column;
    }

    .why-choose-section p.card-description.text-white.position-absolute.top-50.start-50.translate-middle-x.text-center.belief-description {
        font-size: 18px;
        margin: -18%;
        margin-left: 0%;
        background: linear-gradient(to bottom, #fff);
    }
}

@media (max-width: 768px) {
    .why-choose-section .why-we-title h2 {
        font-size: 24px;
    }

    .why-choose-section .why-we p {
        font-size: 14px;
    }
}

@media (max-width: 480px) {
    .why-choose-section .why-we-title h2 {
        font-size: 20px;
    }

    .why-choose-section .why-we p {
        font-size: 12px;
    }
}

/* Cards */
.card-body {
    position: relative;
    overflow: hidden;
    cursor: pointer;
    background: rgb(107, 142, 118);
}

.card-body .card-img-top {
    object-fit: cover;
    width: 85%;
    margin-left: 7%;
    transition: transform 0.3s ease-in-out;
}

.card-body .card-title-vmg {
    font-family: 'Poppins', sans-serif;
    font-size: 24px;
    font-weight: 600;
    line-height: 36px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
}

.card-body:hover .card-img-top {
    opacity: 0;
}

.card-body:hover .belief-description {
    opacity: 1;
    visibility: visible;
    color: transparent;
    transform: translate(-50%, 0%) !important;
    padding: 0px 40px 0px 40px;
}

/* Style the text inside the overlay */
.belief-description {
    transform: translate(-100%, 0%) !important;
    color: #fff !important;
    opacity: 0;
    transition: all 0.3s ease-in-out;
    text-align: center;
}

.why-choose-section p.card-description.text-white.position-absolute.top-50.start-50.translate-middle-x.text-center.belief-description {
    font-size: 14px;
    margin: -18%;
    margin-left: -1%;
    text-align: center;
    background: linear-gradient(to bottom, #fff);
}

/* Media Queries */
@media (max-width: 1400px) {
    .card-title-vmg {
        margin-bottom: var(--bs-card-title-spacer-y);
        color: var(--bs-card-title-color);
        overflow-y: hidden !important;
    }
}

@media (max-width: 1200px) {
    .why-choose-section .why-we p {
        width: 100%;
        top: 795px;
        left: 80px;
        gap: 0px;
        font-family: 'Poppins', sans-serif;
        font-size: 21px;
        font-weight: 400;
        line-height: 34px;
        text-align: justified;
        text-underline-position: from-font;
        text-decoration-skip-ink: none;
        text-align: left;
        color: rgb(103, 103, 103);
    }

    .card-title-vmg {
        margin-bottom: var(--bs-card-title-spacer-y);
        color: var(--bs-card-title-color);
        overflow-y: hidden !important;
    }

    .why-choose-section p.card-description.text-white.position-absolute.top-50.start-50.translate-middle-x.text-center.belief-description {
        font-size: 12px;
        margin: -5%;
    }
}

@media (max-width: 2560px) {
    .text-success {
        --bs-text-opacity: 1;
        color: rgba(var(--bs-success-rgb), var(--bs-text-opacity)) !important;
        overflow-y: hidden !important;
    }

    .text-start {
        text-align: left !important;
        overflow-y: hidden !important;
    }
}

@media (max-width: 992px) {
    .why-choose-section p.card-description.text-white.position-absolute.top-50.start-50.translate-middle-x.text-center.belief-description {
        font-size: 8.5px;
        margin: -7%;
    }

    .why-choose-section p.card-description.text-white.position-absolute.top-50.start-50.translate-middle-x.text-center.belief-description {
        font-size: 14px;
        margin: -24%;
        width: 90%;
        margin-left: 1%;
        background: linear-gradient(to bottom, #fff);
    }
}

@media (max-width: 768px) {
    .card-body {
        flex: 1 1 auto;
        color: var(--bs-card-color);
    }

    h5.card-title-vmg.text-white.position-absolute.top-0.start-50.translate-middle-x.text-center.mt-3 {
        font-size: 14px;
    }

    .why-choose-section p.card-description.text-white.position-absolute.top-50.start-50.translate-middle-x.text-center.belief-description {
        font-size: 13px;
        margin: -25%;
        line-height: 1.5rem;
        margin-left: 1%;
        background: linear-gradient(to bottom, #fff);
    }
}

@media (max-width: 576px) {
    .card-img-top {
        object-fit: cover;
        width: 85%;
        margin-left: 7%;
    }

    .row.d-flex.justify-content-around {
        flex-direction: row;
        width: 90%;
        margin: auto;
    }

    .why-choose-section p.card-description.text-white.position-absolute.top-50.start-50.translate-middle-x.text-center.belief-description {
        font-size: 25.5px;
        margin: -30%;
        margin-left: 2%;
    }

    .why-choose-section p.card-description.text-white.position-absolute.top-50.start-50.translate-middle-x.text-center.belief-description {
        font-size: 10px;
        margin: -25%;
        width: 90%;
        margin-left: 1%;
        background: linear-gradient(to bottom, #fff);
    }
}

@media (max-width: 768px) {
    .row.d-flex.justify-content-around {
        flex-direction: row;
    }

    .why-choose-section p.card-description.text-white.position-absolute.top-50.start-50.translate-middle-x.text-center.belief-description {
        font-size: 10px;
        margin: -19%;
        margin-left: 1%;
    }
}

@media (max-width: 1024px) {
    .why-choose-section p.card-description.text-white.position-absolute.top-50.start-50.translate-middle-x.text-center.belief-description {
        font-size: 10px;
        margin: -19%;
        margin-left: 1%;
    }
}

@media (max-width: 415px) {
    .my-5 {
        margin-top: 8rem !important;
        margin-bottom: 3rem !important;
    }

    .why-choose-section p.card-description.text-white.position-absolute.top-50.start-50.translate-middle-x.text-center.belief-description {
        font-size: 16px;
        margin: -23%;
        line-height: 1.5rem;
        margin-left: 1%;
        padding: 6px;
        background: linear-gradient(to bottom, #fff);
    }
}

@media (max-width: 375px) {}

/* General container styles */
.container-Path-to-Excellence {
    padding: 20px;
    width: 100%;
    background-color: rgba(249, 247, 237, 1);
    padding-bottom: 80px;
}

.container-Path-to-Excellence .heading {
    text-align: left;
    margin-bottom: 20px;
}

.pathexcellence {
    width: 1247px !important;
    height: 69px !important;
    font-size: 24px !important;
    word-spacing: 4px !important;
    font-weight: 400 !important;
    margin-left: 6% !important;
}

.heading-text {
    font-size: 32px;
    font-weight: 500;
    margin-left: 8%;
}

.container-Path-to-Excellence .heading .heading-text {
    margin-left: 10%;
    width: 100%;
    height: 100%;
    font-family: "Poppins", sans-serif;
    font-size: 25px;
    font-weight: 500;
    line-height: 48px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    color: rgba(107, 142, 118, 1);
}

.container-Path-to-Excellence .heading p {
    width: 100%;
    margin-left: 8% !important;
    font-family: "Poppins", sans-serif;
    font-size: 20px;
    font-weight: 400;
    line-height: 34px;
    padding-left: 2%;
    text-align: justify;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    color: rgba(103, 103, 103, 1);
}

/* Design images container */
.container-Path-to-Excellence .design-images {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-evenly;
    margin-left: 133px;
    padding-right: 93px;
}

.container-Path-to-Excellence .design-images .arrow-img {
    width: 23.26px;
    height: 53.14px;
    border-radius: 8px;
    transition: transform 0.3s ease;
    margin-top: 32px;
}

.container-Path-to-Excellence .design-images .image-row .main-img-container {
    position: relative;
    text-align: center;
}

.container-Path-to-Excellence .design-images .image-row .main-img {
    width: 119.15px;
    border-radius: 8px;
    transition: transform 0.3s ease;
    display: block;
    margin: 0 auto;
}

.container-Path-to-Excellence .design-images .image-row .signup-img {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 33.75px;
    height: 45px;
}

.container-Path-to-Excellence .design-images .text-title {
    font-weight: 500;
    font-family: "Poppins", sans-serif;
    font-size: 14px;
    color: rgba(103, 103, 103, 1);
    text-align: center;
    width: 68px;
}

.container-Path-to-Excellence .design-images-row {
    display: flex;
    margin-bottom: 20px;
    width: 100%;
    padding: 2px;
    align-content: center;
    flex-direction: row;
}

@media (max-width: 768px) {
    .container-Path-to-Excellence .design-images {
        flex-direction: column;
        align-items: center;
        gap: 20px;
    }
}

/* Media queries */
@media (max-width: 1024px) {
    .container-Path-to-Excellence .design-images {
        flex-direction: row; 
        flex-wrap: wrap;
        gap: 30px; /* Adjust spacing for smaller screens */
    }
    
    .container-Path-to-Excellence .design-images .text-title {
        font-size: 18px; /* Slightly smaller for responsiveness */
    }
}

@media (max-width: 2560px) {
    .container-Path-to-Excellence .design-images .text-title {
        font-size: 20px;
        font-weight: 500;
        margin-top: 20px;
        width: 113px !important;
    }
}

@media (max-width: 480px) {
    .container-Path-to-Excellence {
        padding: 20px;
        width: 100%;
        max-width: 1258px;
        height: auto;
        margin: 0 auto;
        background-color: rgb(249, 247, 237);
    }

    .star-rating {
        width: 100%;
        height: 25px;
        display: flex;
        justify-content: center;
        margin-top: 7rem;
    }

    .container-Path-to-Excellence .heading p {
        font-size: 16px;
        line-height: 25px;
        margin-left: 3%;
    }

    .container-Path-to-Excellence .design-images .image-row {
        justify-content: center;
        align-items: center;
        margin-bottom: 20px;
    }

    .why-choose-section p {
        font-size: 18px;
        line-height: 31px;
        text-align: center;
        margin-top: 5%;
    }

    .why-choose-section p.card-description.text-white.position-absolute.top-50.start-50.translate-middle-x.text-center.belief-description {
        font-size: 16px;
        margin-top: -5% !important;
        margin: -22%;
        margin-left: -2%;
    }

    .custom-footer .footer-about .contact-info,
    .custom-footer .footer-links .contact-info,
    .custom-footer .footer-legal .contact-info {
        flex-wrap: wrap;
        margin-top: 2%;
        gap: 15px;
        align-items: center;
        /* display: flex
; */
    }

}




@media (max-width: 576px) {
    .container-Path-to-Excellence {
        padding: 20px;
        width: 100%;
        height: auto;
        margin: 0 auto;
        background-color: rgb(249, 247, 237);
    }

    .container-Path-to-Excellence .design-images .image-row {
        justify-content: center;
        align-items: center;
        margin-bottom: 20px;
    }

    .why-choose-section h2 {
        font-size: 32px;
        line-height: 48px;
        margin-bottom: 5%;
    }

    .why-choose-section p {
        font-size: 21px;
        line-height: 34px;
        text-align: center;
    }

    .d-flex {
        display: flex !important;
        flex-direction: column;
        align-items: center;
    }

    .container-Path-to-Excellence .design-images {
        justify-content: center;
    }
}

@media (max-width: 768px) {
    .container-Path-to-Excellence {
        padding: 20px;
        width: 100%;
        height: auto;
        margin: 0 auto;
        background-color: rgb(249, 247, 237);
    }

    .container-Path-to-Excellence .design-images .image-row {
        justify-content: center;
        align-items: center;
        margin-bottom: 5px;
    }

    .container-Path-to-Excellence .design-images .text-title {
        font-size: 14px;
        margin: auto;
        margin-left: 48%;
    }
}

@media (max-width: 992px) {
    .container-Path-to-Excellence .design-images .text-title {
        font-size: 16px;
        width: 100%;
        margin: 0 auto;
    }
}


/* notificationspage */

/* kanj */

/* Actions Container - Flexbox for proper alignment */
.actions-container {
    display: flex;
    justify-content: space-between;
    /* Filters on the left, Select button on the right */
    align-items: center;
    margin-top: 10px;
    padding: 10px 0;
}

.no-notifications {
    padding: 0 21px;
}

/* Select Button */
.select-button {
    /* background: #6b6b6b;
    color: white;
    padding: 8px 12px;
    border-radius: 5px;
    border: none;
    cursor: pointer;
    transition: 0.3s ease; */
    padding: 6px 12px;
    border-radius: 50px;
    border: 1px solid #ddd;
    background: none;
    cursor: pointer;
    transition: 0.3s ease;
}

.select-button:hover {
    /* background: #4f4f4f; */
    background: #6b6b6b;
    color: white;
}

/* Selection Bar */
.selection-bar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #f5f5f5;
    padding: 8px;
    border-radius: 5px;
    margin: 10px 0;
}

.checkbox-container {
    display: flex;
    align-items: center;
    gap: 5px;
}

/* Delete Button */
.delete-button {
    background: #ff4d4d;
    color: white;
    padding: 8px 12px;
    border: none;
    border-radius: 6px;
    cursor: pointer;
    font-size: 14px;
    display: flex;
    align-items: center;
    gap: 5px;
}

.delete-button:hover {
    background: #cc0000;
}

#squarecheckbox {
    width: 18px;
    /* Size */
    height: 18px;
    appearance: none;
    /* Remove default styles */
    -webkit-appearance: none;
    -moz-appearance: none;
    background-color: white;
    border: 2px solid #333;
    /* Border color */
    border-radius: 2px;
    /* Change to 0px for perfect square */
    cursor: pointer;
    display: inline-block;
    position: relative;
    outline: none;
    /* Remove focus outline */
}

#squarecheckbox:checked {
    background-color: #6b8e76;
    /* border-color: #007bff; */
}


/* Notifications List with scrollbar*/
.notifications-list {
    max-height: 380px;
    /* Set a fixed height */
    overflow-y: auto;
    /* Enables vertical scrolling */
    scrollbar-width: thin;
    /* Firefox: makes the scrollbar thinner */
    scrollbar-color: #888 #f1f1f1;
    /* Scrollbar color */
}

/* For Webkit Browsers (Chrome, Edge, Safari) */
.notifications-list::-webkit-scrollbar {
    width: 6px;
    /* Scrollbar width */
}

.notifications-list::-webkit-scrollbar-thumb {
    background: #888;
    /* Scrollbar thumb color */
    border-radius: 4px;
}

.notifications-list::-webkit-scrollbar-thumb:hover {
    background: #555;
    /* Darker on hover */
}

/* kanj */
/* .notifications-container {
    width: 100%;
    max-width: 800px;
    background: white;
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    margin: 20px auto;
} */

.notifications-header {
    padding: 20px;
    border-bottom: 1px solid #eee;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.notifications-header h2 {
    margin: 0;
    font-size: 24px;
    font-weight: 600;
    color: rgba(107, 71, 80, 1);

}

.close-button {
    background: none;
    border: none;
    font-size: 1.5rem;
    cursor: pointer;
    padding: 0 8px;
    color: #666;
}

.notifications-filters {
    padding: 10px 20px;
    /* border-bottom: 1px solid #eee; */
    display: flex;
    gap: 10px;
}

.filter-btn {
    background: none;
    border: 1px solid #ddd;
    padding: 5px 15px;
    border-radius: 20px;
    cursor: pointer;
    font-size: 15px;
    font-weight: 500;
    transition: all 0.2s;
    color: rgba(103, 103, 103, 1);


}

.filter-btn.active {
    background: rgba(103, 103, 103, 1);
    border-color: #ccc;
    color: rgba(255, 255, 255, 1);


}

/* .notifications-list {
    max-height: 500px;
    overflow-y: auto;
    background-color: rgba(245, 242, 231, 0.35);
} */

.notification-item {
    padding: 15px 20px;
    display: flex;
    align-items: center;
    gap: 15px;
    border-bottom: 1px solid #eee;
    transition: background-color 0.2s;
    margin-bottom: 10px;
    border-bottom: 1px solid #eee;
    transition: background-color 0.2s;
    background-color: rgba(245, 242, 231, 0.35);
    margin-bottom: 8px;
    /* Adds gap between each notification */
    border-radius: 5px;
    /* Optional: Rounds corners for a better look */
}

.notification-item:hover {
    background-color: #f8f8f8;
}

.notification-icon {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: rgba(107, 142, 118, 1) !important;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.2rem;
}

.notification-content {
    flex: 1 1;
}

.notification-content p {
    margin: 0;
    font-size: 16px;
    color: rgba(0, 0, 0, 0.6);
    font-weight: 500;
}

.notification-time {
    font-size: 14px;
    font-weight: 300;
    color: var(--grey-200, rgba(188, 182, 183, 1));
    display: flex;
    justify-content: end;
    font-family: 'Poppins', sans-serif;
    /* Apply Poppins */
}

.more-options {
    background: none;
    border: none;
    color: #666;
    cursor: pointer;
    padding: 0 8px;
    font-size: 1.2rem;
    visibility: hidden;
}

.notification-item:hover .more-options {
    visibility: visible;
}

/* Icon types */
.notification-icon.payment {
    background: #4caf50;
}

.notification-icon.campaign {
    background: #2196f3;
}

.notification-icon.approval {
    background: #9c27b0;
}

.notification-icon.view {
    background: #ff9800;
}

/* instaaccordian */
.influencer-stats .stat-item {
    background-color: #fff;
}

@font-face {
    font-family: 'Gilroy-Medium';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format('woff2'),
        url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format('woff');
    font-weight: normal;
    font-style: normal;
}


.interaction-stats {
    color: rgba(107, 71, 80, 1);
    font-family: 'Gilroy-Medium', sans-serif;
    font-weight: 400;
    font-size: 19px;
    line-height: 21.83px;
    letter-spacing: 2%;
    text-align: center;


}

.interaction-stats {
    display: flex;
    gap: 20px;
    /* Adjust spacing as needed */
}

.interaction-stats p {
    text-align: center;
}

.post-interaction h3 {
    text-align: center;
}

.MuiGrid-root.MuiGrid-container.MuiGrid-spacing-xs-2.css-919fip-MuiGrid-root .logo {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: 0.5rem;
    margin: 0 2rem 0 2rem;
}

.MuiGrid-root.MuiGrid-container.MuiGrid-spacing-xs-2.css-919fip-MuiGrid-root .logo img {
    height: 2.5rem;
    margin: 0;
}

.MuiGrid-root.MuiGrid-container.MuiGrid-spacing-xs-2.css-919fip-MuiGrid-root .logo p {
    color: var(--New-form-color, #6b4750);
    text-align: center;
    font-family: 'Poppins', sans-serif;
    font-size: 1.2rem;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    letter-spacing: 1px;
    margin: 0;
}

.MuiGrid-root.MuiGrid-container.MuiGrid-spacing-xs-2.css-919fip-MuiGrid-root .post-interaction {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 0;
}

.MuiGrid-root.MuiGrid-container.MuiGrid-spacing-xs-2.css-919fip-MuiGrid-root .post-interaction h3 {
    color: var(--Dark, #d72756);
    font-family: 'Poppins', sans-serif;
    font-size: 1.2rem;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    text-align: center;
}

.MuiGrid-root.MuiGrid-container.MuiGrid-spacing-xs-2.css-919fip-MuiGrid-root .post-interaction .interaction-stats {
    display: flex;
    flex-direction: row;
    justify-content: center;
    gap: 2rem;
    margin: 0 3rem;
}

.MuiGrid-root.MuiGrid-container.MuiGrid-spacing-xs-2.css-919fip-MuiGrid-root .post-interaction .interaction-stats .interaction-stat-field {
    display: flex;
    flex-direction: column;
}

.MuiGrid-root.MuiGrid-container.MuiGrid-spacing-xs-2.css-919fip-MuiGrid-root .post-interaction .interaction-stats .interaction-stat-field p {
    color: var(--New-form-color, #6b4750);
    text-align: center;
    margin: 0.2rem;
    font-family: 'Poppins', sans-serif;
    font-size: 1.5rem;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    letter-spacing: 0.64px;
}

.MuiGrid-root.MuiGrid-container.MuiGrid-spacing-xs-2.css-919fip-MuiGrid-root .post-interaction .interaction-stats .interaction-stat-field span {
    color: var(--New-form-color, #6b4750);
    text-align: center;
    font-family: 'Poppins', sans-serif;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    letter-spacing: 0.36px;
    display: inline;
}

.wrapper-div .arrow-div {
    text-align: center;
}

.MuiPaper-root.MuiPaper-elevation.MuiPaper-rounded.MuiPaper-elevation1.MuiAccordion-root.MuiAccordion-rounded.MuiAccordion-gutters.css-1086bdv-MuiPaper-root-MuiAccordion-root {
    background: transparent;
    box-shadow: none;
}

.parent-box {
    margin: 0;
    padding: 0;
}

.parent-box .insta-stats {
    margin: 0;
    background-color: #fff;
    box-shadow: #d72756;
}

.parent-box .insta-stats h3 {
    color: var(--NP, var(--primary-300, #f45c7b));
    font-family: 'Poppins', sans-serif;
    font-size: 1.5rem;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    margin: 0;
    width: fit-content;
}

.parent-box .insta-stats .group-stats {
    display: flex;
    justify-content: space-evenly;
    margin: 0;
    box-sizing: border-box;
}

.parent-box .insta-stats .group-stats .city-stats {
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin: 0;
}

.parent-box .insta-stats .group-stats .city-stats p {
    color: var(--New-form-color, #6b4750);
    text-align: center;
    font-family: 'Poppins', sans-serif;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    font-size: 1.2rem;
    margin: 0;
}

.parent-box .insta-stats .group-stats .city-stats p span {
    opacity: 0.7;
}

.parent-box .insta-stats .group-stats .city-stats .progress-bars {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 0.4rem;
    margin: 1rem 0 0 0;
    padding: 0;
    width: 100%;
}

.parent-box .insta-stats .group-stats .city-stats .progress-bars .single-stats-unit {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    gap: 0.3rem;
    width: 100%;
}

.parent-box .insta-stats .group-stats .city-stats .progress-bars .single-stats-unit p {
    color: var(--New-form-color, #6b4750);
    text-align: right;
    font-family: 'Poppins', sans-serif;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    font-size: 0.9rem;
    margin: 0;
}

.parent-box .account-activity h3,
.parent-box .subscribers-chart h3 {
    color: var(--primary-300, #f45c7b);
    font-family: 'Poppins', sans-serif;
    font-size: 1.2rem;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    letter-spacing: 0.4px;
}

.parent-box .account-activity h3 span {
    color: var(--primary-300, #e4688a);
    font-family: 'Poppins', sans-serif;
    font-size: 0.92rem;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    letter-spacing: 0.3px;
}

/* Legends Section */
.legends {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 1rem;
    font-size: 0.9rem;
    flex-basis: 100%;
    flex-wrap: wrap;
    margin-top: 1rem;
}

.legends span {
    position: relative;
    padding-left: 1.5rem;
}

.legends span::before {
    position: absolute;
    top: 0.4rem;
    left: 0;
    content: "";
    width: 0.8rem;
    aspect-ratio: 1;
    border-radius: 50%;
}

.legends span:nth-child(1)::before {
    background-color: #baeadc;
}

.legends span:nth-child(2)::before {
    background-color: #f8bed4;
}

.legends span:nth-child(3)::before {
    background-color: #b9f3fc;
}

@media (min-width: 1400px) and (max-width: 1500px) {
    .MuiGrid-root.MuiGrid-item.MuiGrid-grid-xs-12.MuiGrid-grid-sm-3.MuiGrid-grid-md-3.css-zbaamk-MuiGrid-root .post-interaction .interaction-stats .interaction-stat-field p {
        font-size: 20px;
    }
}

@media screen and (max-width: 1028px) {
    .MuiGrid-root.MuiGrid-container.MuiGrid-spacing-xs-2.css-919fip-MuiGrid-root .post-interaction .interaction-stats {
        margin: 0;
    }

    .influencer-stats .wrapper-div .post-interaction .interaction-stats {
        display: flex;
        justify-content: center;
        gap: 2rem;
        flex-wrap: wrap;
        flex-direction: column;
    }

    .wrapper-div {
        padding: 1rem;
        background: #fff;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-right: 34.9rem;
        margin-left: 36.9rem;
    }

    .parent-box .insta-stats .group-stats .city-stats .progress-bars .single-stats-unit {
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        align-items: center;
        gap: 0.3rem;
        width: 100%;
    }
}


/* youtubraccordian */
.css-1f1pi2l-MuiButtonBase-root-MuiAccordionSummary-root:not(.Mui-disabled) {
    cursor: pointer;
    width: 100%;
    background-color: white;
}

.MuiGrid-root.MuiGrid-container.MuiGrid-spacing-xs-2.css-919fip-MuiGrid-root .youtube-logo {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: 0.5rem;
    margin: 0 2.5rem 0 2.5rem;
}

.MuiGrid-root.MuiGrid-container.MuiGrid-spacing-xs-2.css-919fip-MuiGrid-root .youtube-logo .youtube-image {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: red;
    height: 3rem;
    width: 3rem;
    border-radius: 50%;
}

.MuiGrid-root.MuiGrid-container.MuiGrid-spacing-xs-2.css-919fip-MuiGrid-root .youtube-logo .youtube-image img {
    height: 1.5rem;
    margin: 0;
}

.MuiGrid-root.MuiGrid-container.MuiGrid-spacing-xs-2.css-919fip-MuiGrid-root .youtube-logo p {
    color: var(--New-form-color, #6b4750);
    text-align: center;
    font-family: 'Poppins', sans-serif;
    font-size: 1.2rem;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    letter-spacing: 1px;
    margin: 0;
}

.MuiGrid-root.MuiGrid-container.MuiGrid-spacing-xs-2.css-919fip-MuiGrid-root .arrow-div {
    margin: 0 3rem 0 3rem;
    padding: 2rem 0 2rem 0;
}

.MuiPaper-root.MuiPaper-elevation.MuiPaper-rounded.MuiPaper-elevation1.MuiAccordion-root.MuiAccordion-rounded.MuiAccordion-gutters.css-1086bdv-MuiPaper-root-MuiAccordion-root {
    background: #fff;
    box-shadow: none;
    padding: 2rem;
    position: static;
    border-radius: 8px;
}

@media screen and (max-width: 768px) {
    .MuiPaper-root.MuiPaper-elevation.MuiPaper-rounded.MuiPaper-elevation1.MuiAccordion-root.MuiAccordion-rounded.MuiAccordion-gutters.css-1086bdv-MuiPaper-root-MuiAccordion-root {
        background: #fff;
        box-shadow: none;
        padding: 2rem;
        position: static;
        padding-right: 0px;
    }
}

.interaction-stats {
    display: flex;
}

.css-cmahm4-MuiGrid-root>.MuiGrid-item {
    display: flex;
    justify-content: space-around;
    align-items: center;
}

/* my profile */
button.btn.profile-clear-btn {
    color: rgba(103, 103, 103, 1);
    text-decoration: underline;
    font-family: 'Poppins', sans-serif;
    font-weight: 500;
    font-size: 16px;
    line-height: 21.12px;
    text-align: center;
    border: none;
}

button.profile.btn.btn-success {
    background-color: rgba(107, 142, 118, 1);

}

button.profile.btn.btn-outline-success.mx-2:hover {
    background-color: rgba(107, 142, 118, 1);
    color: white;

}

[type=button]:not(:disabled),
[type=reset]:not(:disabled),
[type=submit]:not(:disabled),
button:not(:disabled) {
    cursor: pointer;
    /* height: 60px; */
    /* width: 107px; */
    border: 2px solid rgba(107, 142, 118, 1);
}




/* Remove default blue background from dropdown items */
.dropdown-menu .dropdown-item {
    background-color: transparent !important;
    color: #000;
    /* Change text color if needed */
}

/* Remove background color on hover */
.dropdown-menu .dropdown-item:hover,
.dropdown-menu .dropdown-item:focus {
    background-color: rgba(0, 0, 0, 0.05) !important;
    /* Slight highlight on hover */
}

.input-container {
    position: relative;
    display: flex;
    align-items: center;
}

.social-icon {
    position: absolute;
    left: 10px;
    width: 20px;
    height: 20px;
}

.social-input {
    width: 100%;
    padding-left: 40px;
    /* Space for icon */
    height: 40px;
    border: 1px solid #ccc;
    border-radius: 5px;
}

.attached-text {
    position: absolute;
    right: 10px;
    font-size: 12px;
    color: green;
    font-weight: bold;
}

/* Influencer Page */
.influencer-container .influencer-hero-section {
    background: rgba(0, 0, 0, 0.5) url(${___CSS_LOADER_URL_REPLACEMENT_8___}) center center;
    background-size: cover;
    height: 400px;
    color: white;
}

h2.text-3xl.font-medium.case-studies.mb-8 {
    color: rgba(107, 142, 118, 1) !important;
    margin-bottom: 1% !important;
    margin-top: 8% !important;
}

h2.text-success.market-heading.fs-4.fw-medium.mb-4 {
    color: rgba(107, 142, 118, 1) !important;
    font-weight: 600;
    font-family: 'Poppins', sans-serif;
    font-size: 32px;
}

h3.heading-title.text-success.fw-medium.mb-2 {
    color: rgba(107, 142, 118, 1) !important;
    font-family: 'Poppins', sans-serif;
    font-size: 24px;
    font-weight: 600;
}

p.text-muted.small.card-content {
    color: rgba(103, 103, 103, 1) !important;
    font-weight: 400;
    font-family: 'Poppins', sans-serif;
    font-size: 16px;

}

.slick-slide>div {
    padding: 0 10px;
}

.text-center .influencer-hero {
    margin-top: 18% !important;

}

.card {
    height: 200px !important;
    /* Adjust this value to your desired height */
    display: flex !important;
    flex-direction: column !important;
}

.card-content {
    flex-grow: 1;
    /* Ensures content inside the card stretches to fill available space */
}

.slick-slider .slick-disabled {
    opacity: 0;
    pointer-events: none;
}

.mb-3.d-flex.user-text {
    color: rgba(107, 142, 118, 1) !important;
    border-bottom: 0.5px solid rgba(103, 103, 103, 1)
}

.text-user.num.fs-3 {
    font-weight: 600;
    font-family: 'Poppins', sans-serif;
    font-size: 40px !important;
}

.text-user.word {
    font-family: 'Poppins', sans-serif;
    font-weight: 400;
    font-size: 16px;
    padding-top: 15px;
    margin-left: 30px;
}

.card-case.p-4.h-100 {
    background-color: rgba(245, 242, 231, 1);
    border-radius: 10px;

}

.date-case {
    color: rgba(103, 103, 103, 1);
    font-family: 'Poppins', sans-serif;
    font-weight: 400;
    font-size: 20px;
}

h3.fs-4.title-case {
    color: rgba(107, 142, 118, 1);
    font-weight: 600;
    font-family: 'Poppins', sans-serif;
    font-size: 28px !important;
}

p.description-case {
    color: rgba(103, 103, 103, 1);
    font-weight: 400;
    font-family: 'Poppins', sans-serif;
    font-size: 20px;
}

button.read-more-btn {
    background-color: rgba(107, 142, 118, 1);
    color: white;
    border-radius: 5px;
    padding: 5px;
    width: 150px;
}

.about-influencer-image {}

/* BrandPage */

.main-content-brand {
    background-color: rgba(245, 242, 231, 1);
}

.main-content-brand .heading-brand-benifit {
    text-align: start;
    color: rgba(107, 142, 118, 1);
    font-family: "Poppins", sans-serif;
    font-size: 32px;
    font-weight: 500;
    line-height: 48px;
    text-align: left;
    margin-bottom: 2%;
}

.main-content-brand .heading-brand-benifit .titles-brand {
    font-size: 24px;
    font-weight: 600;
    margin-left: -69px;
}

.main-content-brand .all-cards .card-one-brand {
    position: relative;
    width: 100%;
    padding: 26px;
    padding-left: 1rem;
    position: relative;

}

.main-content-brand .all-cards .card-one-brand .card {
    background-color: #fff;
    width: 387px;
    height: 159px !important;
    padding: 10px;

}

.main-content-brand .all-cards .card-one-brand .card .card-image-brand {
    position: absolute;
    top: 51%;
    left: -55px;
    transform: translateY(-50%);
    width: 130px;
    height: 124px;
    margin: 0;
    bottom: 50%;
}

.main-content-brand .all-cards .card-one-brand .card .card-image-brand img {
    width: 119px;
    object-fit: none;
    background: #6b8e76;
    border-radius: 5rem;
    border: 9px solid #f5f2e7;
    height: 119px;
}

.main-content-brand .all-cards .card-one-brand .card .card-content-brand {
    margin-left: 100px;
}

.main-content-brand .all-cards .card-one-brand .card .card-content-brand .brand-text-container .brand-card-heading {
    font-family: "Poppins", sans-serif;
    font-size: 24px;
    margin-bottom: 12px;
    margin-top: 10px;
    font-weight: 600;
    line-height: 27px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    color: rgba(107, 142, 118, 1);
}

.main-content-brand .all-cards .card-one-brand .card .card-content-brand .brand-text-container .brand-card-description {
    font-family: "Poppins", sans-serif;
    font-size: 16px;
    font-weight: 400;
    line-height: 22px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    color: rgba(103, 103, 103, 1);
}

/* SETTING PAGE CSS */

.settings-page {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
    padding: 40px 0;
  }
  
  .settings-container {
    width: 50%;
    background-color: #ffffff;
    padding: 20px;
    border-radius: 10px;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  }
  
  .settings-title {
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 15px;
  }
  
  .settings-list {
    background-color: white;
    border-radius: 10px;
    overflow: hidden;
  }
  
  .settings-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 16px;
    border-bottom: 1px solid #e0e0e0;
    font-size: 16px;
    cursor: pointer;
  }
  
  .settings-item:last-child {
    border-bottom: none;
  }
  
  .settings-value {
    display: flex;
    align-items: center;
    color: #7c7c7c;
  }
  
  .arrow {
    font-size: 18px;
    font-weight: bold;
    color: gray;
  }
  
 /* Modal Overlay */
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.4);
    display: flex;
    align-items: center;
    justify-content: center;
    backdrop-filter: blur(5px);
  }
  
  /* Modal Box */
  .modal-content-setting{
    background: white !important;
    width: 350px !important;
    padding: 25px;
    border-radius: 10px !important;
    text-align: center;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
    transition: all 0.3s ease-in-out;
  }

  
  /* Modal Title */
  .modal-title {
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 10px;
  }
  
  /* Modal Message */
  .modal-message {
    font-size: 14px;
    color: #555;
    margin-bottom: 20px;
  }
  
  /* Modal Buttons */
  .modal-buttons {
    display: flex;
    justify-content: center;
    gap: 10px;
    padding-top: 25px;
  }
  
  .modal-btn {
    padding: 8px 15px;
    border-radius: 5px;
    font-size: 14px;
    cursor: pointer;
    border: none;
    outline: none;
    transition: 0.2s ease-in-out;
  }
  
  .logout {
    background-color: #5a7f62;
    color: white;
  }
  
  .logout:hover {
    background-color: #4b6b52;
  }
  
  .cancel {
    background-color: white;
    border: 1px solid #ccc;
    color: black;
  }
  
  .cancel:hover {
    border-color: black;
  }
.text-muted{
    margin-right: 10px !important;
}
.navbar-dull {
    background-color:  rgba(203, 201, 201, 0.4) !important; 
    filter: brightness(70%);
    transition: all 0.3s ease-in-out;
}

.navbar-dull * {  /* Applies blur to all text inside navbar */
    filter: blur(3px); /* Adjust the blur strength */
}
.navbar-dull span,
.navbar-dull a,
.navbar-dull p {
    filter: blur(3px); /* Blurs only text */
}

`, "",{"version":3,"sources":["webpack://./src/InsocialOrbit/Assets/css/index.css"],"names":[],"mappings":"AAAA;IACI,SAAS;IACT,UAAU;IACV,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,6BAA6B;AACjC;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,sBAAsB;IACtB,4BAA4B;IAC5B,iBAAiB;IACjB,0BAA0B;IAC1B,YAAY;IACZ,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,sCAAsC;IACtC,eAAe;AACnB;;AAEA;;;IAGI,kCAAkC;AACtC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;;;IAGI,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,kCAAkC;IAClC,8BAA8B;IAC9B,6BAA6B;IAC7B,cAAc;AAClB;;AAEA;;;IAGI,aAAa;IACb,sBAAsB;IACtB,cAAc;AAClB;;AAEA;;;IAGI,0CAA0C;IAC1C,0CAA0C;IAC1C,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,wCAAwC;IACxC,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,sCAAsC;IACtC,YAAY;IACZ,wCAAwC;AAC5C;;AAEA;;;IAGI,WAAW;IACX,0CAA0C;AAC9C;;AAEA;;;IAGI,0CAA0C;IAC1C,0CAA0C;IAC1C,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,wCAAwC;IACxC,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,sCAAsC;IACtC,YAAY;IACZ,wCAAwC;IACxC,qBAAqB;AACzB;;AAEA;;;IAGI,WAAW;IACX,0CAA0C;AAC9C;;AAEA;;IAEI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;IACrB,kBAAkB;IAClB,qBAAqB;IACrB,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;IACd,yBAAyB;IACzB,6BAA6B;IAC7B,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,YAAY;IACZ,sBAAsB;IACtB,yBAAyB;IACzB,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,kEAAkE;AACtE;;AAEA;IACI,WAAW;IACX,WAAW;IACX,cAAc;IACd,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,UAAU;IACV,QAAQ;IACR,SAAS;IACT,kBAAkB;IAClB,6DAA6D;IAC7D,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;IAC3B,8CAA8C;AAClD;;AAEA;IACI;QACI,UAAU;IACd;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,UAAU;IACd;AACJ;;AAEA;IACI,8BAA8B;IAC9B,SAAS;IACT,MAAM;IACN,gCAAgC;AACpC;;AAEA;IACI,0BAA0B;AAC9B;;;AAGA,MAAM;;AAEN;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,mBAAmB;AACvB;;;;;;;;;;;;;AAaA;IACI;QACI,cAAc;QACd,UAAU;IACd;;IAEA;;;QAGI,eAAe;QACf,yBAAyB;IAC7B;AACJ;;AAEA;;IAEI;;;QAGI,eAAe;QACf,kBAAkB;IACtB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,kBAAkB;QAClB,iBAAiB;IACrB;;IAEA;QACI,kBAAkB;QAClB,cAAc;IAClB;AACJ;;AAEA;IACI;QACI,WAAW;IACf;;IAEA;;;QAGI,eAAe;QACf,mBAAmB;QACnB,yBAAyB;IAC7B;;IAEA;QACI,cAAc;QACd,WAAW;IACf;;IAEA;QACI,kBAAkB;IACtB;;IAEA;;;QAGI,uBAAuB;QACvB,eAAe;IACnB;AACJ;;AAEA;;IAEI;;;QAGI,uBAAuB;IAC3B;;IAEA;QACI,aAAa;QACb,6BAA6B;IACjC;;IAEA;QACI,aAAa;QACb,uBAAuB;IAC3B;;IAEA;;;QAGI,eAAe;QACf,iBAAiB;QACjB,yBAAyB;IAC7B;AACJ;;AAEA;IACI;QACI,uBAAuB;IAC3B;;IAEA;;;QAGI,eAAe;QACf,iBAAiB;QACjB,yBAAyB;IAC7B;;IAEA;QACI,WAAW;QACX,aAAa;QACb,uBAAuB;QACvB,YAAY;IAChB;;IAEA;QACI,aAAa;QACb,8BAA8B;IAClC;AACJ;;AAEA;;IAEI;;;QAGI,eAAe;QACf,SAAS;IACb;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;AACJ;;AAEA;IACI,kCAAkC;IAClC,WAAW;AACf;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,aAAa;IACb,eAAe;AACnB;;AAEA;;IAEI;;;QAGI,eAAe;QACf,iBAAiB;QACjB,gBAAgB;QAChB,yBAAyB;IAC7B;;IAEA;;;QAGI,eAAe;QACf,cAAc;QACd,SAAS;IACb;AACJ;;;;AAIA,mBAAmB;AACnB;IACI,8BAA8B;IAC9B,sBAAsB;IACtB,2BAA2B;AAC/B;;;AAGA;IACI,6BAA6B;;AAEjC;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;IACtB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,iCAAiC;IACjC,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,kCAAkC;AACtC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kCAAkC;IAClC,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,kCAAkC;IAClC,8BAA8B;IAC9B,yBAAyB;AAC7B;;AAEA;IACI,kCAAkC;IAClC,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,kCAAkC;IAClC,8BAA8B;IAC9B,yBAAyB;AAC7B;;AAEA;IACI,kCAAkC;IAClC,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,kCAAkC;IAClC,8BAA8B;IAC9B,yBAAyB;AAC7B;;AAEA;IACI,8BAA8B;IAC9B,kCAAkC;IAClC,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kCAAkC;IAClC,8BAA8B;IAC9B,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,8BAA8B;IAC9B,kCAAkC;IAClC,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kCAAkC;IAClC,8BAA8B;IAC9B,6BAA6B;AACjC;;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,8BAA8B;IAC9B,kCAAkC;IAClC,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kCAAkC;IAClC,8BAA8B;IAC9B,6BAA6B;AACjC;;AAEA;IACI,8BAA8B;IAC9B,kCAAkC;IAClC,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;IACzB,kCAAkC;IAClC,8BAA8B;IAC9B,6BAA6B;IAC7B,cAAc;AAClB;;AAEA;;;IAGI,kCAAkC;IAClC,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;IACzB,gBAAgB;IAChB,kCAAkC;IAClC,8BAA8B;AAClC;;AAEA;IACI,+BAA+B;IAC/B,4BAA4B;IAC5B,2BAA2B;IAC3B,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;;AAEvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;;;;;;;;IASI,kCAAkC;IAClC,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,kCAAkC;IAClC,8BAA8B;IAC9B,6BAA6B;IAC7B,cAAc;IACd,iBAAiB;AACrB;;AAEA;;;;;;IAMI,kCAAkC;IAClC,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;IACzB,mBAAmB;IACnB,kCAAkC;IAClC,8BAA8B;IAC9B,6BAA6B;IAC7B,cAAc;IACd,iBAAiB;AACrB;;AAEA;;;;;IAKI,kCAAkC;IAClC,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,kCAAkC;IAClC,8BAA8B;IAC9B,6BAA6B;IAC7B,cAAc;AAClB;;AAEA;IACI,wCAAwC;;AAE5C;;AAEA;;;IAGI,kCAAkC;IAClC,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,kCAAkC;IAClC,8BAA8B;IAC9B,6BAA6B;AACjC;;;AAGA,gBAAgB;AAChB;IACI,4BAA4B;IAC5B,+DAAmE;AACvE;;AAEA;IACI,oFAAmF;;IAEnF,sBAAsB;IACtB,aAAa;AACjB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,iDAAiD;IACjD,6BAA6B;IAC7B,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,MAAM;IACN,aAAa;IACb,gBAAgB;IAChB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,kCAAkC;IAClC,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,kCAAkC;IAClC,8BAA8B;IAC9B,6BAA6B;AACjC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA,iDAAiD;AACjD;IACI,WAAW;IACX,4DAA4D;IAC5D,kBAAkB;AACtB;;AAEA,yBAAyB;AACzB;;IAEI,aAAa;AACjB;;AAEA,yBAAyB;AACzB;IACI,kBAAkB;IAClB,8BAA8B;IAC9B,WAAW;IACX,qEAAqE;AACzE;;AAEA,kBAAkB;AAClB;IACI,WAAW;IACX,kBAAkB;IAClB,0CAA0C;IAC1C,aAAa;IACb,qBAAqB;IACrB,iBAAiB;IACjB,qDAAqD;AACzD;;AAEA,yBAAyB;AACzB;IACI,kBAAkB;IAClB,SAAS;IACT,0BAA0B;IAC1B,UAAU;IACV,2BAA2B;IAC3B,YAAY;IACZ,qBAAqB;IACrB,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,mBAAmB;IACnB,2CAA2C;IAC3C,qDAAqD;AACzD;;AAEA;IACI,6BAA6B;IAC7B,kCAAkC;IAClC,gBAAgB;IAChB,eAAe;AACnB;;;AAGA;IACI,WAAW;IACX,iBAAiB;IACjB,mCAAmC;IACnC,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,uBAAuB;IACvB,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,kCAAkC;AACtC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,2BAA2B;IAC3B,UAAU;AACd;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,wBAAwB;IACxB,4BAA4B;IAC5B,6BAA6B;AACjC;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,kCAAkC;IAClC,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,kCAAkC;IAClC,8BAA8B;IAC9B,6BAA6B;IAC7B,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kCAAkC;IAClC,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,kCAAkC;IAClC,8BAA8B;IAC9B,6BAA6B;AACjC;;AAEA;IACI,kCAAkC;IAClC,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,kCAAkC;IAClC,8BAA8B;IAC9B,6BAA6B;AACjC;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,uBAAuB;IACvB,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB;6DACyD;QACrD,iBAAiB;AACzB;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;;IAEI,iBAAiB;IACjB,sCAAsC;;IAEtC,kBAAkB;;AAEtB;;AAEA;;IAEI,kBAAkB;;IAElB,UAAU;IACV,iCAAiC;;IAEjC,SAAS;;IAET,2BAA2B;;IAE3B,YAAY;;IAEZ,aAAa;;IAEb,cAAc;;AAElB;;AAEA;;IAEI,YAAY;;IAEZ,aAAa;;IAEb,gBAAgB;IAChB,2BAA2B;;IAE3B,mBAAmB;;IAEnB,mBAAmB;;IAEnB,yBAAyB;;AAE7B;;AAEA;;IAEI,cAAc;IACd,wCAAwC;;IAExC,kBAAkB;;AAEtB;;AAEA;;IAEI,kCAAkC;;IAElC,eAAe;;IAEf,gBAAgB;;IAEhB,iBAAiB;;IAEjB,SAAS;;IAET,kBAAkB;;IAElB,SAAS;;IAET,kCAAkC;;IAElC,8BAA8B;;IAE9B,6BAA6B;;AAEjC;;AAEA;;IAEI,kCAAkC;;IAElC,eAAe;;IAEf,gBAAgB;;IAEhB,iBAAiB;;IAEjB,SAAS;;IAET,kBAAkB;;IAElB,SAAS;;IAET,kCAAkC;;IAElC,8BAA8B;;IAE9B,6BAA6B;;AAEjC;;AAEA;;IAEI,eAAe;;IAEf,YAAY;;IAEZ,gBAAgB;;IAEhB,uBAAuB;;IAEvB,YAAY;;IAEZ,mBAAmB;;IAEnB,aAAa;;IAEb,uBAAuB;;IAEvB,mBAAmB;;IAEnB;;8DAE0D;;AAE9D;;;AAGA;;IAEI,kBAAkB;;IAElB,WAAW;;AAEf;;AAEA;;IAEI,eAAe;;IAEf,gBAAgB;;IAEhB,uBAAuB;;IAEvB,aAAa;;IAEb,mBAAmB;;IAEnB,aAAa;;IAEb,uBAAuB;;IAEvB,mBAAmB;;IAEnB,mFAAmF;;AAEvF;;AAEA;;IAEI,kBAAkB;;AAEtB;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,iBAAiB;IACjB,6BAA6B;IAC7B,kCAAkC;IAClC,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,kCAAkC;IAClC,8BAA8B;IAC9B,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,kCAAkC;AACtC;;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,SAAS;IACT,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,4BAA4B;IAC5B,2BAA2B;IAC3B,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,kCAAkC;IAClC,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,kCAAkC;IAClC,8BAA8B;IAC9B,6BAA6B;AACjC;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,wCAAwC;IACxC;AACJ;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,UAAU;IACV,kCAAkC;IAClC,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,kCAAkC;IAClC,8BAA8B;IAC9B,6BAA6B;AACjC;;AAEA;IACI;QACI,cAAc;QACd,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,oFAA4F;QAC5F,sBAAsB;QACtB,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,iDAAiD;QACjD,6BAA6B;QAC7B,gBAAgB;QAChB,eAAe;IACnB;AACJ;;;AAGA;IACI,wCAAwC;AAC5C;;AAEA;IACI,iBAAiB;IACjB,6BAA6B;IAC7B,kCAAkC;IAClC,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,kCAAkC;IAClC,8BAA8B;IAC9B,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,kBAAkB;AACtB;;AAEA;;;;;GAKG;;AAEH;;;;;;;;;GASG;AACH;;;;;;;;GAQG;AACH;;;GAGG;;AAEH;;;;;;;;;;GAUG;;AAEH;;;;;;;;;GASG;AACH;IACI,iBAAiB;IACjB,sCAAsC;IACtC,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,iCAAiC;IACjC,SAAS;IACT,2BAA2B;IAC3B,YAAY;IACZ,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,2BAA2B;IAC3B,mBAAmB;IACnB,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,wCAAwC;IACxC,kBAAkB;AACtB;;AAEA;IACI,kCAAkC;IAClC,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,SAAS;IACT,kBAAkB;IAClB,SAAS;IACT,kCAAkC;IAClC,8BAA8B;IAC9B,6BAA6B;AACjC;;AAEA;;IAEI,kCAAkC;IAClC,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,SAAS;IACT,kBAAkB;IAClB,SAAS;IACT,kCAAkC;IAClC,8BAA8B;IAC9B,6BAA6B;IAC7B,YAAY;;AAEhB;;AAEA,iBAAiB;;;AAGjB;IACI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,iDAAiD;IACjD,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,kCAAkC;IAClC,8BAA8B;IAC9B,6BAA6B;IAC7B,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,gBAAgB;IAChB,WAAW;IACX,cAAc;IACd,uBAAuB;IACvB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,kBAAkB;IAClB,uBAAuB;IACvB,wCAAwC;IACxC,+BAA+B;IAC/B,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mCAAmC;AACvC;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,kBAAkB;IAClB,uBAAuB;IACvB,wCAAwC;IACxC,kBAAkB;AACtB;;;AAGA;IACI,WAAW;IACX,aAAa;IACb,wBAAwB;IACxB,wBAAwB;IACxB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,aAAa;IACb,iDAAiD;IACjD,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,kCAAkC;IAClC,8BAA8B;IAC9B,6BAA6B;AACjC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,oBAAoB;IACpB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,iDAAiD;IACjD,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,kCAAkC;IAClC,8BAA8B;IAC9B,6BAA6B;AACjC;;AAEA;IACI;QACI,iBAAiB;QACjB,WAAW;QACX,iDAAiD;QACjD,eAAe;QACf,gBAAgB;QAChB,iBAAiB;QACjB,mBAAmB;QACnB,kCAAkC;QAClC,8BAA8B;QAC9B,yBAAyB;QACzB,mBAAmB;QACnB,iBAAiB;QACjB,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,iBAAiB;QACjB,WAAW;QACX,iDAAiD;QACjD,eAAe;QACf,gBAAgB;QAChB,iBAAiB;QACjB,mBAAmB;QACnB,kCAAkC;QAClC,8BAA8B;QAC9B,yBAAyB;QACzB,mBAAmB;QACnB,iBAAiB;QACjB,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,WAAW;QACX,cAAc;QACd,kBAAkB;QAClB,uBAAuB;QACvB,oCAAoC;QACpC,+BAA+B;QAC/B,kBAAkB;IACtB;;IAEA;QACI,mBAAmB;QACnB,WAAW;QACX,aAAa;QACb,iDAAiD;QACjD,eAAe;QACf,gBAAgB;QAChB,iBAAiB;QACjB,kBAAkB;QAClB,kCAAkC;QAClC,8BAA8B;QAC9B,yBAAyB;IAC7B;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,aAAa;QACb,uBAAuB;QACvB,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,iBAAiB;QACjB,WAAW;QACX,YAAY;QACZ,iDAAiD;QACjD,eAAe;QACf,gBAAgB;QAChB,iBAAiB;QACjB,gBAAgB;QAChB,kCAAkC;QAClC,8BAA8B;QAC9B,yBAAyB;QACzB,mBAAmB;QACnB,eAAe;QACf,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,eAAe;QACf,uBAAuB;IAC3B;;IAEA;QACI,aAAa;QACb,cAAc;IAClB;AACJ;;AAEA;IACI;QACI,cAAc;IAClB;AACJ;;AAEA;IACI;QACI,mBAAmB;QACnB,WAAW;QACX,aAAa;QACb,iDAAiD;QACjD,eAAe;QACf,gBAAgB;QAChB,iBAAiB;QACjB,mBAAmB;QACnB,kCAAkC;QAClC,8BAA8B;QAC9B,yBAAyB;IAC7B;AACJ;;AAEA,cAAc;;AAEd;IACI,4BAA4B;IAC5B,+DAA2D;AAC/D;;AAEA;IACI,kBAAkB;IAClB,yDAAgD;IAChD,sBAAsB;IACtB,2BAA2B;IAC3B,aAAa;IACb,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,iDAAiD;IACjD,WAAW;AACf;;AAEA;IACI,WAAW;IACX,2CAA2C;IAC3C,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,2BAA2B;IAC3B,wBAAwB;IACxB,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,YAAY;IACZ,UAAU;AACd;;AAEA;IACI,2BAA2B;IAC3B,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,cAAc;IACd,aAAa;IACb,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,4BAA4B;AAChC;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,iDAAiD;IACjD,YAAY;IACZ,UAAU;IACV,6BAA6B;AACjC;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,wCAAwC;IACxC,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,aAAa;AACjB;;AAEA;IACI;QACI,WAAW;QACX,2CAA2C;QAC3C,WAAW;QACX,YAAY;QACZ,4BAA4B;QAC5B,wBAAwB;QACxB,wBAAwB;QACxB,kBAAkB;QAClB,QAAQ;QACR,OAAO;QACP,YAAY;QACZ,UAAU;IACd;;IAEA;QACI,SAAS;QACT,eAAe;QACf,gBAAgB;QAChB,iDAAiD;QACjD,YAAY;QACZ,UAAU;QACV,yBAAyB;IAC7B;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,2BAA2B;QAC3B,eAAe;QACf,cAAc;IAClB;AACJ;;AAEA;IACI;QACI,WAAW;QACX,2CAA2C;QAC3C,WAAW;QACX,YAAY;QACZ,4BAA4B;QAC5B,wBAAwB;QACxB,wBAAwB;QACxB,kBAAkB;QAClB,MAAM;QACN,OAAO;QACP,YAAY;QACZ,UAAU;IACd;;IAEA;QACI,oBAAoB;QACpB,0BAA0B;QAC1B,2BAA2B;QAC3B,iDAAiD;QACjD,qBAAqB;QACrB,2BAA2B;QAC3B,qBAAqB;QACrB,oCAAoC;QACpC,qBAAqB;QACrB,6BAA6B;IACjC;;IAEA;QACI,uBAAuB;QACvB,sBAAsB;QACtB,oCAAoC;QACpC,8BAA8B;IAClC;AACJ;;AAEA;IACI;QACI,SAAS;QACT,eAAe;QACf,gBAAgB;QAChB,iDAAiD;QACjD,YAAY;QACZ,UAAU;QACV,yBAAyB;IAC7B;;IAEA;QACI,YAAY;QACZ,WAAW;QACX,oCAAoC;QACpC,oBAAoB;IACxB;AACJ;;AAEA;IACI;QACI,oBAAoB;QACpB,0BAA0B;QAC1B,2BAA2B;QAC3B,iDAAiD;QACjD,sBAAsB;QACtB,2BAA2B;QAC3B,qBAAqB;QACrB,oCAAoC;QACpC,qBAAqB;QACrB,6BAA6B;IACjC;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,uBAAuB;QACvB,sBAAsB;QACtB,oCAAoC;QACpC,8BAA8B;IAClC;;IAEA;;;;;;;;;;;;OAYG;AACP;;AAEA;IACI;QACI,SAAS;QACT,eAAe;QACf,gBAAgB;QAChB,iDAAiD;QACjD,YAAY;QACZ,UAAU;QACV,yBAAyB;IAC7B;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,kBAAkB;QAClB,UAAU;QACV,cAAc;QACd,aAAa;QACb,kBAAkB;QAClB,UAAU;QACV,gBAAgB;QAChB,4BAA4B;IAChC;;IAEA;QACI,eAAe;IACnB;AACJ;;AAIA,gCAAgC;AAChC;IACI,kCAAkC;AACtC;;AAEA;IACI,cAAc;IACd,kCAAkC;IAClC,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,aAAa;IACb,mBAAmB;IACnB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,mFAAmF;AACvF;;AAEA;;GAEG;;AAEH;IACI,mBAAmB;AACvB;;AAEA,sDAAsD;;AAEtD,gBAAgB;AAChB;IACI,gCAAgC;IAChC,SAAS;IACT,UAAU;IACV,sBAAsB;AAC1B;;AAEA,oBAAoB;AACpB;IACI,kBAAkB;IAClB,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kCAAkC;IAClC,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,6BAA6B;IAC7B,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,kCAAkC;IAClC,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,6BAA6B;AACjC;;AAEA,2BAA2B;AAC3B;IACI;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA,UAAU;AACV;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,8BAA8B;AAClC;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,eAAe;IACf,sCAAsC;AAC1C;;AAEA;IACI,kCAAkC;IAClC,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA,+BAA+B;AAC/B;IACI,UAAU;AACd;;AAEA;IACI,UAAU;IACV,mBAAmB;IACnB,kBAAkB;IAClB,yCAAyC;AAC7C;;AAEA,sCAAsC;AACtC;IACI,kBAAkB;IAClB,0CAA0C;IAC1C,sBAAsB;IACtB,UAAU;IACV,gCAAgC;IAChC,kBAAkB;IAClB,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,eAAe;AACnB;;AAEA,kBAAkB;AAClB;IACI;QACI,cAAc;QACd,2BAA2B;IAC/B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,YAAY;QACZ,mBAAmB;QACnB,eAAe;QACf,4CAA4C;IAChD;AACJ;;AAEA;IACI;QACI,UAAU;QACV,eAAe;IACnB;;IAEA;QACI,mBAAmB;QACnB,UAAU;QACV,YAAY;IAChB;;IAEA;QACI,iBAAiB;QACjB,YAAY;QACZ,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,YAAY;QACZ,UAAU;QACV,eAAe;QACf,4CAA4C;IAChD;AACJ;;AAEA;IACI;QACI,eAAe;QACf,YAAY;QACZ,iBAAiB;QACjB,eAAe;QACf,4CAA4C;IAChD;AACJ;;AAEA,eAAe;AACf;IACI,4BAA4B;IAC5B,yBAAyB;IACzB,+DAA2D;IAC3D,mBAAmB;AACvB;;AAEA;IACI,oFAA8E;IAC9E,sBAAsB;IACtB,aAAa;AACjB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,iDAAiD;IACjD,6BAA6B;IAC7B,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,8BAA8B;AAClC;;AAEA;IACI,cAAc;IACd,kCAAkC;IAClC,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,kCAAkC;IAClC,8BAA8B;AAClC;;AAEA;IACI,6BAA6B;IAC7B,eAAe;IACf,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,cAAc;IACd,kCAAkC;IAClC,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,kCAAkC;IAClC,8BAA8B;IAC9B,yBAAyB;AAC7B;;AAEA;IACI,kCAAkC;IAClC,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,kCAAkC;IAClC,8BAA8B;IAC9B,yBAAyB;IACzB,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,kCAAkC;IAClC,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,kCAAkC;IAClC,8BAA8B;IAC9B,6BAA6B;AACjC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,wCAAwC;IACxC,iBAAiB;IACjB,wCAAwC;AAC5C;;AAEA;;IAEI,cAAc;IACd,UAAU;IACV,kCAAkC;IAClC,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,kCAAkC;IAClC,8BAA8B;AAClC;;AAEA;IACI,wCAAwC;IACxC,wCAAwC;AAC5C;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,aAAa;;AAEb;IACI,kBAAkB;IAClB,yDAAiD;IACjD,mCAAmC;IACnC,sBAAsB;IACtB,2BAA2B;IAC3B,aAAa;IACb,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,oCAAoC;IACpC,kBAAkB;IAClB,iDAAiD;IACjD,WAAW;IACX,6CAA6C;IAC7C,wBAAwB;AAC5B;;AAEA;IACI,WAAW;IACX,0DAA0D;IAC1D,wCAAwC;IACxC,8CAA8C;IAC9C,WAAW;IACX,sBAAsB;IACtB,YAAY;IACZ,6CAA6C;IAC7C,yBAAyB;IACzB,2BAA2B;IAC3B,wBAAwB;IACxB,+BAA+B;IAC/B,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,UAAU;IACV,qBAAqB;IACrB,UAAU;IACV,yCAAyC;AAC7C;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,2CAA2C;IAC3C,eAAe;IACf,aAAa;IACb,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,4BAA4B;AAChC;;AAEA;IACI,qBAAqB;IACrB,4BAA4B;IAC5B,wBAAwB;IACxB,4BAA4B;IAC5B,+BAA+B;IAC/B,mBAAmB;IACnB,6BAA6B;AACjC;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,iDAAiD;IACjD,WAAW;IACX,6BAA6B;IAC7B,kBAAkB;IAClB,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,wCAAwC;IACxC,6BAA6B;IAC7B,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,qBAAqB;IACrB,wBAAwB;IACxB,4BAA4B;IAC5B,+BAA+B;IAC/B,mBAAmB;IACnB,kCAAkC;IAClC,6BAA6B;IAC7B,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI;QACI,UAAU;QACV,iCAAiC;IACrC;;IAEA;QACI,SAAS;QACT,yBAAyB;IAC7B;;IAEA;QACI,OAAO;QACP,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB,UAAU;QACV,eAAe;QACf,aAAa;QACb,kBAAkB;QAClB,WAAW;QACX,gBAAgB;QAChB,4BAA4B;IAChC;AACJ;;AAEA;IACI;QACI,WAAW;QACX,0DAA0D;QAC1D,2CAA2C;QAC3C,WAAW;QACX,YAAY;QACZ,4BAA4B;QAC5B,wBAAwB;QACxB,wBAAwB;QACxB,kBAAkB;QAClB,QAAQ;QACR,OAAO;QACP,YAAY;QACZ,UAAU;IACd;;IAEA;QACI,SAAS;QACT,eAAe;QACf,gBAAgB;QAChB,iDAAiD;QACjD,YAAY;QACZ,UAAU;QACV,yBAAyB;IAC7B;AACJ;;AAEA;IACI;QACI,WAAW;QACX,2CAA2C;QAC3C,WAAW;QACX,YAAY;QACZ,4BAA4B;QAC5B,wBAAwB;QACxB,wBAAwB;QACxB,kBAAkB;QAClB,MAAM;QACN,OAAO;QACP,YAAY;QACZ,UAAU;QACV,gCAAgC;IACpC;;IAEA;QACI,oBAAoB;QACpB,0BAA0B;QAC1B,yCAAyC;QACzC,2BAA2B;QAC3B,iDAAiD;QACjD,qBAAqB;QACrB,6CAA6C;QAC7C,2BAA2B;QAC3B,iCAAiC;QACjC,qBAAqB;QACrB,qCAAqC;QACrC,oCAAoC;QACpC,qBAAqB;QACrB,6BAA6B;IACjC;;IAEA,iCAAiC;IACjC;QACI,uBAAuB;QACvB,sBAAsB;QACtB,oCAAoC;QACpC,8BAA8B;IAClC;AACJ;;AAEA;IACI;QACI,WAAW;IACf;AACJ;;AAEA;IACI;QACI,SAAS;QACT,eAAe;QACf,gBAAgB;QAChB,iDAAiD;QACjD,WAAW;QACX,UAAU;QACV,yBAAyB;IAC7B;AACJ;;AAEA;IACI;QACI,oBAAoB;QACpB,0BAA0B;QAC1B,2BAA2B;QAC3B,iDAAiD;QACjD,sBAAsB;QACtB,2BAA2B;QAC3B,qBAAqB;QACrB,oCAAoC;QACpC,qBAAqB;QACrB,6BAA6B;IACjC;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,uBAAuB;QACvB,sBAAsB;QACtB,oCAAoC;QACpC,8BAA8B;IAClC;;IAEA;QACI,gBAAgB;QAChB,kBAAkB;QAClB,eAAe;QACf,gBAAgB;QAChB,oCAAoC;QACpC,yBAAyB;QACzB,YAAY;QACZ,kBAAkB;QAClB,eAAe;QACf,kBAAkB;QAClB,qBAAqB;QACrB,wBAAwB;QACxB,4BAA4B;QAC5B,+BAA+B;QAC/B,mBAAmB;QACnB,6BAA6B;QAC7B,mBAAmB;QACnB,UAAU;IACd;AACJ;;AAEA;IACI;QACI,SAAS;QACT,eAAe;QACf,gBAAgB;QAChB,iDAAiD;QACjD,YAAY;QACZ,UAAU;QACV,yBAAyB;IAC7B;;IAEA;QACI,gBAAgB;QAChB,kBAAkB;QAClB,eAAe;QACf,gBAAgB;QAChB,oCAAoC;QACpC,yBAAyB;QACzB,YAAY;QACZ,kBAAkB;QAClB,eAAe;QACf,kBAAkB;QAClB,qBAAqB;QACrB,wBAAwB;QACxB,4BAA4B;QAC5B,+BAA+B;QAC/B,mBAAmB;QACnB,6BAA6B;QAC7B,mBAAmB;QACnB,UAAU;IACd;AACJ;;AAEA;IACI,2BAA2B;AAC/B;;AAEA,wCAAwC;AACxC;IACI,wBAAwB;IACxB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,wBAAwB;IACxB,qBAAqB;AACzB;;AAEA,gBAAgB;AAChB;IACI,gCAAgC;IAChC,SAAS;IACT,UAAU;IACV,sBAAsB;AAC1B;;AAEA,oBAAoB;AACpB;IACI,kBAAkB;IAClB,yCAAyC;IACzC,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,UAAU;IACV,UAAU;IACV,UAAU;IACV,QAAQ;IACR,YAAY;IACZ,kCAAkC;IAClC,eAAe;IACf,2BAA2B;IAC3B,iBAAiB;IACjB,gBAAgB;IAChB,wCAAwC;IACxC,8BAA8B;IAC9B,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,UAAU;IACV,UAAU;IACV,UAAU;IACV,QAAQ;IACR,kCAAkC;IAClC,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kCAAkC;IAClC,8BAA8B;IAC9B,8BAA8B;IAC9B,6BAA6B;AACjC;;AAEA,2BAA2B;AAC3B;IACI;QACI,sBAAsB;IAC1B;;IAEA;QACI,eAAe;QACf,YAAY;QACZ,eAAe;QACf,4CAA4C;IAChD;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA,UAAU;AACV;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,8BAA8B;AAClC;;AAEA;IACI,iBAAiB;IACjB,UAAU;IACV,eAAe;IACf,sCAAsC;AAC1C;;AAEA;IACI,kCAAkC;IAClC,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,kCAAkC;IAClC,8BAA8B;AAClC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;IACV,mBAAmB;IACnB,kBAAkB;IAClB,yCAAyC;IACzC,0BAA0B;AAC9B;;AAEA,sCAAsC;AACtC;IACI,0CAA0C;IAC1C,sBAAsB;IACtB,UAAU;IACV,gCAAgC;IAChC,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,4CAA4C;AAChD;;AAEA,kBAAkB;AAClB;IACI;QACI,4CAA4C;QAC5C,iCAAiC;QACjC,6BAA6B;IACjC;AACJ;;AAEA;IACI;QACI,WAAW;QACX,UAAU;QACV,UAAU;QACV,QAAQ;QACR,kCAAkC;QAClC,eAAe;QACf,gBAAgB;QAChB,iBAAiB;QACjB,qBAAqB;QACrB,kCAAkC;QAClC,8BAA8B;QAC9B,gBAAgB;QAChB,yBAAyB;IAC7B;;IAEA;QACI,4CAA4C;QAC5C,iCAAiC;QACjC,6BAA6B;IACjC;;IAEA;QACI,eAAe;QACf,WAAW;IACf;AACJ;;AAEA;IACI;QACI,oBAAoB;QACpB,qEAAqE;QACrE,6BAA6B;IACjC;;IAEA;QACI,2BAA2B;QAC3B,6BAA6B;IACjC;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB,WAAW;IACf;;IAEA;QACI,eAAe;QACf,YAAY;QACZ,UAAU;QACV,eAAe;QACf,4CAA4C;IAChD;AACJ;;AAEA;IACI;QACI,cAAc;QACd,2BAA2B;IAC/B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,YAAY;QACZ,mBAAmB;QACnB,eAAe;QACf,4CAA4C;IAChD;AACJ;;AAEA;IACI;QACI,iBAAiB;QACjB,UAAU;QACV,eAAe;IACnB;;IAEA;QACI,mBAAmB;QACnB,UAAU;QACV,YAAY;IAChB;;IAEA;QACI,iBAAiB;QACjB,YAAY;QACZ,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,YAAY;QACZ,UAAU;QACV,eAAe;QACf,4CAA4C;IAChD;AACJ;;AAEA;IACI;QACI,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,YAAY;QACZ,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,eAAe;QACf,YAAY;QACZ,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,2BAA2B;QAC3B,8BAA8B;IAClC;;IAEA;QACI,eAAe;QACf,YAAY;QACZ,mBAAmB;QACnB,eAAe;QACf,YAAY;QACZ,4CAA4C;IAChD;AACJ;;AAEA,2BAA2B;;AAE3B,6BAA6B;AAC7B;IACI,aAAa;IACb,WAAW;IACX,wCAAwC;IACxC,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,wBAAwB;IACxB,uBAAuB;IACvB,0BAA0B;IAC1B,4BAA4B;IAC5B,2BAA2B;IAC3B,0BAA0B;AAC9B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,kCAAkC;IAClC,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,kCAAkC;IAClC,8BAA8B;IAC9B,6BAA6B;AACjC;;AAEA;IACI,WAAW;IACX,0BAA0B;IAC1B,kCAAkC;IAClC,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,kCAAkC;IAClC,8BAA8B;IAC9B,6BAA6B;AACjC;;AAEA,4BAA4B;AAC5B;IACI,aAAa;IACb,eAAe;IACf,6BAA6B;IAC7B,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,+BAA+B;IAC/B,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,+BAA+B;IAC/B,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,kCAAkC;IAClC,eAAe;IACf,6BAA6B;IAC7B,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI;QACI,sBAAsB;QACtB,mBAAmB;QACnB,SAAS;IACb;AACJ;;AAEA,kBAAkB;AAClB;IACI;QACI,mBAAmB;QACnB,eAAe;QACf,SAAS,EAAE,uCAAuC;IACtD;;IAEA;QACI,eAAe,EAAE,wCAAwC;IAC7D;AACJ;;AAEA;IACI;QACI,eAAe;QACf,gBAAgB;QAChB,gBAAgB;QAChB,uBAAuB;IAC3B;AACJ;;AAEA;IACI;QACI,aAAa;QACb,WAAW;QACX,iBAAiB;QACjB,YAAY;QACZ,cAAc;QACd,oCAAoC;IACxC;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,aAAa;QACb,uBAAuB;QACvB,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,eAAe;IACnB;;IAEA;QACI,uBAAuB;QACvB,mBAAmB;QACnB,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,kBAAkB;QAClB,cAAc;IAClB;;IAEA;QACI,eAAe;QACf,0BAA0B;QAC1B,YAAY;QACZ,gBAAgB;IACpB;;IAEA;;;QAGI,eAAe;QACf,cAAc;QACd,SAAS;QACT,mBAAmB;QACnB;GACL;IACC;;AAEJ;;;;;AAKA;IACI;QACI,aAAa;QACb,WAAW;QACX,YAAY;QACZ,cAAc;QACd,oCAAoC;IACxC;;IAEA;QACI,uBAAuB;QACvB,mBAAmB;QACnB,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,iBAAiB;IACrB;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,kBAAkB;IACtB;;IAEA;QACI,wBAAwB;QACxB,sBAAsB;QACtB,mBAAmB;IACvB;;IAEA;QACI,uBAAuB;IAC3B;AACJ;;AAEA;IACI;QACI,aAAa;QACb,WAAW;QACX,YAAY;QACZ,cAAc;QACd,oCAAoC;IACxC;;IAEA;QACI,uBAAuB;QACvB,mBAAmB;QACnB,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,YAAY;QACZ,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,eAAe;QACf,WAAW;QACX,cAAc;IAClB;AACJ;;;AAGA,sBAAsB;;AAEtB,SAAS;;AAET,qDAAqD;AACrD;IACI,aAAa;IACb,8BAA8B;IAC9B,oDAAoD;IACpD,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA,kBAAkB;AAClB;IACI;;;;;;4BAMwB;IACxB,iBAAiB;IACjB,mBAAmB;IACnB,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;AAChB;;AAEA,kBAAkB;AAClB;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA,kBAAkB;AAClB;IACI,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,SAAS;IACT,YAAY;IACZ,gBAAgB;IAChB,0BAA0B;IAC1B,wBAAwB;IACxB,qBAAqB;IACrB,uBAAuB;IACvB,sBAAsB;IACtB,iBAAiB;IACjB,kBAAkB;IAClB,qCAAqC;IACrC,eAAe;IACf,qBAAqB;IACrB,kBAAkB;IAClB,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;AAC/B;;;AAGA,qCAAqC;AACrC;IACI,iBAAiB;IACjB,uBAAuB;IACvB,gBAAgB;IAChB,+BAA+B;IAC/B,qBAAqB;IACrB,yCAAyC;IACzC,6BAA6B;IAC7B,oBAAoB;AACxB;;AAEA,+CAA+C;AAC/C;IACI,UAAU;IACV,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;IAChB,0BAA0B;IAC1B,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA,SAAS;AACT;;;;;;;GAOG;;AAEH;IACI,aAAa;IACb,6BAA6B;IAC7B,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,2BAA2B;;AAE/B;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,cAAc;IACd,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,mCAAmC;IACnC,aAAa;IACb,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,sBAAsB;IACtB,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,6BAA6B;;;AAGjC;;AAEA;IACI,kCAAkC;IAClC,kBAAkB;IAClB,6BAA6B;;;AAGjC;;AAEA;;;;GAIG;;AAEH;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,6BAA6B;IAC7B,iCAAiC;IACjC,mBAAmB;IACnB,6BAA6B;IAC7B,iCAAiC;IACjC,2CAA2C;IAC3C,kBAAkB;IAClB,uCAAuC;IACvC,kBAAkB;IAClB,+CAA+C;AACnD;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,6CAA6C;IAC7C,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;AACrB;;AAEA;IACI,SAAO;AACX;;AAEA;IACI,SAAS;IACT,eAAe;IACf,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,8CAA8C;IAC9C,aAAa;IACb,oBAAoB;IACpB,kCAAkC;IAClC,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,WAAW;IACX,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,eAAe;AACf;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,mBAAmB;AACnB;IACI,sBAAsB;AAC1B;;AAEA;IACI,4BAA4B;IAC5B;8DACkD;IAClD,mBAAmB;IACnB,kBAAkB;AACtB;;;AAGA;IACI,2BAA2B;IAC3B,wCAAwC;IACxC,gBAAgB;IAChB,eAAe;IACf,oBAAoB;IACpB,kBAAkB;IAClB,kBAAkB;;;AAGtB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;IACtB,WAAW;IACX,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,SAAS;AACb;;AAEA;IACI,qCAAqC;IACrC,kBAAkB;IAClB,kCAAkC;IAClC,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,2BAA2B;IAC3B,kCAAkC;IAClC,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,qCAAqC;IACrC,kBAAkB;IAClB,cAAc;IACd,kCAAkC;IAClC,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,qCAAqC;IACrC,kBAAkB;IAClB,kCAAkC;IAClC,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,UAAU;AACd;;AAEA;IACI,SAAS;IACT,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,6CAA6C;IAC7C,kCAAkC;IAClC,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,6BAA6B;IAC7B,SAAS;IACT,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,qCAAqC;IACrC,kBAAkB;IAClB,kCAAkC;IAClC,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,SAAS;AACb;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,WAAW;IACX,WAAW;AACf;;AAEA;IACI,qCAAqC;IACrC,iBAAiB;IACjB,kCAAkC;IAClC,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,SAAS;AACb;;AAEA;;IAEI,kCAAkC;IAClC,kCAAkC;IAClC,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,kCAAkC;IAClC,kCAAkC;IAClC,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA,oBAAoB;AACpB;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;IACT,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,OAAO;IACP,WAAW;IACX,aAAa;IACb,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,SAAS;IACb;;IAEA;QACI,aAAa;QACb,uBAAuB;QACvB,SAAS;QACT,eAAe;QACf,sBAAsB;IAC1B;;IAEA;QACI,aAAa;QACb,gBAAgB;QAChB,aAAa;QACb,sBAAsB;QACtB,mBAAmB;QACnB,qBAAqB;QACrB,oBAAoB;IACxB;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,yBAAyB;QACzB,mBAAmB;QACnB,WAAW;QACX,WAAW;IACf;AACJ;;;AAGA,qBAAqB;AACrB;IACI,eAAe;IACf,WAAW;IACX,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;IACtB,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,qBAAqB;IACrB,YAAY;IACZ,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,SAAS;AACb;;AAEA;IACI,qCAAqC;IACrC,kBAAkB;IAClB,kCAAkC;IAClC,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI;QACI,gBAAgB;QAChB,gBAAgB;QAChB,aAAa;QACb,gBAAgB;QAChB,kBAAkB;IACtB;AACJ;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA,eAAe;AACf;IACI,6BAA6B;IAC7B,0BAA0B;IAC1B,kCAAkC;IAClC,gBAAgB;IAChB,eAAe;IACf,oBAAoB;IACpB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,wCAAwC;;AAE5C;;AAEA;IACI,wCAAwC;IACxC,YAAY;;AAEhB;;AAEA;;;;IAII,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,wCAAwC;AAC5C;;;;;AAKA,uDAAuD;AACvD;IACI,wCAAwC;IACxC,WAAW;IACX,gCAAgC;AACpC;;AAEA,qCAAqC;AACrC;;IAEI,gDAAgD;IAChD,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,YAAY;IACZ,iBAAiB;AACrB;;AAEA,oBAAoB;AACpB;IACI,oFAAwF;IACxF,sBAAsB;IACtB,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,wCAAwC;IACxC,4BAA4B;IAC5B,yBAAyB;AAC7B;;AAEA;IACI,wCAAwC;IACxC,gBAAgB;IAChB,kCAAkC;IAClC,eAAe;AACnB;;AAEA;IACI,wCAAwC;IACxC,kCAAkC;IAClC,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,wCAAwC;IACxC,gBAAgB;IAChB,kCAAkC;IAClC,eAAe;;AAEnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;;AAE9B;;AAEA;IACI,wBAAwB;IACxB,6CAA6C;IAC7C,wBAAwB;IACxB,iCAAiC;AACrC;;AAEA;IACI,YAAY;IACZ,sEAAsE;AAC1E;;AAEA;IACI,UAAU;IACV,oBAAoB;AACxB;;AAEA;IACI,wCAAwC;IACxC;AACJ;;AAEA;IACI,gBAAgB;IAChB,kCAAkC;IAClC,0BAA0B;AAC9B;;AAEA;IACI,kCAAkC;IAClC,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,wCAAwC;IACxC,mBAAmB;;AAEvB;;AAEA;IACI,6BAA6B;IAC7B,kCAAkC;IAClC,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;IAChB,kCAAkC;IAClC,0BAA0B;AAC9B;;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;IAChB,kCAAkC;IAClC,eAAe;AACnB;;AAEA;IACI,wCAAwC;IACxC,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,YAAY;AAChB;;AAEA,yBAAyB;;AAEzB,cAAc;;AAEd;IACI,wCAAwC;AAC5C;;AAEA;IACI,iBAAiB;IACjB,6BAA6B;IAC7B,kCAAkC;IAClC,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,kBAAkB;;AAEtB;;AAEA;IACI,sBAAsB;IACtB,YAAY;IACZ,wBAAwB;IACxB,aAAa;;AAEjB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,2BAA2B;IAC3B,YAAY;IACZ,aAAa;IACb,SAAS;IACT,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;IACnB,yBAAyB;IACzB,aAAa;AACjB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kCAAkC;IAClC,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,kCAAkC;IAClC,8BAA8B;IAC9B,6BAA6B;AACjC;;AAEA;IACI,kCAAkC;IAClC,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,kCAAkC;IAClC,8BAA8B;IAC9B,6BAA6B;AACjC;;AAEA,qBAAqB;;AAErB;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,UAAU;IACV,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,2CAA2C;EAC7C;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,gCAAgC;IAChC,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,WAAW;EACb;;CAED,kBAAkB;AACnB;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,0BAA0B;EAC5B;;EAEA,cAAc;EACd;IACE,4BAA4B;IAC5B,uBAAuB;IACvB,aAAa;IACb,8BAA8B;IAC9B,kBAAkB;IAClB,yCAAyC;IACzC,gCAAgC;EAClC;;;EAGA,gBAAgB;EAChB;IACE,eAAe;IACf,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA,kBAAkB;EAClB;IACE,eAAe;IACf,WAAW;IACX,mBAAmB;EACrB;;EAEA,kBAAkB;EAClB;IACE,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,YAAY;IACZ,aAAa;IACb,4BAA4B;EAC9B;;EAEA;IACE,yBAAyB;IACzB,YAAY;EACd;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,uBAAuB;IACvB,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,mBAAmB;EACrB;AACF;IACI,6BAA6B;AACjC;AACA;IACI,sDAAsD;IACtD,uBAAuB;IACvB,gCAAgC;AACpC;;AAEA,kBAAkB,2CAA2C;IACzD,iBAAiB,EAAE,6BAA6B;AACpD;AACA;;;IAGI,iBAAiB,EAAE,oBAAoB;AAC3C","sourcesContent":["body {\n    margin: 0;\n    padding: 0;\n    box-sizing: border-box;\n}\n\n.Title {\n    font-size: 32px;\n    font-weight: 500;\n    color: #6B8E76;\n    padding: 0 0 30px 0;\n    margin-right: 59%;\n}\n\n.MainContainerPadding {\n    padding: 0 50px;\n}\n\n.custom-footer .footer-links {\n    margin-left: -10%;\n}\n\n.custom-footer .footer-legal {\n    margin-left: 50%;\n    margin-top: -210px;\n}\n\nheader a.nav-link {\n    font-size: 20px;\n    color: #6B8E76;\n    font-weight: 400;\n    padding: 12px 20px !important;\n}\n\nheader .LoginBtn {\n    background-color: #6B8E76;\n    border-radius: 10px;\n    color: #fff !important;\n    padding: 0px 20px !important;\n    line-height: 24px;\n    font-size: 20px !important;\n    height: 48px;\n    width: 120px;\n    text-align: center;\n}\n\n.custom-footer {\n    background-color: #6f8d77;\n    color: #ffffff;\n    font-family: \"Public Sans\", sans-serif;\n    padding: 40px 0;\n}\n\n.custom-footer .footer-about,\n.custom-footer .footer-links,\n.custom-footer .footer-legal {\n    font-family: Poppins, \"sans-serif\";\n}\n\n.custom-footer .footer-links {\n    margin-left: -10%;\n}\n\n.custom-footer .footer-legal {\n    margin-left: 50%;\n    margin-top: -210px;\n}\n\nh5.links.mb-3 {\n    font-size: 17px;\n}\n\n.custom-footer .footer-about p.description,\n.custom-footer .footer-links p.description,\n.custom-footer .footer-legal p.description {\n    width: 100%;\n    font-size: 16px;\n    font-weight: 400;\n    line-height: 24px;\n    text-align: left;\n    text-underline-position: from-font;\n    text-decoration-skip-ink: none;\n    color: rgba(255, 255, 255, 1);\n    margin-top: 3%;\n}\n\n.custom-footer .footer-about .contact-info,\n.custom-footer .footer-links .contact-info,\n.custom-footer .footer-legal .contact-info {\n    display: flex;\n    flex-direction: column;\n    margin-top: 3%;\n}\n\n.custom-footer .footer-about .contact-info .contact-box-call,\n.custom-footer .footer-links .contact-info .contact-box-call,\n.custom-footer .footer-legal .contact-info .contact-box-call {\n    background-color: rgba(255, 255, 255, 0.1);\n    border: 1px solid rgba(255, 255, 255, 0.3);\n    border-radius: 8px;\n    padding: 15px;\n    max-width: fit-content;\n    color: rgba(255, 255, 255, 1) !important;\n    font-size: 14px;\n    line-height: 1.6;\n    display: flex;\n    align-items: center;\n    font-family: \"Public Sans\", sans-serif;\n    height: 36px;\n    background-color: rgba(121, 155, 132, 1);\n}\n\n.custom-footer .footer-about .contact-info .contact-box-call:hover,\n.custom-footer .footer-links .contact-info .contact-box-call:hover,\n.custom-footer .footer-legal .contact-info .contact-box-call:hover {\n    color: #fff;\n    background-color: rgba(255, 255, 255, 0.2);\n}\n\n.custom-footer .footer-about .contact-info .contact-box-mail,\n.custom-footer .footer-links .contact-info .contact-box-mail,\n.custom-footer .footer-legal .contact-info .contact-box-mail {\n    background-color: rgba(255, 255, 255, 0.1);\n    border: 1px solid rgba(255, 255, 255, 0.3);\n    border-radius: 8px;\n    padding: 15px;\n    max-width: max-content;\n    color: rgba(255, 255, 255, 1) !important;\n    font-size: 14px;\n    line-height: 1.6;\n    display: flex;\n    align-items: center;\n    font-family: \"Public Sans\", sans-serif;\n    height: 36px;\n    background-color: rgba(121, 155, 132, 1);\n    text-decoration: none;\n}\n\n.custom-footer .footer-about .contact-info .contact-box-mail:hover,\n.custom-footer .footer-links .contact-info .contact-box-mail:hover,\n.custom-footer .footer-legal .contact-info .contact-box-mail:hover {\n    color: #fff;\n    background-color: rgba(255, 255, 255, 0.2);\n}\n\n.custom-footer .footer-links ul li a,\n.custom-footer .footer-legal ul li a {\n    font-size: 14px;\n    line-height: 1.8;\n    position: relative;\n    display: inline-block;\n    padding-left: 10px;\n    text-decoration: none;\n    overflow: hidden;\n    white-space: nowrap;\n    color: #ffffff;\n    transition: all 0.3s ease;\n    width: -webkit-fill-available;\n    margin-left: -10px;\n}\n\n.custom-footer .footer-bottom {\n    padding-top: 20px;\n}\n\n.custom-footer .footer-bottom p {\n    font-size: 12px;\n    margin: 0;\n}\n\n.SMN_effect-31 a {\n    position: relative;\n    overflow: hidden;\n    display: block;\n    text-align: center;\n    flex-grow: 1;\n    animation-duration: 1s;\n    animation-fill-mode: both;\n    padding: 0;\n    width: fit-content;\n}\n\nul.menu.align-center.expanded.text-center.SMN_effect-31 {\n    list-style: none;\n}\n\n.SMN_effect-31 a span {\n    display: block;\n    transition: transform 500ms cubic-bezier(0.68, -0.55, 0.265, 1.55);\n}\n\n.SMN_effect-31 a:after {\n    content: \"\";\n    height: 2px;\n    color: #ffffff;\n    font-size: 14px;\n    height: 2px;\n    position: absolute;\n    top: 0;\n    left: 100%;\n    right: 0;\n    bottom: 0;\n    text-align: center;\n    transition: left 500ms cubic-bezier(0.68, -0.55, 0.265, 1.55);\n    width: fit-content;\n}\n\n.SMN_effect-31 a:hover {\n    color: #ffffff;\n}\n\n.SMN_effect-31 a:hover span {\n    color: #ffffff !important;\n    transform: translateX(100%);\n    animation: hover-list 15s ease-in-out forwards;\n}\n\n@keyframes hover-list {\n    0% {\n        opacity: 0;\n    }\n\n    50% {\n        opacity: 0.9;\n    }\n\n    100% {\n        opacity: 0;\n    }\n}\n\n.SMN_effect-31 a:hover:after {\n    content: \"• \" attr(data-hover);\n    left: 20%;\n    top: 0;\n    transition: all 0.3s ease-in-out;\n}\n\n.SMN_effect-31 a:active {\n    animation-name: rubberBand;\n}\n\n\n.Why {}\n\n.Why .WhyImg {\n    border-radius: 10px;\n}\n\n.Why .WhyImg img {\n    width: 100%;\n    border-radius: 14px;\n}\n\n\n\n\n\n\n\n\n\n\n\n\n@media (max-width: 1200px) {\n    .col-xl-4 {\n        flex: 0 0 auto;\n        width: 40%;\n    }\n\n    .custom-footer .footer-about p.description,\n    .custom-footer .footer-links p.description,\n    .custom-footer .footer-legal p.description {\n        font-size: 14px;\n        color: rgb(255, 255, 255);\n    }\n}\n\n@media (max-width: 480px) {\n\n    .custom-footer .footer-about p.description,\n    .custom-footer .footer-links p.description,\n    .custom-footer .footer-legal p.description {\n        font-size: 15px;\n        text-align: center;\n    }\n\n    .footer-logo {\n        margin: auto;\n    }\n\n    .col-xl-4.col-xs-12.col-md-3.col-sm-6.footer-links {\n        text-align: center;\n        margin-bottom: 2%;\n    }\n\n    .col-xl-4.col-xs-12.col-md-3.col-sm-6.mb-4.footer-legal {\n        text-align: center;\n        margin-top: 5%;\n    }\n}\n\n@media (max-width: 576px) {\n    .col-xl-4.col-xs-12.col-md-3.col-sm-6.mb-4.footer-about {\n        width: 100%;\n    }\n\n    .custom-footer .footer-about p.description,\n    .custom-footer .footer-links p.description,\n    .custom-footer .footer-legal p.description {\n        font-size: 17px;\n        text-align: justify;\n        color: rgb(255, 255, 255);\n    }\n\n    .col-sm-6 {\n        flex: 0 0 auto;\n        width: 100%;\n    }\n\n    .row {\n        text-align: center;\n    }\n\n    .custom-footer .footer-about .contact-info,\n    .custom-footer .footer-links .contact-info,\n    .custom-footer .footer-legal .contact-info {\n        justify-content: center;\n        margin-top: 10%;\n    }\n}\n\n@media (max-width: 768px) {\n\n    .custom-footer .footer-about .contact-info,\n    .custom-footer .footer-links .contact-info,\n    .custom-footer .footer-legal .contact-info {\n        justify-content: center;\n    }\n\n    .col-xl-4.col-xs-12.col-md-12.col-sm-12.all-links {\n        display: flex;\n        justify-content: space-around;\n    }\n\n    .contact-info {\n        display: flex;\n        justify-content: center;\n    }\n\n    .custom-footer .footer-about p.description,\n    .custom-footer .footer-links p.description,\n    .custom-footer .footer-legal p.description {\n        font-size: 18px;\n        line-height: 26px;\n        color: rgb(255, 255, 255);\n    }\n}\n\n@media (max-width: 992px) {\n    .contact-info {\n        justify-content: center;\n    }\n\n    .custom-footer .footer-about p.description,\n    .custom-footer .footer-links p.description,\n    .custom-footer .footer-legal p.description {\n        font-size: 19px;\n        line-height: 23px;\n        color: rgb(255, 255, 255);\n    }\n\n    .col-xl-4.col-xs-12.col-md-6.col-sm-12.all-links {\n        width: 100%;\n        display: flex;\n        justify-content: center;\n        margin: auto;\n    }\n\n    .row {\n        display: flex;\n        justify-content: space-between;\n    }\n}\n\n@media (max-width: 1024px) {\n\n    .custom-footer .footer-about .contact-info,\n    .custom-footer .footer-links .contact-info,\n    .custom-footer .footer-legal .contact-info {\n        flex-wrap: wrap;\n        gap: 15px;\n    }\n\n    .col-xl-4.col-xs-12.col-md-6.col-sm-12.all-links {\n        width: 100%;\n        margin: auto;\n    }\n}\n\n.align-items-start {\n    align-items: flex-start !important;\n    width: 100%;\n}\n\n.justify-content-between {\n    justify-content: space-between !important;\n}\n\n.row {\n    --bs-gutter-x: 1.5rem;\n    --bs-gutter-y: 0;\n    display: flex;\n    flex-wrap: wrap;\n}\n\n@media (max-width: 1440px) {\n\n    .custom-footer .footer-about p.description,\n    .custom-footer .footer-links p.description,\n    .custom-footer .footer-legal p.description {\n        font-size: 17px;\n        line-height: 26px;\n        text-align: left;\n        color: rgb(255, 255, 255);\n    }\n\n    .custom-footer .footer-about .contact-info,\n    .custom-footer .footer-links .contact-info,\n    .custom-footer .footer-legal .contact-info {\n        flex-wrap: wrap;\n        margin-top: 2%;\n        gap: 15px;\n    }\n}\n\n\n\n/* privacy policy */\nnav.navbar.navbar-expand-lg.navbar-light {\n    background: #6f8d77 !important;\n    color: #fff !important;\n    box-shadow: none !important;\n}\n\n\n.main-policy {\n    color: rgba(103, 103, 103, 1);\n    ;\n}\n\n.row-nav-profile .nav-link {\n    height: fit-content;\n    color: #fff !important;\n    padding: 5px !important;\n    border-radius: 4px;\n}\n\n.row-nav-profile .nav-link:hover {\n    color: #6f8d77 !important;\n    background-color: #fff !important;\n    border-radius: 4px;\n}\n\n.policy-container {\n    background-color: white;\n    padding: 40px 20px;\n    font-family: \"Poppins\", sans-serif;\n}\n\n.policy-container .privacy-policy-content {\n    padding: 30px;\n}\n\n.policy-container .privacy-policy-content .head-title {\n    width: 100%;\n}\n\np.info-title {\n    font-weight: 500;\n}\n\nspan.child-titles {\n    font-family: \"Poppins\", sans-serif;\n    font-size: 16px;\n    font-weight: 500;\n    line-height: 24px;\n    text-align: left;\n    text-underline-position: from-font;\n    text-decoration-skip-ink: none;\n    color: rgb(107, 142, 118);\n}\n\nspan.Cookies-child-titles {\n    font-family: \"Poppins\", sans-serif;\n    font-size: 16px;\n    font-weight: 500;\n    line-height: 24px;\n    text-align: left;\n    text-underline-position: from-font;\n    text-decoration-skip-ink: none;\n    color: rgb(107, 142, 118);\n}\n\nspan.Your-rights-child-titles {\n    font-family: \"Poppins\", sans-serif;\n    font-size: 16px;\n    font-weight: 500;\n    line-height: 24px;\n    text-align: left;\n    text-underline-position: from-font;\n    text-decoration-skip-ink: none;\n    color: rgb(107, 142, 118);\n}\n\n.policy-container .privacy-policy-content .policy-heading {\n    text-align: justify !important;\n    font-family: \"Poppins\", sans-serif;\n    font-size: 24px;\n    font-weight: 500;\n    line-height: 36px;\n    text-underline-position: from-font;\n    text-decoration-skip-ink: none;\n    color: rgba(107, 142, 118, 1);\n    margin-bottom: 0.5%;\n}\n\n.policy-container .privacy-policy-content .policy-content {\n    margin-bottom: 2%;\n}\n\n.policy-container .privacy-policy-content .policy-content p {\n    text-align: justify !important;\n    font-family: \"Poppins\", sans-serif;\n    font-size: 20px;\n    font-weight: 400;\n    line-height: 28px;\n    text-underline-position: from-font;\n    text-decoration-skip-ink: none;\n    color: rgba(103, 103, 103, 1);\n}\n\n.policy-container .privacy-policy-content .policy-content p .iso-title {\n    color: rgba(107, 142, 118, 1);\n    font-weight: 600;\n    font-size: 20px;\n}\n\n.policy-container .about-heading {\n    text-align: justify !important;\n    font-family: \"Poppins\", sans-serif;\n    font-size: 22px;\n    font-weight: 500;\n    line-height: 33px;\n    text-underline-position: from-font;\n    text-decoration-skip-ink: none;\n    color: rgba(107, 142, 118, 1);\n}\n\n.policy-container .about-content {\n    text-align: justify !important;\n    font-family: \"Poppins\", sans-serif;\n    font-size: 16px;\n    font-weight: 400;\n    line-height: 28px;\n    letter-spacing: -0.0015em;\n    text-underline-position: from-font;\n    text-decoration-skip-ink: none;\n    color: rgba(103, 103, 103, 1);\n    margin-top: 1%;\n}\n\n.policy-container .about-content .about-iso,\n.policy-container .about-content .address,\n.policy-container .about-content .website-link {\n    font-family: \"Poppins\", sans-serif;\n    font-size: 16px;\n    font-weight: 600;\n    line-height: 28px;\n    letter-spacing: -0.0015em;\n    text-align: left;\n    text-underline-position: from-font;\n    text-decoration-skip-ink: none;\n}\n\n.policy-container .about-content .website-link {\n    text-decoration-line: underline;\n    text-decoration-style: solid;\n    color: rgba(0, 122, 255, 1);\n    cursor: pointer;\n}\n\n.child-Data-Sharing-heading {\n    line-height: 30px;\n    margin-bottom: 15px;\n\n}\n\np.cookie-title {\n    font-weight: 500;\n}\n\n.cookie-head-title {\n    margin-bottom: 17px;\n    margin-top: 17px;\n}\n\n.Cookies-content {\n    line-height: 29px;\n}\n\n.Data-Retention-titles {\n    margin-top: 10px;\n    margin-bottom: 10px;\n}\n\n.Data-Retentionchild-content {\n    margin-bottom: 10px;\n}\n\n.Your-rights-heading {\n    margin-bottom: 20px;\n}\n\n.policy-container .Information-heading,\n.policy-container .Data-Collection-heading,\n.policy-container .Data-Sharing-heading,\n.policy-container .Cookies-heading,\n.policy-container .Data-Retentionchild-titles,\n.policy-container .Your-rights-titles,\n.policy-container .Security-titles,\n.policy-container .Updates-titles,\n.policy-container .Contact-titles {\n    font-family: \"Poppins\", sans-serif;\n    font-size: 22px;\n    font-weight: 500;\n    line-height: 33px;\n    text-align: left;\n    text-underline-position: from-font;\n    text-decoration-skip-ink: none;\n    color: rgba(107, 142, 118, 1);\n    margin-top: 1%;\n    margin-bottom: 1%;\n}\n\n.policy-container .Information-content,\n.policy-container .Data-Collection-content,\n.policy-container .Data-Sharing-content,\n.policy-container .Updates-content,\n.policy-container .Contact-content,\n.policy-container .Your-rights-content {\n    font-family: \"Poppins\", sans-serif;\n    font-size: 16px;\n    font-weight: 400;\n    line-height: 30px;\n    letter-spacing: -0.0015em;\n    text-align: justify;\n    text-underline-position: from-font;\n    text-decoration-skip-ink: none;\n    color: rgba(103, 103, 103, 1);\n    margin-top: 1%;\n    margin-bottom: 1%;\n}\n\n.policy-container .Information-content .information-point,\n.policy-container .Data-Sharing-content .child-Data-Sharing-heading,\n.policy-container .Data-Sharing-content .child-Data-Sharing-heading .child-titles,\n.policy-container .Cookies-content .Cookies-point,\n.policy-container .Your-rights-content .Your-rights-child-titles {\n    font-family: \"Poppins\", sans-serif;\n    font-size: 16px;\n    font-weight: 400;\n    line-height: 24px;\n    text-align: left;\n    text-underline-position: from-font;\n    text-decoration-skip-ink: none;\n    color: rgba(103, 103, 103, 1);\n    margin-top: 1%;\n}\n\n.contacts {\n    color: rgba(103, 103, 103, 1) !important;\n    ;\n}\n\n.policy-container .Cookies-content .google-text,\n.policy-container .Cookies-content .note,\n.policy-container .contacts {\n    font-family: \"Poppins\", sans-serif;\n    font-size: 16px;\n    font-weight: 600;\n    line-height: 28px;\n    text-align: left;\n    text-underline-position: from-font;\n    text-decoration-skip-ink: none;\n    color: rgba(107, 142, 118, 1);\n}\n\n\n/* brand pagee */\n@font-face {\n    font-family: \"FantasyMagist\";\n    src: url(\"../../Assets/Img/FANTASY\\ MAGIST.otf\") format(\"opentype\");\n}\n\n.brand-container .brand-hero-section {\n    background: rgba(0, 0, 0, 0.5) url(\"../../Assets/Img/brandLabel.png\") center center;\n\n    background-size: cover;\n    height: 400px;\n}\n\n.brand-container .brand-hero-section .text-center {\n    margin-top: 21%;\n}\n\n.brand-container .brand-hero-section .text-center .hero-title {\n    font-family: \"FantasyMagist\", \"Arial\", sans-serif;\n    color: rgba(245, 242, 231, 1);\n    font-weight: 400;\n}\n\n.brand-container .brand-hero-section .brand-hero-title {\n    margin-top: 5%;\n    font-size: 24px;\n    border-bottom: 2px solid black;\n}\n\n.brand-container .slider .slider-overlay-text {\n    width: fit-content;\n    position: absolute;\n    top: 0;\n    padding: 28px;\n    text-align: left;\n    font-size: 26px;\n    color: #fff;\n}\n\n.brand-container .slider .slider-overlay-text h2 {\n    font-size: 3rem;\n    margin-top: 3rem;\n    transition: all 0.3s ease;\n    width: 23rem;\n}\n\n.brand-container .why-marketing .brand-section-title {\n    width: 100%;\n    font-family: \"Poppins\", sans-serif;\n    font-size: 32px;\n    font-weight: 600;\n    line-height: 48px;\n    text-align: left;\n    text-underline-position: from-font;\n    text-decoration-skip-ink: none;\n    color: rgba(107, 142, 118, 1);\n}\n\n.brand-container .why-marketing .card {\n    border: none;\n}\n\n.brand-container .why-marketing .card .image-container {\n    position: relative;\n    overflow: hidden;\n    border-radius: 6px;\n}\n\n/* Ensure the slider container spans full width */\n.fresh-slides {\n    width: 100%;\n    /* Ensure the slider spans the full width of the container */\n    position: relative;\n}\n\n/* Hide arrows and dots */\n.fresh-slides .slick-arrow,\n.fresh-slides .slick-dots {\n    display: none;\n}\n\n/* Container for images */\n.image-container {\n    position: relative;\n    /* Position for overlay text */\n    width: 100%;\n    /* Make sure the image container spans the full width of the slider */\n}\n\n/* Image styling */\n.fresh-slides img {\n    width: 102%;\n    margin-left: -10px;\n    /* Ensure the image takes the full width */\n    height: 400px;\n    /* Set fixed height */\n    object-fit: cover;\n    /* Ensure images cover the space without distortion */\n}\n\n/* Overlay text styling */\n.slider-text {\n    position: absolute;\n    top: 20px;\n    /* Position from the top */\n    left: 20px;\n    /* Position from the left */\n    color: white;\n    /* White text color */\n    font-size: 24px;\n    /* Text size */\n    font-weight: bold;\n    /* Make text bold */\n    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);\n    /* Optional: adds shadow to make text more readable */\n}\n\n.key-trend {\n    color: rgba(245, 242, 231, 1);\n    font-family: \"Poppins\", sans-serif;\n    font-weight: 500;\n    font-size: 20px;\n}\n\n\n.why-marketing .card .card-img-top {\n    width: 100%;\n    object-fit: cover;\n    transition: filter 0.3s ease-in-out;\n    height: 289px;\n    filter: grayscale(100%);\n}\n\n.why-marketing .card .overlay-text {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    color: #fff;\n    padding: 10px;\n    text-align: center;\n    transition: all 1s ease;\n    opacity: 1;\n    overflow: hidden;\n}\n\n.why-marketing .card .overlay-text .card-text {\n    font-size: 32px;\n    font-weight: 600;\n    font-family: \"Poppins\", sans-serif;\n}\n\n.why-marketing .card:hover .card-img-top {\n    filter: grayscale(0%);\n}\n\n.why-marketing .card:hover .overlay-text {\n    transform: translateY(100%);\n    opacity: 0;\n}\n\n.why-marketing .row {\n    margin-bottom: 1.5rem;\n}\n\n.carousel-item img {\n    height: 300px !important;\n    object-fit: cover !important;\n    border-radius: 8px !important;\n}\n\n.hero-title {\n    font-size: 2.5rem;\n    font-weight: bold;\n}\n\n.brand-container hr {\n    width: 50px;\n    border: 2px solid #fff;\n    margin: auto;\n}\n\n.heading-Challenges {\n    font-family: \"Poppins\", sans-serif;\n    font-size: 32px;\n    font-weight: 600;\n    line-height: 48px;\n    text-align: left;\n    text-underline-position: from-font;\n    text-decoration-skip-ink: none;\n    color: rgba(107, 142, 118, 1);\n    margin-top: -71px;\n    margin-left: -70px;\n}\n\n.challenges-brand {\n    margin-left: 9px;\n}\n\n.brand-panel-4 .challenges-brand .title-Challenges {\n    font-family: \"Poppins\", sans-serif;\n    font-size: 20px;\n    font-weight: 500;\n    line-height: 30px;\n    text-align: left;\n    text-underline-position: from-font;\n    text-decoration-skip-ink: none;\n    color: rgba(107, 142, 118, 1);\n}\n\n.brand-panel-4 .challenges-brand .description-Challenges {\n    font-family: \"Poppins\", sans-serif;\n    font-size: 16px;\n    font-weight: 400;\n    line-height: 24px;\n    text-align: left;\n    text-underline-position: from-font;\n    text-decoration-skip-ink: none;\n    color: rgba(103, 103, 103, 1);\n}\n\n.about-image {\n    font-size: 20px;\n    width: 516px;\n    font-weight: 400;\n    background-color: white;\n    padding: 4px;\n    border-radius: 10px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    box-shadow: rgb(255, 255, 255) 0px 0px 0px 2px inset,\n        rgba(107, 142, 118, 0.8784313725) 15px -15px 0px -3px;\n        margin-left: 80px;\n}\n\n.brand-panel-4 .about-image img {\n    border-radius: 8px;\n    width: 100%;\n}\n\n.main-content .all-cards .card-one .card {\n\n    padding-top: 70px;\n    /* Prevent overlap of text with icon */\n\n    text-align: center;\n\n}\n\n.main-content .all-cards .card-one .card .card-image {\n\n    position: absolute;\n\n    top: -40px;\n    /* Move the icon above the card */\n\n    left: 50%;\n\n    transform: translateX(-50%);\n\n    width: 130px;\n\n    height: 124px;\n\n    margin: 0 auto;\n\n}\n\n.main-content .all-cards .card-one .card .card-image img {\n\n    width: 100px;\n\n    height: 100px;\n\n    object-fit: none;\n    /* Ensure image fits well */\n\n    background: #6b8e76;\n\n    border-radius: 5rem;\n\n    border: 9px solid #f5f2e7;\n\n}\n\n.main-content .all-cards .card-one .card .card-content {\n\n    margin-left: 0;\n    /* Reset margin so text stays centered */\n\n    text-align: center;\n\n}\n\n.main-content .all-cards .card-one .card .card-content .brand-text-container .brand-card-heading {\n\n    font-family: \"Poppins\", sans-serif;\n\n    font-size: 20px;\n\n    font-weight: 600;\n\n    line-height: 27px;\n\n    /* kanj */\n\n    text-align: center;\n\n    /* kanj */\n\n    text-underline-position: from-font;\n\n    text-decoration-skip-ink: none;\n\n    color: rgba(107, 142, 118, 1);\n\n}\n\n.main-content .all-cards .card-one .card .card-content .brand-text-container .brand-card-description {\n\n    font-family: \"Poppins\", sans-serif;\n\n    font-size: 15px;\n\n    font-weight: 400;\n\n    line-height: 22px;\n\n    /* kanj */\n\n    text-align: center;\n\n    /* kanj */\n\n    text-underline-position: from-font;\n\n    text-decoration-skip-ink: none;\n\n    color: rgba(103, 103, 103, 1);\n\n}\n\n.about-image1 {\n\n    font-size: 20px;\n\n    width: 516px;\n\n    font-weight: 400;\n\n    background-color: white;\n\n    padding: 4px;\n\n    border-radius: 10px;\n\n    display: flex;\n\n    justify-content: center;\n\n    align-items: center;\n\n    box-shadow: rgb(255, 255, 255) 0px 0px 0px 2px inset,\n\n        rgba(107, 142, 118, 0.8784313725) -15px -15px 0px -3px;\n\n}\n\n\n.brand-panel-4 .about-image1 img {\n\n    border-radius: 8px;\n\n    width: 100%;\n\n}\n\n.container-about-section .about-image1-wrapper {\n\n    font-size: 20px;\n\n    font-weight: 400;\n\n    background-color: white;\n\n    padding: 10px;\n\n    border-radius: 10px;\n\n    display: flex;\n\n    justify-content: center;\n\n    align-items: center;\n\n    box-shadow: rgb(255, 255, 255) 0px 0px 0px 2px inset, #6b8e76e0 15px -15px 0px -3px;\n\n}\n\n.container-about-section .about-image1-wrapper img {\n\n    border-radius: 8px;\n\n}\n\n.main-content {\n    background-color: rgba(245, 242, 231, 1);\n}\n\n.main-content .heading-brand-benifit {\n    text-align: start;\n    color: rgba(107, 142, 118, 1);\n    font-family: \"Poppins\", sans-serif;\n    font-size: 32px;\n    font-weight: 500;\n    line-height: 48px;\n    text-align: left;\n    text-underline-position: from-font;\n    text-decoration-skip-ink: none;\n    margin-bottom: 2%;\n}\n\n.heading-brand-benifit .titles-brand {\n    font-size: 24px;\n    font-weight: 600;\n}\n\n.impactful-stats {\n    margin: 40px 0;\n    font-family: \"Poppins\", sans-serif;\n}\n\n.impactful-stats .title {\n    color: rgba(107, 142, 118, 1);\n    font-weight: 600;\n    font-size: 24px;\n    margin-bottom: 20px;\n    text-align: left;\n}\n\n.impactful-stats .stats-container {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 20px;\n    justify-content: space-between;\n    margin-top: 20px;\n}\n\n.impactful-stats .stats-container .stat-card {\n    flex-grow: 1;\n    flex-shrink: 1;\n    flex-basis: calc(25% - 20px);\n    max-width: calc(25% - 20px);\n    text-align: start;\n    color: rgb(42, 42, 42);\n}\n\n.impactful-stats .stats-container .stat-card .stat-title {\n    font-family: \"Poppins\", sans-serif;\n    font-size: 48px;\n    font-weight: 600;\n    line-height: 27px;\n    text-align: left;\n    text-underline-position: from-font;\n    text-decoration-skip-ink: none;\n    color: rgba(107, 142, 118, 1);\n}\n\n.impactful-stats .stats-container .stat-card .divider {\n    width: 50%;\n    margin: 0 0 10px;\n    border: 1px solid rgba(103, 103, 103, 1);\n    margin-top: 5%\n}\n\n.impactful-stats .stats-container .stat-card .stats-description {\n    width: 100%;\n}\n\n.impactful-stats .stats-container .stat-card .stats-description .stat-description {\n    width: 80%;\n    font-family: \"Poppins\", sans-serif;\n    font-size: 16px;\n    font-weight: 400;\n    line-height: 24px;\n    text-align: left;\n    text-underline-position: from-font;\n    text-decoration-skip-ink: none;\n    color: rgba(103, 103, 103, 1);\n}\n\n@media screen and (max-width: 768px) {\n    .impactful-stats .stats-container .stat-card {\n        flex: 1 1 100%;\n        max-width: 100%;\n        margin-bottom: 20px;\n    }\n\n    .brand-container .brand-hero-section {\n        background: rgba(0, 0, 0, 0.5) url(\"../../Assets/Img/Brand\\ Page\\ Banner.png\") center center;\n        background-size: cover;\n        height: 400px;\n    }\n}\n\n@media screen and (max-width: 426px) {\n    .brand-container .brand-hero-section .text-center .hero-title {\n        font-family: \"FantasyMagist\", \"Arial\", sans-serif;\n        color: rgba(245, 242, 231, 1);\n        font-weight: 400;\n        font-size: 32px;\n    }\n}\n\n\n.main-content {\n    background-color: rgba(245, 242, 231, 1);\n}\n\n.main-content .heading-brand-benifit {\n    text-align: start;\n    color: rgba(107, 142, 118, 1);\n    font-family: \"Poppins\", sans-serif;\n    font-size: 32px;\n    font-weight: 500;\n    line-height: 48px;\n    text-align: left;\n    text-underline-position: from-font;\n    text-decoration-skip-ink: none;\n    margin-bottom: 2%;\n}\n\n.main-content .heading-brand-benifit .titles-brand {\n    font-size: 32px;\n    font-weight: 500;\n    margin-left: -8px;\n}\n\n.main-content .all-cards .card-one {\n    position: relative;\n    width: 100%;\n    padding: 26px;\n    padding-left: 1rem;\n}\n\n/* .main-content .all-cards .card-one .card {\n    background-color: #fff;\n    width: 100%;\n    height: 159px;\n    padding: 10px;\n} */\n\n/* .main-content .all-cards .card-one .card .card-image {\n    position: absolute;\n    top: 51%;\n    left: -55px;\n    transform: translateY(-50%);\n    width: 130px;\n    height: 124px;\n    margin: 0;\n    bottom: 50%;\n} */\n/* \n.main-content .all-cards .card-one .card .card-image img {\n    width: 119px;\n    object-fit: none;\n    background: #6b8e76;\n    border-radius: 5rem;\n    border: 9px solid #f5f2e7;\n    height: 119px;\n} */\n/* \n.main-content .all-cards .card-one .card .card-content {\n    margin-left: 100px;\n} */\n\n/* .main-content .all-cards .card-one .\n .card-content .brand-text-container .brand-card-heading {\n    font-family: \"Poppins\", sans-serif;\n    font-size: 20px;\n    font-weight: 600;\n    line-height: 27px;\n    text-align: left;\n    text-underline-position: from-font;\n    text-decoration-skip-ink: none;\n    color: rgba(107, 142, 118, 1);\n} */\n\n/* .main-content .all-cards .card-one .card .card-content .brand-text-container .brand-card-description {\n    font-family: \"Poppins\", sans-serif;\n    font-size: 16px;\n    font-weight: 400;\n    line-height: 22px;\n    text-align: left;\n    text-underline-position: from-font;\n    text-decoration-skip-ink: none;\n    color: rgba(103, 103, 103, 1);\n} */\n.main-content .all-cards .card-one .card {\n    padding-top: 70px;\n    /* Prevent overlap of text with icon */\n    text-align: center;\n}\n\n.main-content .all-cards .card-one .card .card-image {\n    position: absolute;\n    top: -40px;\n    /* Move the icon above the card */\n    left: 50%;\n    transform: translateX(-50%);\n    width: 130px;\n    height: 124px;\n    margin: 0 auto;\n}\n\n.main-content .all-cards .card-one .card .card-image img {\n    width: 100px;\n    height: 100px;\n    object-fit: none;\n    /* Ensure image fits well */\n    background: #6b8e76;\n    border-radius: 5rem;\n    border: 9px solid #f5f2e7;\n}\n\n.main-content .all-cards .card-one .card .card-content {\n    margin-left: 0;\n    /* Reset margin so text stays centered */\n    text-align: center;\n}\n\n.main-content .all-cards .card-one .card .card-content .brand-text-container .brand-card-heading {\n    font-family: \"Poppins\", sans-serif;\n    font-size: 20px;\n    font-weight: 600;\n    line-height: 27px;\n    /* kanj */\n    text-align: center;\n    /* kanj */\n    text-underline-position: from-font;\n    text-decoration-skip-ink: none;\n    color: rgba(107, 142, 118, 1);\n}\n\n.main-content .all-cards .card-one .card .card-content .brand-text-container .brand-card-description {\n\n    font-family: \"Poppins\", sans-serif;\n    font-size: 15px;\n    font-weight: 400;\n    line-height: 22px;\n    /* kanj */\n    text-align: center;\n    /* kanj */\n    text-underline-position: from-font;\n    text-decoration-skip-ink: none;\n    color: rgba(103, 103, 103, 1);\n    padding: 5px;\n\n}\n\n/* testimonials */\n\n\n.testimonial-section {\n    text-align: center;\n    padding: 50px 20px;\n}\n\n.testimonial-section .testimonial-heading {\n    text-align: start;\n    width: 100%;\n    font-family: \"Poppins\", \"Public Sans\", sans-serif;\n    font-size: 32px;\n    font-weight: 500;\n    line-height: 48px;\n    text-align: left;\n    text-underline-position: from-font;\n    text-decoration-skip-ink: none;\n    color: rgba(107, 142, 118, 1);\n    margin-bottom: 20px;\n    margin-bottom: 3%;\n}\n\n.testimonial-carousel {\n    display: flex;\n    justify-content: center;\n    overflow: hidden;\n    width: 100%;\n    margin: 0 auto;\n    scroll-behavior: smooth;\n    flex-wrap: nowrap;\n}\n\n.testimonial-card {\n    min-width: 300px;\n    margin: 0 10px;\n    padding: 20px;\n    border-radius: 8px;\n    background-color: white;\n    border: 1px solid rgba(245, 242, 231, 1);\n    transition: transform 0.3s ease;\n    text-align: center;\n}\n\n.testimonial-card-wrapper {\n    padding: 10px;\n    /* Adds spacing between the cards */\n}\n\n.testimonial-card {\n    min-width: 300px;\n    padding: 20px;\n    border-radius: 8px;\n    background-color: white;\n    border: 1px solid rgba(245, 242, 231, 1);\n    text-align: center;\n}\n\n\n.client-image {\n    width: 100%;\n    height: 100px;\n    margin: 0 auto 10px auto;\n    /* border-radius: 50%; */\n    overflow: hidden;\n}\n\n.client-image img {\n    margin: auto;\n    width: 100%;\n    height: 39px;\n    object-fit: contain;\n}\n\n.testimonial-text {\n    text-align: justify;\n    width: 100%;\n    height: 144px;\n    font-family: \"Poppins\", \"Public Sans\", sans-serif;\n    font-size: 16px;\n    font-weight: 400;\n    line-height: 24px;\n    text-align: center;\n    text-underline-position: from-font;\n    text-decoration-skip-ink: none;\n    color: rgba(103, 103, 103, 1);\n}\n\n.star-rating {\n    width: 100%;\n    height: 25px;\n    display: flex;\n    justify-content: center;\n    margin-top: 11%;\n}\n\nh3 {\n    font-size: 1.3em;\n    margin: 10px 0 5px 0;\n    color: #333;\n}\n\n.client-role {\n    display: flex;\n    justify-content: center;\n    width: 100%;\n    height: 24px;\n    font-family: \"Poppins\", \"Public Sans\", sans-serif;\n    font-size: 16px;\n    font-weight: 500;\n    line-height: 24px;\n    text-align: left;\n    text-underline-position: from-font;\n    text-decoration-skip-ink: none;\n    color: rgba(107, 142, 118, 1);\n}\n\n@media (max-width: 2720px) {\n    .testimonial-section .testimonial-heading {\n        text-align: start;\n        width: 100%;\n        font-family: \"Poppins\", \"Public Sans\", sans-serif;\n        font-size: 24px;\n        font-weight: 600;\n        line-height: 48px;\n        text-align: justify;\n        text-underline-position: from-font;\n        text-decoration-skip-ink: none;\n        color: rgb(107, 142, 118);\n        margin-bottom: 20px;\n        margin-bottom: 3%;\n        padding-left: 4%;\n    }\n}\n\n@media (max-width: 2560px) {\n    .testimonial-section .testimonial-heading {\n        text-align: start;\n        width: 100%;\n        font-family: \"Poppins\", \"Public Sans\", sans-serif;\n        font-size: 24px;\n        font-weight: 600;\n        line-height: 48px;\n        text-align: justify;\n        text-underline-position: from-font;\n        text-decoration-skip-ink: none;\n        color: rgb(107, 142, 118);\n        margin-bottom: 20px;\n        margin-bottom: 3%;\n        padding-left: 4%;\n    }\n}\n\n@media (max-width: 1200px) {\n    .testimonial-card {\n        width: 100%;\n        margin: 0 10px;\n        border-radius: 8px;\n        background-color: white;\n        border: 1px solid rgb(245, 242, 231);\n        transition: transform 0.3s ease;\n        text-align: center;\n    }\n\n    .testimonial-text {\n        text-align: justify;\n        width: 100%;\n        height: 144px;\n        font-family: \"Poppins\", \"Public Sans\", sans-serif;\n        font-size: 15px;\n        font-weight: 400;\n        line-height: 22px;\n        text-align: center;\n        text-underline-position: from-font;\n        text-decoration-skip-ink: none;\n        color: rgb(103, 103, 103);\n    }\n\n    .star-rating {\n        width: 100%;\n        height: 25px;\n        display: flex;\n        justify-content: center;\n        margin-top: 3rem;\n    }\n}\n\n@media (max-width: 1024px) {\n    .testimonial-section .testimonial-heading {\n        text-align: start;\n        width: 100%;\n        height: 22px;\n        font-family: \"Poppins\", \"Public Sans\", sans-serif;\n        font-size: 32px;\n        font-weight: 500;\n        line-height: 48px;\n        text-align: left;\n        text-underline-position: from-font;\n        text-decoration-skip-ink: none;\n        color: rgb(107, 142, 118);\n        margin-bottom: 20px;\n        margin-left: 1%;\n        margin-bottom: 3%;\n    }\n}\n\n@media (max-width: 768px) {\n    .testimonial-carousel {\n        flex-wrap: wrap;\n        justify-content: center;\n    }\n\n    .testimonial-card {\n        flex: 1 1 90%;\n        margin: 10px 0;\n    }\n}\n\n@media (max-width: 480px) {\n    .testimonial-card {\n        flex: 1 1 100%;\n    }\n}\n\n@media (max-width: 768px) {\n    .testimonial-text {\n        text-align: justify;\n        width: 100%;\n        height: 144px;\n        font-family: \"Poppins\", \"Public Sans\", sans-serif;\n        font-size: 14px;\n        font-weight: 400;\n        line-height: 30px;\n        text-align: justify;\n        text-underline-position: from-font;\n        text-decoration-skip-ink: none;\n        color: rgb(103, 103, 103);\n    }\n}\n\n/* AboutPage */\n\n@font-face {\n    font-family: \"FantasyMagist\";\n    src: url(\".././Img/FANTASY\\ MAGIST.otf\") format(\"opentype\");\n}\n\n.about-hero-section {\n    position: relative;\n    background-image: url(\".././Img/Bannermain.png\");\n    background-size: cover;\n    background-position: center;\n    height: 300px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    color: white !important;\n    text-align: center;\n    font-family: \"FantasyMagist\", \"Arial\", sans-serif;\n    width: 100%;\n}\n\n.about-hero-section::before {\n    content: \"\";\n    background-color: rgba(101, 145, 115, 0.88);\n    width: 100%;\n    height: 100%;\n    background-repeat: repeat;\n    background-position: center;\n    background-size: contain;\n    position: absolute;\n    top: 0;\n    left: 0;\n    opacity: 0.5;\n    z-index: 1;\n}\n\np.About.card-description.text-white.position-absolute.top-50.start-50.translate-middle-x.text-center.belief-description {\n    margin-top: -24% !important;\n    font-size: 15px;\n}\n\n.about-hero-section .overlay-text {\n    position: relative;\n    z-index: 2;\n    margin-top: 9%;\n    padding: 20px;\n    border-radius: 5px;\n    width: 100%;\n    max-width: 900px;\n    font-family: \"FantasyMagist\";\n}\n\n.about-hero-section .overlay h1 {\n    margin: 0;\n    font-size: 48px;\n    font-weight: 400;\n    font-family: \"FantasyMagist\", \"Arial\", sans-serif;\n    width: 877px;\n    top: 340px;\n    color: rgba(245, 242, 231, 1);\n}\n\n.about-hero-section .overlay .underline {\n    width: 600px;\n    height: 2px;\n    background-color: rgba(245, 242, 231, 1);\n    margin: 10px auto 0;\n}\n\n.about-hero-section .underline::after {\n    content: \"\";\n    display: none;\n}\n\n@media (max-width: 576px) {\n    .hero-section::before {\n        content: \"\";\n        background-color: rgba(107, 142, 118, 0.88);\n        width: 100%;\n        height: 100%;\n        background-repeat: no-repeat;\n        background-position: top;\n        background-size: contain;\n        position: absolute;\n        top: 0px;\n        left: 0;\n        opacity: 0.5;\n        z-index: 1;\n    }\n\n    .hero-section .overlay h1 {\n        margin: 0;\n        font-size: 27px;\n        font-weight: 400;\n        font-family: \"FantasyMagist\", \"Arial\", sans-serif;\n        width: 553px;\n        top: 340px;\n        color: rgb(245, 242, 231);\n    }\n\n    .col-xl-4.col-xs-12.col-md-3.col-sm-6.d-flex {\n        margin-bottom: 5%;\n    }\n\n    p.About.card-description.text-white.position-absolute.top-50.start-50.translate-middle-x.text-center.belief-description {\n        margin-top: -30% !important;\n        font-size: 13px;\n        line-height: 2;\n    }\n}\n\n@media (max-width: 768px) {\n    .hero-section::before {\n        content: \"\";\n        background-color: rgba(107, 142, 118, 0.88);\n        width: 100%;\n        height: 100%;\n        background-repeat: no-repeat;\n        background-position: top;\n        background-size: contain;\n        position: absolute;\n        top: 0;\n        left: 0;\n        opacity: 0.5;\n        z-index: 1;\n    }\n\n    .hero-section .overlay h1 {\n        margin: 0 !important;\n        font-size: 28px !important;\n        font-weight: 400 !important;\n        font-family: \"FantasyMagist\", \"Arial\", sans-serif;\n        width: 90% !important;\n        max-width: 890px !important;\n        top: 200px !important;\n        color: rgb(245, 242, 231) !important;\n        z-index: 2 !important;\n        text-align: center !important;\n    }\n\n    .hero-section .overlay .underline {\n        width: 600px !important;\n        height: 2px !important;\n        background-color: rgb(245, 242, 231);\n        margin: 10px 40px 0 !important;\n    }\n}\n\n@media (max-width: 992px) {\n    .hero-section .overlay h1 {\n        margin: 0;\n        font-size: 34px;\n        font-weight: 400;\n        font-family: \"FantasyMagist\", \"Arial\", sans-serif;\n        width: 818px;\n        top: 340px;\n        color: rgb(245, 242, 231);\n    }\n\n    .hero-section .overlay .underline {\n        width: 600px;\n        height: 2px;\n        background-color: rgb(245, 242, 231);\n        margin: 10px 113px 0;\n    }\n}\n\n@media (max-width: 480px) {\n    .hero-section .overlay h1 {\n        margin: 0 !important;\n        font-size: 35px !important;\n        font-weight: 400 !important;\n        font-family: \"FantasyMagist\", \"Arial\", sans-serif;\n        width: 101% !important;\n        max-width: 439px !important;\n        top: 200px !important;\n        color: rgb(245, 242, 231) !important;\n        z-index: 2 !important;\n        text-align: center !important;\n    }\n\n    .row.d-flex.justify-content-around {\n        margin-left: 7%;\n    }\n\n    .hero-section .overlay .underline {\n        width: 295px !important;\n        height: 2px !important;\n        background-color: rgb(245, 242, 231);\n        margin: 10px 40px 0 !important;\n    }\n\n    /* .container-about-section .about-image-wrapper {\n        font-size: 20px;\n        font-weight: 400;\n        background-color: white;\n        padding: 10px;\n        border-radius: 10px;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        box-shadow: rgb(255, 255, 255) 0px 0px 0px 2px inset, #6b8e76e0 15px -15px 0px -3px;\n        margin-top: 5%;\n        margin-right: 5%;\n    } */\n}\n\n@media (max-width: 380px) {\n    .hero-section .overlay h1 {\n        margin: 0;\n        font-size: 30px;\n        font-weight: 400;\n        font-family: \"FantasyMagist\", \"Arial\", sans-serif;\n        width: 338px;\n        top: 340px;\n        color: rgb(245, 242, 231);\n    }\n\n    .hero-section .overlay .underline {\n        display: none;\n    }\n\n    .hero-section .overlay {\n        position: relative;\n        z-index: 2;\n        margin-top: 9%;\n        padding: 20px;\n        border-radius: 5px;\n        width: 82%;\n        max-width: 900px;\n        font-family: \"FantasyMagist\";\n    }\n\n    .row.d-flex.justify-content-around {\n        margin-left: 7%;\n    }\n}\n\n@import url(\"https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap\");\n\n/* Apply Poppins font globally */\nbody {\n    font-family: \"Poppins\", sans-serif;\n}\n\n.container-about-section p.text-justify {\n    color: #676767;\n    font-family: \"Poppins\", sans-serif;\n    font-weight: 400;\n    font-size: 20px;\n    line-height: 34px;\n}\n\n.container-about-section .about-image-wrapper {\n    font-size: 20px;\n    font-weight: 400;\n    background-color: white;\n    padding: 10px;\n    border-radius: 10px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    box-shadow: rgb(255, 255, 255) 0px 0px 0px 2px inset, #6b8e76e0 15px -15px 0px -3px;\n}\n\n/* .container-about-section .about-image-wrapper img {\n    border-radius: 8px;\n} */\n\n.container-about-section .text-justify {\n    text-align: justify;\n}\n\n/* Variables are replaced directly with their values */\n\n/* Base styles */\nbody {\n    font-family: \"Arial\", sans-serif;\n    margin: 0;\n    padding: 0;\n    box-sizing: border-box;\n}\n\n/* Section styling */\n.why-choose-section {\n    padding: 40px 20px;\n    background-color: #fff;\n    text-align: center;\n}\n\n.why-choose-section h2 {\n    width: 100%;\n    font-family: \"Poppins\", sans-serif;\n    font-size: 32px;\n    font-weight: 500;\n    line-height: 48px;\n    text-align: left;\n    color: rgba(107, 142, 118, 1);\n    margin-bottom: 2%;\n}\n\n.why-choose-section p {\n    width: 100%;\n    font-family: \"Poppins\", sans-serif;\n    font-size: 24px;\n    font-weight: 400;\n    line-height: 34px;\n    text-align: justify;\n    color: rgba(103, 103, 103, 1);\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n    .why-choose-section h2 {\n        font-size: 24px;\n    }\n\n    .why-choose-section p {\n        font-size: 14px;\n    }\n}\n\n@media (max-width: 480px) {\n    .why-choose-section h2 {\n        font-size: 16px;\n    }\n\n    .why-choose-section p {\n        font-size: 12px;\n    }\n}\n\n/* Cards */\n.card-body {\n    position: relative;\n    overflow: hidden;\n    cursor: pointer;\n    background: rgb(107, 142, 118);\n}\n\n.card-body .card-img-top {\n    object-fit: cover;\n    width: 100%;\n    margin-left: 7%;\n    transition: transform 0.3s ease-in-out;\n}\n\n.card-body .card-title-vmg {\n    font-family: \"Poppins\", sans-serif;\n    font-size: 24px;\n    font-weight: 600;\n    line-height: 36px;\n    text-align: left;\n}\n\n/* Hover Effect for Card Body */\n.card-body:hover .card-img-top {\n    opacity: 0;\n}\n\n.card-body:hover .belief-description {\n    opacity: 1;\n    visibility: visible;\n    color: transparent;\n    transform: translate(-50%, 0%) !important;\n}\n\n/* Style the text inside the overlay */\n.belief-description {\n    position: absolute;\n    transform: translate(-100%, 0%) !important;\n    color: #fff !important;\n    opacity: 0;\n    transition: all 0.3s ease-in-out;\n    text-align: center;\n    width: 100%;\n    line-height: 45px;\n}\n\n.why-choose-section p.about.card-description.text-white.position-absolute.top-50.start-50.translate-middle-x.text-center.belief-description {\n    font-size: 17px;\n    margin: -29%;\n    margin-left: 1%;\n}\n\n/* Media Queries */\n@media (max-width: 768px) {\n    .card-body {\n        flex: 1 1 auto;\n        color: var(--bs-card-color);\n    }\n\n    h5.card-title-vmg.text-white.position-absolute.top-0.start-50.translate-middle-x.text-center.mt-3 {\n        font-size: 14px;\n    }\n\n    .why-choose-section p.card-description.text-white.position-absolute.top-50.start-50.translate-middle-x.text-center.belief-description {\n        font-size: 13px;\n        margin: -25%;\n        line-height: 1.5rem;\n        margin-left: 1%;\n        background: linear-gradient(to bottom, #fff);\n    }\n}\n\n@media (max-width: 576px) {\n    .card-img-top {\n        width: 85%;\n        margin-left: 7%;\n    }\n\n    .row.d-flex.justify-content-around {\n        flex-direction: row;\n        width: 90%;\n        margin: auto;\n    }\n\n    .why-choose-section p.card-description.text-white.position-absolute.top-50.start-50.translate-middle-x.text-center.belief-description {\n        font-size: 25.5px;\n        margin: -30%;\n        margin-left: 2%;\n    }\n\n    .why-choose-section p.card-description.text-white.position-absolute.top-50.start-50.translate-middle-x.text-center.belief-description {\n        font-size: 10px;\n        margin: -25%;\n        width: 90%;\n        margin-left: 1%;\n        background: linear-gradient(to bottom, #fff);\n    }\n}\n\n@media (max-width: 375px) {\n    .why-choose-section p.card-description.text-white.position-absolute.top-50.start-50.translate-middle-x.text-center.belief-description {\n        font-size: 12px;\n        margin: -32%;\n        line-height: 2rem;\n        margin-left: 1%;\n        background: linear-gradient(to bottom, #fff);\n    }\n}\n\n/* contact-us */\n@font-face {\n    font-family: \"FantasyMagist\";\n    /* Name the font family */\n    src: url(\".././Img/FANTASY\\ MAGIST.otf\") format(\"opentype\");\n    /* Corrected path */\n}\n\n.contact-container .hero-section {\n    background: rgba(0, 0, 0, 0.5) url(\"../Img/ContactusBanner.png\") center center;\n    background-size: cover;\n    height: 400px;\n}\n\n.contact-container .hero-section .text-center {\n    margin-top: 14%;\n}\n\n.contact-container .hero-section .text-center .hero-title {\n    font-family: \"FantasyMagist\", \"Arial\", sans-serif;\n    color: rgba(245, 242, 231, 1);\n    font-weight: 400;\n}\n\n.contact-container .hero-section .contact-hero-title {\n    margin-top: 5%;\n    font-size: 24px;\n    border-bottom: 2px solid black;\n}\n\n.contact-container .contact-content .section-title {\n    color: #6b8e76;\n    font-family: \"Poppins\", sans-serif;\n    font-size: 32px;\n    font-weight: 600;\n    line-height: 48px;\n    text-align: left;\n    text-underline-position: from-font;\n    text-decoration-skip-ink: none;\n}\n\n.contact-container .contact-content .description {\n    color: rgba(103, 103, 103, 1);\n    font-size: 20px;\n    font-weight: 400;\n    margin-top: -4% !important;\n}\n\nlabel.form-label {\n    color: rgba(103, 103, 103, 1);\n}\n\n.contact-container .contact-content .get-in-touch {\n    color: #6b8e76;\n    font-family: \"Poppins\", sans-serif;\n    font-size: 32px;\n    font-weight: 600;\n    line-height: 48px;\n    text-align: left;\n    text-underline-position: from-font;\n    text-decoration-skip-ink: none;\n    margin-top: 5% !important;\n}\n\n.contact-container .contact-content .contact-info {\n    font-family: \"Poppins\", sans-serif;\n    font-size: 20px;\n    font-weight: 500;\n    line-height: 40px;\n    text-align: left;\n    text-underline-position: from-font;\n    text-decoration-skip-ink: none;\n    color: #6b8e76 !important;\n    list-style-type: none;\n    margin-left: -28px;\n    margin-top: 10px;\n}\n\n.contact-container .contact-content .contact-info li {\n    margin-bottom: 10px;\n}\n\n.contact-label {\n    color: rgba(103, 103, 103, 1) !important;\n}\n\n.contact-container .form-section {\n    background-color: rgba(249, 247, 237, 1);\n}\n\n.contact-container .form-section .form-title .title {\n    font-family: \"Poppins\", sans-serif;\n    font-size: 32px;\n    font-weight: 500;\n    line-height: 48px;\n    text-align: left;\n    text-underline-position: from-font;\n    text-decoration-skip-ink: none;\n    color: rgba(107, 142, 118, 1);\n}\n\n.contact-container .form-section .connect-form .form-label {\n    font-weight: 500;\n}\n\n.contact-container .form-section .connect-form input {\n    border: 1px solid rgba(103, 103, 103, 1);\n    margin-bottom: 3%;\n    background-color: rgba(249, 247, 237, 1);\n}\n\n.contact-container .form-section .connect-form input::placeholder,\n.contact-container .form-section .connect-form textarea::placeholder {\n    color: #6b8e76;\n    opacity: 1;\n    font-family: \"Poppins\", sans-serif;\n    font-size: 16px;\n    font-weight: 400;\n    line-height: 30px;\n    text-align: left;\n    text-underline-position: from-font;\n    text-decoration-skip-ink: none;\n}\n\n.contact-container .form-section .connect-form textarea {\n    border: 1px solid rgba(103, 103, 103, 1);\n    background-color: rgba(249, 247, 237, 1);\n}\n\n.contact-container .form-section .connect-form .btn-success {\n    background-color: #6b8e76;\n    border: none;\n}\n\n.contact-container .form-section .connect-form .btn-success:hover {\n    background-color: #5a7a65;\n}\n\n/* HOMEPAGE */\n\n.hero-section-banner {\n    position: relative;\n    background-image: url(\".././Img/homebanner2.png\");\n    /* Replace with your actual image */\n    background-size: cover;\n    background-position: center;\n    height: 544px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    color: rgb(245, 242, 231) !important;\n    text-align: center;\n    font-family: \"FantasyMagist\", \"Arial\", sans-serif;\n    width: 100%;\n    /* Ensures the section spans the full width */\n    mix-blend-mode: multiply;\n}\n\n.hero-section-banner::before {\n    content: \"\";\n    /* background-image: url(\"../../assets/bannericon.png\"); */\n    background-color: rgba(107, 142, 118, 1);\n    /* Set to the color you want above the image */\n    width: 100%;\n    /* Ensure full-width */\n    height: 100%;\n    /* Matches the full height of .hero-section */\n    background-repeat: repeat;\n    background-position: center;\n    background-size: contain;\n    /* Adjust the background size */\n    position: absolute;\n    top: 0;\n    left: 0;\n    opacity: 0;\n    /* Adjust as needed */\n    z-index: 1;\n    /* Behind text but above the background */\n}\n\n.overlay {\n    position: relative;\n    z-index: 2;\n    /* Text content appears above both images */\n    margin-top: 15%;\n    padding: 20px;\n    border-radius: 5px;\n    width: 100%;\n    max-width: 900px;\n    font-family: \"FantasyMagist\";\n}\n\n.animation-text h1 {\n    animation-name: intro;\n    /* Reference the animation */\n    animation-duration: 0.5s;\n    animation-iteration-count: 1;\n    animation-timing-function: ease;\n    animation-delay: 1s;\n    animation-fill-mode: forwards;\n}\n\nh1 {\n    margin: 0;\n    font-size: 45px;\n    font-weight: 400;\n    font-family: \"FantasyMagist\", \"Arial\", sans-serif;\n    width: 100%;\n    color: rgba(245, 242, 231, 1);\n    position: relative;\n    /* For animation to work */\n}\n\nbutton.connect-button {\n    margin-top: 20px;\n    padding: 10px 20px;\n    font-size: 16px;\n    font-weight: 500;\n    background-color: rgba(245, 242, 231, 1);\n    color: rgba(107, 142, 118, 1);\n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n    position: relative;\n    animation-name: intro;\n    animation-duration: 0.5s;\n    animation-iteration-count: 1;\n    animation-timing-function: ease;\n    animation-delay: 1s;\n    /* Slightly delay compared to h1 */\n    animation-fill-mode: forwards;\n    font-style: Poppins;\n    width: 30%;\n}\n\n@keyframes intro {\n    0% {\n        top: 150px;\n        /* Start below the visible area */\n    }\n\n    98% {\n        top: -5px;\n        /* Slight bounce effect */\n    }\n\n    100% {\n        top: 0%;\n        /* Final position */\n    }\n}\n\n@media (max-width: 2720px) {\n    .hero-section .overlay {\n        position: relative;\n        z-index: 2;\n        margin-top: 10%;\n        padding: 20px;\n        border-radius: 5px;\n        width: 100%;\n        max-width: 900px;\n        font-family: \"FantasyMagist\";\n    }\n}\n\n@media (max-width: 576px) {\n    .hero-section::before {\n        content: \"\";\n        /* background-image: url(\"../../assets/bannericon.png\"); */\n        background-color: rgba(107, 142, 118, 0.88);\n        width: 100%;\n        height: 100%;\n        background-repeat: no-repeat;\n        background-position: top;\n        background-size: contain;\n        position: absolute;\n        top: 0px;\n        left: 0;\n        opacity: 0.5;\n        z-index: 1;\n    }\n\n    .hero-section .overlay h1 {\n        margin: 0;\n        font-size: 27px;\n        font-weight: 400;\n        font-family: \"FantasyMagist\", \"Arial\", sans-serif;\n        width: 553px;\n        top: 340px;\n        color: rgb(245, 242, 231);\n    }\n}\n\n@media (max-width: 768px) {\n    .hero-section::before {\n        content: \"\";\n        background-color: rgba(107, 142, 118, 0.88);\n        width: 100%;\n        height: 100%;\n        background-repeat: no-repeat;\n        background-position: top;\n        background-size: contain;\n        position: absolute;\n        top: 0;\n        left: 0;\n        opacity: 0.5;\n        z-index: 1;\n        /* Ensure it's behind the text */\n    }\n\n    .hero-section .overlay h1 {\n        margin: 0 !important;\n        font-size: 28px !important;\n        /* Adjust font size for smaller screens */\n        font-weight: 400 !important;\n        font-family: \"FantasyMagist\", \"Arial\", sans-serif;\n        width: 90% !important;\n        /* Make the width relative to the container */\n        max-width: 890px !important;\n        /* Max width for larger screens */\n        top: 200px !important;\n        /* Adjust top position if necessary */\n        color: rgb(245, 242, 231) !important;\n        z-index: 2 !important;\n        text-align: center !important;\n    }\n\n    /* Responsive underline styling */\n    .hero-section .overlay .underline {\n        width: 600px !important;\n        height: 2px !important;\n        background-color: rgb(245, 242, 231);\n        margin: 10px 40px 0 !important;\n    }\n}\n\n@media (max-width: 1200px) {\n    .hero-section {\n        width: 100%;\n    }\n}\n\n@media (max-width: 992px) {\n    .hero-section .overlay h1 {\n        margin: 0;\n        font-size: 34px;\n        font-weight: 400;\n        font-family: \"FantasyMagist\", \"Arial\", sans-serif;\n        width: 100%;\n        top: 340px;\n        color: rgb(245, 242, 231);\n    }\n}\n\n@media (max-width: 480px) {\n    .hero-section .overlay h1 {\n        margin: 0 !important;\n        font-size: 29px !important;\n        font-weight: 400 !important;\n        font-family: \"FantasyMagist\", \"Arial\", sans-serif;\n        width: 100% !important;\n        max-width: 439px !important;\n        top: 200px !important;\n        color: rgb(245, 242, 231) !important;\n        z-index: 2 !important;\n        text-align: center !important;\n    }\n\n    .row.d-flex.justify-content-around {\n        margin-left: 7%;\n    }\n\n    .hero-section .overlay .underline {\n        width: 295px !important;\n        height: 2px !important;\n        background-color: rgb(245, 242, 231);\n        margin: 10px 40px 0 !important;\n    }\n\n    .hero-section-banner .overlay button.connect-button {\n        margin-top: 20px;\n        padding: 10px 20px;\n        font-size: 16px;\n        font-weight: 500;\n        background-color: rgb(245, 242, 231);\n        color: rgb(107, 142, 118);\n        border: none;\n        border-radius: 5px;\n        cursor: pointer;\n        position: relative;\n        animation-name: intro;\n        animation-duration: 0.5s;\n        animation-iteration-count: 1;\n        animation-timing-function: ease;\n        animation-delay: 1s;\n        animation-fill-mode: forwards;\n        font-style: Poppins;\n        width: 50%;\n    }\n}\n\n@media (max-width: 380px) {\n    .hero-section .overlay h1 {\n        margin: 0;\n        font-size: 30px;\n        font-weight: 400;\n        font-family: \"FantasyMagist\", \"Arial\", sans-serif;\n        width: 338px;\n        top: 340px;\n        color: rgb(245, 242, 231);\n    }\n\n    .hero-section .overlay button.connect-button {\n        margin-top: 20px;\n        padding: 10px 20px;\n        font-size: 16px;\n        font-weight: 500;\n        background-color: rgb(245, 242, 231);\n        color: rgb(107, 142, 118);\n        border: none;\n        border-radius: 5px;\n        cursor: pointer;\n        position: relative;\n        animation-name: intro;\n        animation-duration: 0.5s;\n        animation-iteration-count: 1;\n        animation-timing-function: ease;\n        animation-delay: 1s;\n        animation-fill-mode: forwards;\n        font-style: Poppins;\n        width: 50%;\n    }\n}\n\n@media (max-width: 380px) {\n    .hero-section .overlay h1 {}\n}\n\n/* Variables for colors and typography */\n:root {\n    --primary-color: #6b8e76;\n    /* Greenish color */\n    --text-color: #555;\n    /* Gray color */\n    --background-color: #fff;\n    /* White background */\n}\n\n/* Base styles */\nbody {\n    font-family: \"Arial\", sans-serif;\n    margin: 0;\n    padding: 0;\n    box-sizing: border-box;\n}\n\n/* Section styling */\n.why-choose-section {\n    padding: 40px 20px;\n    background-color: var(--background-color);\n    text-align: center;\n}\n\n.why-choose-section .why-we-title {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n}\n\n.why-choose-section .why-we-title h2 {\n    width: 82%;\n    top: 734px;\n    left: 80px;\n    gap: 0px;\n    opacity: 0px;\n    font-family: 'Poppins', sans-serif;\n    font-size: 32px;\n    font-weight: 500 !important;\n    line-height: 48px;\n    text-align: left;\n    color: rgba(107, 142, 118, 1) !important;\n    text-decoration-skip-ink: none;\n    margin-bottom: 2%;\n}\n\n.why-choose-section .why-we {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n}\n\n.why-choose-section .why-we p {\n    width: 82%;\n    top: 795px;\n    left: 80px;\n    gap: 0px;\n    font-family: 'Poppins', sans-serif;\n    font-size: 24px;\n    font-weight: 400;\n    line-height: 34px;\n    text-underline-position: from-font;\n    text-decoration-skip-ink: none;\n    text-align: justify !important;\n    color: rgba(103, 103, 103, 1);\n}\n\n/* Responsive adjustments */\n@media (max-width: 2720px) {\n    .d-flex.justify-content-start {\n        flex-direction: column;\n    }\n\n    .why-choose-section p.card-description.text-white.position-absolute.top-50.start-50.translate-middle-x.text-center.belief-description {\n        font-size: 18px;\n        margin: -18%;\n        margin-left: 0%;\n        background: linear-gradient(to bottom, #fff);\n    }\n}\n\n@media (max-width: 768px) {\n    .why-choose-section .why-we-title h2 {\n        font-size: 24px;\n    }\n\n    .why-choose-section .why-we p {\n        font-size: 14px;\n    }\n}\n\n@media (max-width: 480px) {\n    .why-choose-section .why-we-title h2 {\n        font-size: 20px;\n    }\n\n    .why-choose-section .why-we p {\n        font-size: 12px;\n    }\n}\n\n/* Cards */\n.card-body {\n    position: relative;\n    overflow: hidden;\n    cursor: pointer;\n    background: rgb(107, 142, 118);\n}\n\n.card-body .card-img-top {\n    object-fit: cover;\n    width: 85%;\n    margin-left: 7%;\n    transition: transform 0.3s ease-in-out;\n}\n\n.card-body .card-title-vmg {\n    font-family: 'Poppins', sans-serif;\n    font-size: 24px;\n    font-weight: 600;\n    line-height: 36px;\n    text-align: left;\n    text-underline-position: from-font;\n    text-decoration-skip-ink: none;\n}\n\n.card-body:hover .card-img-top {\n    opacity: 0;\n}\n\n.card-body:hover .belief-description {\n    opacity: 1;\n    visibility: visible;\n    color: transparent;\n    transform: translate(-50%, 0%) !important;\n    padding: 0px 40px 0px 40px;\n}\n\n/* Style the text inside the overlay */\n.belief-description {\n    transform: translate(-100%, 0%) !important;\n    color: #fff !important;\n    opacity: 0;\n    transition: all 0.3s ease-in-out;\n    text-align: center;\n}\n\n.why-choose-section p.card-description.text-white.position-absolute.top-50.start-50.translate-middle-x.text-center.belief-description {\n    font-size: 14px;\n    margin: -18%;\n    margin-left: -1%;\n    text-align: center;\n    background: linear-gradient(to bottom, #fff);\n}\n\n/* Media Queries */\n@media (max-width: 1400px) {\n    .card-title-vmg {\n        margin-bottom: var(--bs-card-title-spacer-y);\n        color: var(--bs-card-title-color);\n        overflow-y: hidden !important;\n    }\n}\n\n@media (max-width: 1200px) {\n    .why-choose-section .why-we p {\n        width: 100%;\n        top: 795px;\n        left: 80px;\n        gap: 0px;\n        font-family: 'Poppins', sans-serif;\n        font-size: 21px;\n        font-weight: 400;\n        line-height: 34px;\n        text-align: justified;\n        text-underline-position: from-font;\n        text-decoration-skip-ink: none;\n        text-align: left;\n        color: rgb(103, 103, 103);\n    }\n\n    .card-title-vmg {\n        margin-bottom: var(--bs-card-title-spacer-y);\n        color: var(--bs-card-title-color);\n        overflow-y: hidden !important;\n    }\n\n    .why-choose-section p.card-description.text-white.position-absolute.top-50.start-50.translate-middle-x.text-center.belief-description {\n        font-size: 12px;\n        margin: -5%;\n    }\n}\n\n@media (max-width: 2560px) {\n    .text-success {\n        --bs-text-opacity: 1;\n        color: rgba(var(--bs-success-rgb), var(--bs-text-opacity)) !important;\n        overflow-y: hidden !important;\n    }\n\n    .text-start {\n        text-align: left !important;\n        overflow-y: hidden !important;\n    }\n}\n\n@media (max-width: 992px) {\n    .why-choose-section p.card-description.text-white.position-absolute.top-50.start-50.translate-middle-x.text-center.belief-description {\n        font-size: 8.5px;\n        margin: -7%;\n    }\n\n    .why-choose-section p.card-description.text-white.position-absolute.top-50.start-50.translate-middle-x.text-center.belief-description {\n        font-size: 14px;\n        margin: -24%;\n        width: 90%;\n        margin-left: 1%;\n        background: linear-gradient(to bottom, #fff);\n    }\n}\n\n@media (max-width: 768px) {\n    .card-body {\n        flex: 1 1 auto;\n        color: var(--bs-card-color);\n    }\n\n    h5.card-title-vmg.text-white.position-absolute.top-0.start-50.translate-middle-x.text-center.mt-3 {\n        font-size: 14px;\n    }\n\n    .why-choose-section p.card-description.text-white.position-absolute.top-50.start-50.translate-middle-x.text-center.belief-description {\n        font-size: 13px;\n        margin: -25%;\n        line-height: 1.5rem;\n        margin-left: 1%;\n        background: linear-gradient(to bottom, #fff);\n    }\n}\n\n@media (max-width: 576px) {\n    .card-img-top {\n        object-fit: cover;\n        width: 85%;\n        margin-left: 7%;\n    }\n\n    .row.d-flex.justify-content-around {\n        flex-direction: row;\n        width: 90%;\n        margin: auto;\n    }\n\n    .why-choose-section p.card-description.text-white.position-absolute.top-50.start-50.translate-middle-x.text-center.belief-description {\n        font-size: 25.5px;\n        margin: -30%;\n        margin-left: 2%;\n    }\n\n    .why-choose-section p.card-description.text-white.position-absolute.top-50.start-50.translate-middle-x.text-center.belief-description {\n        font-size: 10px;\n        margin: -25%;\n        width: 90%;\n        margin-left: 1%;\n        background: linear-gradient(to bottom, #fff);\n    }\n}\n\n@media (max-width: 768px) {\n    .row.d-flex.justify-content-around {\n        flex-direction: row;\n    }\n\n    .why-choose-section p.card-description.text-white.position-absolute.top-50.start-50.translate-middle-x.text-center.belief-description {\n        font-size: 10px;\n        margin: -19%;\n        margin-left: 1%;\n    }\n}\n\n@media (max-width: 1024px) {\n    .why-choose-section p.card-description.text-white.position-absolute.top-50.start-50.translate-middle-x.text-center.belief-description {\n        font-size: 10px;\n        margin: -19%;\n        margin-left: 1%;\n    }\n}\n\n@media (max-width: 415px) {\n    .my-5 {\n        margin-top: 8rem !important;\n        margin-bottom: 3rem !important;\n    }\n\n    .why-choose-section p.card-description.text-white.position-absolute.top-50.start-50.translate-middle-x.text-center.belief-description {\n        font-size: 16px;\n        margin: -23%;\n        line-height: 1.5rem;\n        margin-left: 1%;\n        padding: 6px;\n        background: linear-gradient(to bottom, #fff);\n    }\n}\n\n@media (max-width: 375px) {}\n\n/* General container styles */\n.container-Path-to-Excellence {\n    padding: 20px;\n    width: 100%;\n    background-color: rgba(249, 247, 237, 1);\n    padding-bottom: 80px;\n}\n\n.container-Path-to-Excellence .heading {\n    text-align: left;\n    margin-bottom: 20px;\n}\n\n.pathexcellence {\n    width: 1247px !important;\n    height: 69px !important;\n    font-size: 24px !important;\n    word-spacing: 4px !important;\n    font-weight: 400 !important;\n    margin-left: 6% !important;\n}\n\n.heading-text {\n    font-size: 32px;\n    font-weight: 500;\n    margin-left: 8%;\n}\n\n.container-Path-to-Excellence .heading .heading-text {\n    margin-left: 10%;\n    width: 100%;\n    height: 100%;\n    font-family: \"Poppins\", sans-serif;\n    font-size: 25px;\n    font-weight: 500;\n    line-height: 48px;\n    text-align: left;\n    text-underline-position: from-font;\n    text-decoration-skip-ink: none;\n    color: rgba(107, 142, 118, 1);\n}\n\n.container-Path-to-Excellence .heading p {\n    width: 100%;\n    margin-left: 8% !important;\n    font-family: \"Poppins\", sans-serif;\n    font-size: 20px;\n    font-weight: 400;\n    line-height: 34px;\n    padding-left: 2%;\n    text-align: justify;\n    text-underline-position: from-font;\n    text-decoration-skip-ink: none;\n    color: rgba(103, 103, 103, 1);\n}\n\n/* Design images container */\n.container-Path-to-Excellence .design-images {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-evenly;\n    margin-left: 133px;\n    padding-right: 93px;\n}\n\n.container-Path-to-Excellence .design-images .arrow-img {\n    width: 23.26px;\n    height: 53.14px;\n    border-radius: 8px;\n    transition: transform 0.3s ease;\n    margin-top: 32px;\n}\n\n.container-Path-to-Excellence .design-images .image-row .main-img-container {\n    position: relative;\n    text-align: center;\n}\n\n.container-Path-to-Excellence .design-images .image-row .main-img {\n    width: 119.15px;\n    border-radius: 8px;\n    transition: transform 0.3s ease;\n    display: block;\n    margin: 0 auto;\n}\n\n.container-Path-to-Excellence .design-images .image-row .signup-img {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    width: 33.75px;\n    height: 45px;\n}\n\n.container-Path-to-Excellence .design-images .text-title {\n    font-weight: 500;\n    font-family: \"Poppins\", sans-serif;\n    font-size: 14px;\n    color: rgba(103, 103, 103, 1);\n    text-align: center;\n    width: 68px;\n}\n\n.container-Path-to-Excellence .design-images-row {\n    display: flex;\n    margin-bottom: 20px;\n    width: 100%;\n    padding: 2px;\n    align-content: center;\n    flex-direction: row;\n}\n\n@media (max-width: 768px) {\n    .container-Path-to-Excellence .design-images {\n        flex-direction: column;\n        align-items: center;\n        gap: 20px;\n    }\n}\n\n/* Media queries */\n@media (max-width: 1024px) {\n    .container-Path-to-Excellence .design-images {\n        flex-direction: row; \n        flex-wrap: wrap;\n        gap: 30px; /* Adjust spacing for smaller screens */\n    }\n    \n    .container-Path-to-Excellence .design-images .text-title {\n        font-size: 18px; /* Slightly smaller for responsiveness */\n    }\n}\n\n@media (max-width: 2560px) {\n    .container-Path-to-Excellence .design-images .text-title {\n        font-size: 20px;\n        font-weight: 500;\n        margin-top: 20px;\n        width: 113px !important;\n    }\n}\n\n@media (max-width: 480px) {\n    .container-Path-to-Excellence {\n        padding: 20px;\n        width: 100%;\n        max-width: 1258px;\n        height: auto;\n        margin: 0 auto;\n        background-color: rgb(249, 247, 237);\n    }\n\n    .star-rating {\n        width: 100%;\n        height: 25px;\n        display: flex;\n        justify-content: center;\n        margin-top: 7rem;\n    }\n\n    .container-Path-to-Excellence .heading p {\n        font-size: 16px;\n        line-height: 25px;\n        margin-left: 3%;\n    }\n\n    .container-Path-to-Excellence .design-images .image-row {\n        justify-content: center;\n        align-items: center;\n        margin-bottom: 20px;\n    }\n\n    .why-choose-section p {\n        font-size: 18px;\n        line-height: 31px;\n        text-align: center;\n        margin-top: 5%;\n    }\n\n    .why-choose-section p.card-description.text-white.position-absolute.top-50.start-50.translate-middle-x.text-center.belief-description {\n        font-size: 16px;\n        margin-top: -5% !important;\n        margin: -22%;\n        margin-left: -2%;\n    }\n\n    .custom-footer .footer-about .contact-info,\n    .custom-footer .footer-links .contact-info,\n    .custom-footer .footer-legal .contact-info {\n        flex-wrap: wrap;\n        margin-top: 2%;\n        gap: 15px;\n        align-items: center;\n        /* display: flex\n; */\n    }\n\n}\n\n\n\n\n@media (max-width: 576px) {\n    .container-Path-to-Excellence {\n        padding: 20px;\n        width: 100%;\n        height: auto;\n        margin: 0 auto;\n        background-color: rgb(249, 247, 237);\n    }\n\n    .container-Path-to-Excellence .design-images .image-row {\n        justify-content: center;\n        align-items: center;\n        margin-bottom: 20px;\n    }\n\n    .why-choose-section h2 {\n        font-size: 32px;\n        line-height: 48px;\n        margin-bottom: 5%;\n    }\n\n    .why-choose-section p {\n        font-size: 21px;\n        line-height: 34px;\n        text-align: center;\n    }\n\n    .d-flex {\n        display: flex !important;\n        flex-direction: column;\n        align-items: center;\n    }\n\n    .container-Path-to-Excellence .design-images {\n        justify-content: center;\n    }\n}\n\n@media (max-width: 768px) {\n    .container-Path-to-Excellence {\n        padding: 20px;\n        width: 100%;\n        height: auto;\n        margin: 0 auto;\n        background-color: rgb(249, 247, 237);\n    }\n\n    .container-Path-to-Excellence .design-images .image-row {\n        justify-content: center;\n        align-items: center;\n        margin-bottom: 5px;\n    }\n\n    .container-Path-to-Excellence .design-images .text-title {\n        font-size: 14px;\n        margin: auto;\n        margin-left: 48%;\n    }\n}\n\n@media (max-width: 992px) {\n    .container-Path-to-Excellence .design-images .text-title {\n        font-size: 16px;\n        width: 100%;\n        margin: 0 auto;\n    }\n}\n\n\n/* notificationspage */\n\n/* kanj */\n\n/* Actions Container - Flexbox for proper alignment */\n.actions-container {\n    display: flex;\n    justify-content: space-between;\n    /* Filters on the left, Select button on the right */\n    align-items: center;\n    margin-top: 10px;\n    padding: 10px 0;\n}\n\n.no-notifications {\n    padding: 0 21px;\n}\n\n/* Select Button */\n.select-button {\n    /* background: #6b6b6b;\n    color: white;\n    padding: 8px 12px;\n    border-radius: 5px;\n    border: none;\n    cursor: pointer;\n    transition: 0.3s ease; */\n    padding: 6px 12px;\n    border-radius: 50px;\n    border: 1px solid #ddd;\n    background: none;\n    cursor: pointer;\n    transition: 0.3s ease;\n}\n\n.select-button:hover {\n    /* background: #4f4f4f; */\n    background: #6b6b6b;\n    color: white;\n}\n\n/* Selection Bar */\n.selection-bar {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    background: #f5f5f5;\n    padding: 8px;\n    border-radius: 5px;\n    margin: 10px 0;\n}\n\n.checkbox-container {\n    display: flex;\n    align-items: center;\n    gap: 5px;\n}\n\n/* Delete Button */\n.delete-button {\n    background: #ff4d4d;\n    color: white;\n    padding: 8px 12px;\n    border: none;\n    border-radius: 6px;\n    cursor: pointer;\n    font-size: 14px;\n    display: flex;\n    align-items: center;\n    gap: 5px;\n}\n\n.delete-button:hover {\n    background: #cc0000;\n}\n\n#squarecheckbox {\n    width: 18px;\n    /* Size */\n    height: 18px;\n    appearance: none;\n    /* Remove default styles */\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    background-color: white;\n    border: 2px solid #333;\n    /* Border color */\n    border-radius: 2px;\n    /* Change to 0px for perfect square */\n    cursor: pointer;\n    display: inline-block;\n    position: relative;\n    outline: none;\n    /* Remove focus outline */\n}\n\n#squarecheckbox:checked {\n    background-color: #6b8e76;\n    /* border-color: #007bff; */\n}\n\n\n/* Notifications List with scrollbar*/\n.notifications-list {\n    max-height: 380px;\n    /* Set a fixed height */\n    overflow-y: auto;\n    /* Enables vertical scrolling */\n    scrollbar-width: thin;\n    /* Firefox: makes the scrollbar thinner */\n    scrollbar-color: #888 #f1f1f1;\n    /* Scrollbar color */\n}\n\n/* For Webkit Browsers (Chrome, Edge, Safari) */\n.notifications-list::-webkit-scrollbar {\n    width: 6px;\n    /* Scrollbar width */\n}\n\n.notifications-list::-webkit-scrollbar-thumb {\n    background: #888;\n    /* Scrollbar thumb color */\n    border-radius: 4px;\n}\n\n.notifications-list::-webkit-scrollbar-thumb:hover {\n    background: #555;\n    /* Darker on hover */\n}\n\n/* kanj */\n/* .notifications-container {\n    width: 100%;\n    max-width: 800px;\n    background: white;\n    border-radius: 8px;\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n    margin: 20px auto;\n} */\n\n.notifications-header {\n    padding: 20px;\n    border-bottom: 1px solid #eee;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.notifications-header h2 {\n    margin: 0;\n    font-size: 24px;\n    font-weight: 600;\n    color: rgba(107, 71, 80, 1);\n\n}\n\n.close-button {\n    background: none;\n    border: none;\n    font-size: 1.5rem;\n    cursor: pointer;\n    padding: 0 8px;\n    color: #666;\n}\n\n.notifications-filters {\n    padding: 10px 20px;\n    /* border-bottom: 1px solid #eee; */\n    display: flex;\n    gap: 10px;\n}\n\n.filter-btn {\n    background: none;\n    border: 1px solid #ddd;\n    padding: 5px 15px;\n    border-radius: 20px;\n    cursor: pointer;\n    font-size: 15px;\n    font-weight: 500;\n    transition: all 0.2s;\n    color: rgba(103, 103, 103, 1);\n\n\n}\n\n.filter-btn.active {\n    background: rgba(103, 103, 103, 1);\n    border-color: #ccc;\n    color: rgba(255, 255, 255, 1);\n\n\n}\n\n/* .notifications-list {\n    max-height: 500px;\n    overflow-y: auto;\n    background-color: rgba(245, 242, 231, 0.35);\n} */\n\n.notification-item {\n    padding: 15px 20px;\n    display: flex;\n    align-items: center;\n    gap: 15px;\n    border-bottom: 1px solid #eee;\n    transition: background-color 0.2s;\n    margin-bottom: 10px;\n    border-bottom: 1px solid #eee;\n    transition: background-color 0.2s;\n    background-color: rgba(245, 242, 231, 0.35);\n    margin-bottom: 8px;\n    /* Adds gap between each notification */\n    border-radius: 5px;\n    /* Optional: Rounds corners for a better look */\n}\n\n.notification-item:hover {\n    background-color: #f8f8f8;\n}\n\n.notification-icon {\n    width: 40px;\n    height: 40px;\n    border-radius: 50%;\n    background: rgba(107, 142, 118, 1) !important;\n    color: white;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 1.2rem;\n}\n\n.notification-content {\n    flex: 1;\n}\n\n.notification-content p {\n    margin: 0;\n    font-size: 16px;\n    color: rgba(0, 0, 0, 0.6);\n    font-weight: 500;\n}\n\n.notification-time {\n    font-size: 14px;\n    font-weight: 300;\n    color: var(--grey-200, rgba(188, 182, 183, 1));\n    display: flex;\n    justify-content: end;\n    font-family: 'Poppins', sans-serif;\n    /* Apply Poppins */\n}\n\n.more-options {\n    background: none;\n    border: none;\n    color: #666;\n    cursor: pointer;\n    padding: 0 8px;\n    font-size: 1.2rem;\n    visibility: hidden;\n}\n\n.notification-item:hover .more-options {\n    visibility: visible;\n}\n\n/* Icon types */\n.notification-icon.payment {\n    background: #4caf50;\n}\n\n.notification-icon.campaign {\n    background: #2196f3;\n}\n\n.notification-icon.approval {\n    background: #9c27b0;\n}\n\n.notification-icon.view {\n    background: #ff9800;\n}\n\n/* instaaccordian */\n.influencer-stats .stat-item {\n    background-color: #fff;\n}\n\n@font-face {\n    font-family: 'Gilroy-Medium';\n    src: url('../Img/Gilroy-Medium.ttf') format('woff2'),\n        url('../Img/Gilroy-Medium.ttf') format('woff');\n    font-weight: normal;\n    font-style: normal;\n}\n\n\n.interaction-stats {\n    color: rgba(107, 71, 80, 1);\n    font-family: 'Gilroy-Medium', sans-serif;\n    font-weight: 400;\n    font-size: 19px;\n    line-height: 21.83px;\n    letter-spacing: 2%;\n    text-align: center;\n\n\n}\n\n.interaction-stats {\n    display: flex;\n    gap: 20px;\n    /* Adjust spacing as needed */\n}\n\n.interaction-stats p {\n    text-align: center;\n}\n\n.post-interaction h3 {\n    text-align: center;\n}\n\n.MuiGrid-root.MuiGrid-container.MuiGrid-spacing-xs-2.css-919fip-MuiGrid-root .logo {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n    gap: 0.5rem;\n    margin: 0 2rem 0 2rem;\n}\n\n.MuiGrid-root.MuiGrid-container.MuiGrid-spacing-xs-2.css-919fip-MuiGrid-root .logo img {\n    height: 2.5rem;\n    margin: 0;\n}\n\n.MuiGrid-root.MuiGrid-container.MuiGrid-spacing-xs-2.css-919fip-MuiGrid-root .logo p {\n    color: var(--New-form-color, #6b4750);\n    text-align: center;\n    font-family: 'Poppins', sans-serif;\n    font-size: 1.2rem;\n    font-style: normal;\n    font-weight: 500;\n    line-height: normal;\n    letter-spacing: 1px;\n    margin: 0;\n}\n\n.MuiGrid-root.MuiGrid-container.MuiGrid-spacing-xs-2.css-919fip-MuiGrid-root .post-interaction {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    margin: 0;\n}\n\n.MuiGrid-root.MuiGrid-container.MuiGrid-spacing-xs-2.css-919fip-MuiGrid-root .post-interaction h3 {\n    color: var(--Dark, #d72756);\n    font-family: 'Poppins', sans-serif;\n    font-size: 1.2rem;\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n    text-align: center;\n}\n\n.MuiGrid-root.MuiGrid-container.MuiGrid-spacing-xs-2.css-919fip-MuiGrid-root .post-interaction .interaction-stats {\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    gap: 2rem;\n    margin: 0 3rem;\n}\n\n.MuiGrid-root.MuiGrid-container.MuiGrid-spacing-xs-2.css-919fip-MuiGrid-root .post-interaction .interaction-stats .interaction-stat-field {\n    display: flex;\n    flex-direction: column;\n}\n\n.MuiGrid-root.MuiGrid-container.MuiGrid-spacing-xs-2.css-919fip-MuiGrid-root .post-interaction .interaction-stats .interaction-stat-field p {\n    color: var(--New-form-color, #6b4750);\n    text-align: center;\n    margin: 0.2rem;\n    font-family: 'Poppins', sans-serif;\n    font-size: 1.5rem;\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n    letter-spacing: 0.64px;\n}\n\n.MuiGrid-root.MuiGrid-container.MuiGrid-spacing-xs-2.css-919fip-MuiGrid-root .post-interaction .interaction-stats .interaction-stat-field span {\n    color: var(--New-form-color, #6b4750);\n    text-align: center;\n    font-family: 'Poppins', sans-serif;\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n    letter-spacing: 0.36px;\n    display: inline;\n}\n\n.wrapper-div .arrow-div {\n    text-align: center;\n}\n\n.MuiPaper-root.MuiPaper-elevation.MuiPaper-rounded.MuiPaper-elevation1.MuiAccordion-root.MuiAccordion-rounded.MuiAccordion-gutters.css-1086bdv-MuiPaper-root-MuiAccordion-root {\n    background: transparent;\n    box-shadow: none;\n}\n\n.parent-box {\n    margin: 0;\n    padding: 0;\n}\n\n.parent-box .insta-stats {\n    margin: 0;\n    background-color: #fff;\n    box-shadow: #d72756;\n}\n\n.parent-box .insta-stats h3 {\n    color: var(--NP, var(--primary-300, #f45c7b));\n    font-family: 'Poppins', sans-serif;\n    font-size: 1.5rem;\n    font-style: normal;\n    font-weight: 500;\n    line-height: normal;\n    margin: 0;\n    width: fit-content;\n}\n\n.parent-box .insta-stats .group-stats {\n    display: flex;\n    justify-content: space-evenly;\n    margin: 0;\n    box-sizing: border-box;\n}\n\n.parent-box .insta-stats .group-stats .city-stats {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    margin: 0;\n}\n\n.parent-box .insta-stats .group-stats .city-stats p {\n    color: var(--New-form-color, #6b4750);\n    text-align: center;\n    font-family: 'Poppins', sans-serif;\n    font-style: normal;\n    font-weight: 500;\n    line-height: normal;\n    font-size: 1.2rem;\n    margin: 0;\n}\n\n.parent-box .insta-stats .group-stats .city-stats p span {\n    opacity: 0.7;\n}\n\n.parent-box .insta-stats .group-stats .city-stats .progress-bars {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    gap: 0.4rem;\n    margin: 1rem 0 0 0;\n    padding: 0;\n    width: 100%;\n}\n\n.parent-box .insta-stats .group-stats .city-stats .progress-bars .single-stats-unit {\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-end;\n    align-items: center;\n    gap: 0.3rem;\n    width: 100%;\n}\n\n.parent-box .insta-stats .group-stats .city-stats .progress-bars .single-stats-unit p {\n    color: var(--New-form-color, #6b4750);\n    text-align: right;\n    font-family: 'Poppins', sans-serif;\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n    font-size: 0.9rem;\n    margin: 0;\n}\n\n.parent-box .account-activity h3,\n.parent-box .subscribers-chart h3 {\n    color: var(--primary-300, #f45c7b);\n    font-family: 'Poppins', sans-serif;\n    font-size: 1.2rem;\n    font-style: normal;\n    font-weight: 500;\n    line-height: normal;\n    letter-spacing: 0.4px;\n}\n\n.parent-box .account-activity h3 span {\n    color: var(--primary-300, #e4688a);\n    font-family: 'Poppins', sans-serif;\n    font-size: 0.92rem;\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n    letter-spacing: 0.3px;\n}\n\n/* Legends Section */\n.legends {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 1rem;\n    font-size: 0.9rem;\n    flex-basis: 100%;\n    flex-wrap: wrap;\n    margin-top: 1rem;\n}\n\n.legends span {\n    position: relative;\n    padding-left: 1.5rem;\n}\n\n.legends span::before {\n    position: absolute;\n    top: 0.4rem;\n    left: 0;\n    content: \"\";\n    width: 0.8rem;\n    aspect-ratio: 1;\n    border-radius: 50%;\n}\n\n.legends span:nth-child(1)::before {\n    background-color: #baeadc;\n}\n\n.legends span:nth-child(2)::before {\n    background-color: #f8bed4;\n}\n\n.legends span:nth-child(3)::before {\n    background-color: #b9f3fc;\n}\n\n@media (min-width: 1400px) and (max-width: 1500px) {\n    .MuiGrid-root.MuiGrid-item.MuiGrid-grid-xs-12.MuiGrid-grid-sm-3.MuiGrid-grid-md-3.css-zbaamk-MuiGrid-root .post-interaction .interaction-stats .interaction-stat-field p {\n        font-size: 20px;\n    }\n}\n\n@media screen and (max-width: 1028px) {\n    .MuiGrid-root.MuiGrid-container.MuiGrid-spacing-xs-2.css-919fip-MuiGrid-root .post-interaction .interaction-stats {\n        margin: 0;\n    }\n\n    .influencer-stats .wrapper-div .post-interaction .interaction-stats {\n        display: flex;\n        justify-content: center;\n        gap: 2rem;\n        flex-wrap: wrap;\n        flex-direction: column;\n    }\n\n    .wrapper-div {\n        padding: 1rem;\n        background: #fff;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        margin-right: 34.9rem;\n        margin-left: 36.9rem;\n    }\n\n    .parent-box .insta-stats .group-stats .city-stats .progress-bars .single-stats-unit {\n        display: flex;\n        flex-direction: column;\n        justify-content: flex-end;\n        align-items: center;\n        gap: 0.3rem;\n        width: 100%;\n    }\n}\n\n\n/* youtubraccordian */\n.css-1f1pi2l-MuiButtonBase-root-MuiAccordionSummary-root:not(.Mui-disabled) {\n    cursor: pointer;\n    width: 100%;\n    background-color: white;\n}\n\n.MuiGrid-root.MuiGrid-container.MuiGrid-spacing-xs-2.css-919fip-MuiGrid-root .youtube-logo {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n    gap: 0.5rem;\n    margin: 0 2.5rem 0 2.5rem;\n}\n\n.MuiGrid-root.MuiGrid-container.MuiGrid-spacing-xs-2.css-919fip-MuiGrid-root .youtube-logo .youtube-image {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background-color: red;\n    height: 3rem;\n    width: 3rem;\n    border-radius: 50%;\n}\n\n.MuiGrid-root.MuiGrid-container.MuiGrid-spacing-xs-2.css-919fip-MuiGrid-root .youtube-logo .youtube-image img {\n    height: 1.5rem;\n    margin: 0;\n}\n\n.MuiGrid-root.MuiGrid-container.MuiGrid-spacing-xs-2.css-919fip-MuiGrid-root .youtube-logo p {\n    color: var(--New-form-color, #6b4750);\n    text-align: center;\n    font-family: 'Poppins', sans-serif;\n    font-size: 1.2rem;\n    font-style: normal;\n    font-weight: 500;\n    line-height: normal;\n    letter-spacing: 1px;\n    margin: 0;\n}\n\n.MuiGrid-root.MuiGrid-container.MuiGrid-spacing-xs-2.css-919fip-MuiGrid-root .arrow-div {\n    margin: 0 3rem 0 3rem;\n    padding: 2rem 0 2rem 0;\n}\n\n.MuiPaper-root.MuiPaper-elevation.MuiPaper-rounded.MuiPaper-elevation1.MuiAccordion-root.MuiAccordion-rounded.MuiAccordion-gutters.css-1086bdv-MuiPaper-root-MuiAccordion-root {\n    background: #fff;\n    box-shadow: none;\n    padding: 2rem;\n    position: static;\n    border-radius: 8px;\n}\n\n@media screen and (max-width: 768px) {\n    .MuiPaper-root.MuiPaper-elevation.MuiPaper-rounded.MuiPaper-elevation1.MuiAccordion-root.MuiAccordion-rounded.MuiAccordion-gutters.css-1086bdv-MuiPaper-root-MuiAccordion-root {\n        background: #fff;\n        box-shadow: none;\n        padding: 2rem;\n        position: static;\n        padding-right: 0px;\n    }\n}\n\n.interaction-stats {\n    display: flex;\n}\n\n.css-cmahm4-MuiGrid-root>.MuiGrid-item {\n    display: flex;\n    justify-content: space-around;\n    align-items: center;\n}\n\n/* my profile */\nbutton.btn.profile-clear-btn {\n    color: rgba(103, 103, 103, 1);\n    text-decoration: underline;\n    font-family: 'Poppins', sans-serif;\n    font-weight: 500;\n    font-size: 16px;\n    line-height: 21.12px;\n    text-align: center;\n    border: none;\n}\n\nbutton.profile.btn.btn-success {\n    background-color: rgba(107, 142, 118, 1);\n\n}\n\nbutton.profile.btn.btn-outline-success.mx-2:hover {\n    background-color: rgba(107, 142, 118, 1);\n    color: white;\n\n}\n\n[type=button]:not(:disabled),\n[type=reset]:not(:disabled),\n[type=submit]:not(:disabled),\nbutton:not(:disabled) {\n    cursor: pointer;\n    /* height: 60px; */\n    /* width: 107px; */\n    border: 2px solid rgba(107, 142, 118, 1);\n}\n\n\n\n\n/* Remove default blue background from dropdown items */\n.dropdown-menu .dropdown-item {\n    background-color: transparent !important;\n    color: #000;\n    /* Change text color if needed */\n}\n\n/* Remove background color on hover */\n.dropdown-menu .dropdown-item:hover,\n.dropdown-menu .dropdown-item:focus {\n    background-color: rgba(0, 0, 0, 0.05) !important;\n    /* Slight highlight on hover */\n}\n\n.input-container {\n    position: relative;\n    display: flex;\n    align-items: center;\n}\n\n.social-icon {\n    position: absolute;\n    left: 10px;\n    width: 20px;\n    height: 20px;\n}\n\n.social-input {\n    width: 100%;\n    padding-left: 40px;\n    /* Space for icon */\n    height: 40px;\n    border: 1px solid #ccc;\n    border-radius: 5px;\n}\n\n.attached-text {\n    position: absolute;\n    right: 10px;\n    font-size: 12px;\n    color: green;\n    font-weight: bold;\n}\n\n/* Influencer Page */\n.influencer-container .influencer-hero-section {\n    background: rgba(0, 0, 0, 0.5) url(\"../Img/Hero\\ Section\\ Influencer.png\") center center;\n    background-size: cover;\n    height: 400px;\n    color: white;\n}\n\nh2.text-3xl.font-medium.case-studies.mb-8 {\n    color: rgba(107, 142, 118, 1) !important;\n    margin-bottom: 1% !important;\n    margin-top: 8% !important;\n}\n\nh2.text-success.market-heading.fs-4.fw-medium.mb-4 {\n    color: rgba(107, 142, 118, 1) !important;\n    font-weight: 600;\n    font-family: 'Poppins', sans-serif;\n    font-size: 32px;\n}\n\nh3.heading-title.text-success.fw-medium.mb-2 {\n    color: rgba(107, 142, 118, 1) !important;\n    font-family: 'Poppins', sans-serif;\n    font-size: 24px;\n    font-weight: 600;\n}\n\np.text-muted.small.card-content {\n    color: rgba(103, 103, 103, 1) !important;\n    font-weight: 400;\n    font-family: 'Poppins', sans-serif;\n    font-size: 16px;\n\n}\n\n.slick-slide>div {\n    padding: 0 10px;\n}\n\n.text-center .influencer-hero {\n    margin-top: 18% !important;\n\n}\n\n.card {\n    height: 200px !important;\n    /* Adjust this value to your desired height */\n    display: flex !important;\n    flex-direction: column !important;\n}\n\n.card-content {\n    flex-grow: 1;\n    /* Ensures content inside the card stretches to fill available space */\n}\n\n.slick-slider .slick-disabled {\n    opacity: 0;\n    pointer-events: none;\n}\n\n.mb-3.d-flex.user-text {\n    color: rgba(107, 142, 118, 1) !important;\n    border-bottom: 0.5px solid rgba(103, 103, 103, 1)\n}\n\n.text-user.num.fs-3 {\n    font-weight: 600;\n    font-family: 'Poppins', sans-serif;\n    font-size: 40px !important;\n}\n\n.text-user.word {\n    font-family: 'Poppins', sans-serif;\n    font-weight: 400;\n    font-size: 16px;\n    padding-top: 15px;\n    margin-left: 30px;\n}\n\n.card-case.p-4.h-100 {\n    background-color: rgba(245, 242, 231, 1);\n    border-radius: 10px;\n\n}\n\n.date-case {\n    color: rgba(103, 103, 103, 1);\n    font-family: 'Poppins', sans-serif;\n    font-weight: 400;\n    font-size: 20px;\n}\n\nh3.fs-4.title-case {\n    color: rgba(107, 142, 118, 1);\n    font-weight: 600;\n    font-family: 'Poppins', sans-serif;\n    font-size: 28px !important;\n}\n\np.description-case {\n    color: rgba(103, 103, 103, 1);\n    font-weight: 400;\n    font-family: 'Poppins', sans-serif;\n    font-size: 20px;\n}\n\nbutton.read-more-btn {\n    background-color: rgba(107, 142, 118, 1);\n    color: white;\n    border-radius: 5px;\n    padding: 5px;\n    width: 150px;\n}\n\n.about-influencer-image {}\n\n/* BrandPage */\n\n.main-content-brand {\n    background-color: rgba(245, 242, 231, 1);\n}\n\n.main-content-brand .heading-brand-benifit {\n    text-align: start;\n    color: rgba(107, 142, 118, 1);\n    font-family: \"Poppins\", sans-serif;\n    font-size: 32px;\n    font-weight: 500;\n    line-height: 48px;\n    text-align: left;\n    margin-bottom: 2%;\n}\n\n.main-content-brand .heading-brand-benifit .titles-brand {\n    font-size: 24px;\n    font-weight: 600;\n    margin-left: -69px;\n}\n\n.main-content-brand .all-cards .card-one-brand {\n    position: relative;\n    width: 100%;\n    padding: 26px;\n    padding-left: 1rem;\n    position: relative;\n\n}\n\n.main-content-brand .all-cards .card-one-brand .card {\n    background-color: #fff;\n    width: 387px;\n    height: 159px !important;\n    padding: 10px;\n\n}\n\n.main-content-brand .all-cards .card-one-brand .card .card-image-brand {\n    position: absolute;\n    top: 51%;\n    left: -55px;\n    transform: translateY(-50%);\n    width: 130px;\n    height: 124px;\n    margin: 0;\n    bottom: 50%;\n}\n\n.main-content-brand .all-cards .card-one-brand .card .card-image-brand img {\n    width: 119px;\n    object-fit: none;\n    background: #6b8e76;\n    border-radius: 5rem;\n    border: 9px solid #f5f2e7;\n    height: 119px;\n}\n\n.main-content-brand .all-cards .card-one-brand .card .card-content-brand {\n    margin-left: 100px;\n}\n\n.main-content-brand .all-cards .card-one-brand .card .card-content-brand .brand-text-container .brand-card-heading {\n    font-family: \"Poppins\", sans-serif;\n    font-size: 24px;\n    margin-bottom: 12px;\n    margin-top: 10px;\n    font-weight: 600;\n    line-height: 27px;\n    text-align: left;\n    text-underline-position: from-font;\n    text-decoration-skip-ink: none;\n    color: rgba(107, 142, 118, 1);\n}\n\n.main-content-brand .all-cards .card-one-brand .card .card-content-brand .brand-text-container .brand-card-description {\n    font-family: \"Poppins\", sans-serif;\n    font-size: 16px;\n    font-weight: 400;\n    line-height: 22px;\n    text-align: left;\n    text-underline-position: from-font;\n    text-decoration-skip-ink: none;\n    color: rgba(103, 103, 103, 1);\n}\n\n/* SETTING PAGE CSS */\n\n.settings-page {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 20px;\n    padding: 40px 0;\n  }\n  \n  .settings-container {\n    width: 50%;\n    background-color: #ffffff;\n    padding: 20px;\n    border-radius: 10px;\n    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);\n  }\n  \n  .settings-title {\n    font-size: 18px;\n    font-weight: bold;\n    margin-bottom: 15px;\n  }\n  \n  .settings-list {\n    background-color: white;\n    border-radius: 10px;\n    overflow: hidden;\n  }\n  \n  .settings-item {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 12px 16px;\n    border-bottom: 1px solid #e0e0e0;\n    font-size: 16px;\n    cursor: pointer;\n  }\n  \n  .settings-item:last-child {\n    border-bottom: none;\n  }\n  \n  .settings-value {\n    display: flex;\n    align-items: center;\n    color: #7c7c7c;\n  }\n  \n  .arrow {\n    font-size: 18px;\n    font-weight: bold;\n    color: gray;\n  }\n  \n /* Modal Overlay */\n.modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: rgba(0, 0, 0, 0.4);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    backdrop-filter: blur(5px);\n  }\n  \n  /* Modal Box */\n  .modal-content-setting{\n    background: white !important;\n    width: 350px !important;\n    padding: 25px;\n    border-radius: 10px !important;\n    text-align: center;\n    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);\n    transition: all 0.3s ease-in-out;\n  }\n\n  \n  /* Modal Title */\n  .modal-title {\n    font-size: 18px;\n    font-weight: 600;\n    margin-bottom: 10px;\n  }\n  \n  /* Modal Message */\n  .modal-message {\n    font-size: 14px;\n    color: #555;\n    margin-bottom: 20px;\n  }\n  \n  /* Modal Buttons */\n  .modal-buttons {\n    display: flex;\n    justify-content: center;\n    gap: 10px;\n    padding-top: 25px;\n  }\n  \n  .modal-btn {\n    padding: 8px 15px;\n    border-radius: 5px;\n    font-size: 14px;\n    cursor: pointer;\n    border: none;\n    outline: none;\n    transition: 0.2s ease-in-out;\n  }\n  \n  .logout {\n    background-color: #5a7f62;\n    color: white;\n  }\n  \n  .logout:hover {\n    background-color: #4b6b52;\n  }\n  \n  .cancel {\n    background-color: white;\n    border: 1px solid #ccc;\n    color: black;\n  }\n  \n  .cancel:hover {\n    border-color: black;\n  }\n.text-muted{\n    margin-right: 10px !important;\n}\n.navbar-dull {\n    background-color:  rgba(203, 201, 201, 0.4) !important; \n    filter: brightness(70%);\n    transition: all 0.3s ease-in-out;\n}\n\n.navbar-dull * {  /* Applies blur to all text inside navbar */\n    filter: blur(3px); /* Adjust the blur strength */\n}\n.navbar-dull span,\n.navbar-dull a,\n.navbar-dull p {\n    filter: blur(3px); /* Blurs only text */\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
